import React, { Component, Fragment, lazy, Suspense } from "react";
import ReactDOM from "react-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import ReactToPrint from "react-to-print";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { injectIntl } from "react-intl";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import TableChairs from "../../../containers/dashboards/TableChairs";
import TemplateWarningCard from "../../../components/common/TemplateWarningCard";
import axios from "axios";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import { NotificationManager } from "../../../components/common/react-notifications";
import { ThemeColors } from "../../../helpers/ThemeColors";
import createSocket from "../../../helpers/createSocket";
import STATUS from "../../../constants/status";
import { connect } from "react-redux";
import {
  getDateWithFormat,
  IsRedirectFromAlert,
  NotificatioErrController,
  NotificatioSucController,
} from "../../../helpers/Utils";
import LogsHelper from "../../../helpers/Logs";
// import { isRorF, isR } from '../../../helpers/Roles';
import CompaniesRequired from "../../../containers/navs/CompaniesRequired";
import IntlMessages from "../../../helpers/IntlMessages";
import {
  AddCommaNumber,
  buildPrintPageStyle,
  buildSilentPrintHtml,
  getStoredPrintPaperWidthMm,
} from "../../../helpers/Utils";
import OrderAdjustmentModals from "../../../containers/pages/OrderAdjustmentModals";
import { GetProductsSelectDiscount } from "../../../helpers/Discount";
import FullModalAllOrders from "../../../containers/dashboards/FullModalAllOrders";
import ProductOrderModalMenu from "../../../containers/dashboards/ProductOrderModalMenu";
import ProvisionalInvoice from "../../../containers/dashboards/ProvisionalInvoice";
import ListOrders from "./ListOrders";
import FooterOrders from "./FooterOrders";
import ListOrderStatus from "./ListOrderStatus";
import ListPendingOrdersStatus from "../../../containers/dashboards/ListPendingOrdersStatus";
import { isRorF } from "../../../helpers/Roles";
import {
  updateSearchKeyword,
  submitSearchByEnter,
  setSearchContext,
} from "../../../redux/actions";
import BarcodeScanner from "../../../components/common/BarcodeScanner";
import OrderHistoryModal from "../../../containers/dashboards/OrderHistoryModal";
import WizardBasic from "../../../containers/dashboards/WizardBasic";
import KeyboardShortcutsModal from "../../../containers/dashboards/KeyboardShortcutsModal";
import ShippingAddressModal from "../../../containers/dashboards/ShippingAddressModal";
import ComponentToPrintNow from "../../../containers/pages/ComponentToPrintNow";
import ComponentToPrintForKitchen from "../../../containers/pages/ComponentToPrintForKitchen";
import {
  getEnabledOnlinePrintTypes,
  getOnlinePrintRetryDelay,
  ONLINE_PRINT_MAX_ATTEMPTS,
} from "../../../helpers/OnlinePrintQueue";
import {
  getOrCreateWebPrintTerminalId,
  getWebPrintDocumentType,
  getWebPrintMode,
} from "../../../helpers/WebPrintTerminal";
import {
  calculateOrderAdjustmentAmount,
  getFeeApplicationBase,
  getPostDiscountSubtotal,
} from "../../../helpers/OrderAdjustmentCalculations";
import { normalizeFeeOtherLabel } from "../../../helpers/FeeOtherLabel";

const AddProductModalWrapper = lazy(
  () => import("../../../containers/pages/product/AddProductModalWrapper"),
);
const colors = ThemeColors();

const isCurrentFloor = ({ current, get }) => current === get;

const isElectron = !!window.electronAPI;
const getStore = () => {
  const localDomain =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("vmass_store_domain") ||
        localStorage.getItem("domain")
      : "";
  if (localDomain) {
    return localDomain;
  }
  try {
    const userStr =
      typeof localStorage !== "undefined" ? localStorage.getItem("user") : null;
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user && user.domain) {
        return user.domain;
      }
    }
  } catch (e) {}

  if (isElectron || typeof window === "undefined") {
    return "";
  }
  const hostPart = window.location.host.split(".")[0];
  if (
    hostPart &&
    hostPart !== "localhost" &&
    !hostPart.startsWith("localhost:") &&
    hostPart !== "127" &&
    hostPart !== "app" &&
    hostPart !== "web" &&
    hostPart !== "admin"
  ) {
    return hostPart;
  }
  return "";
};

const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <div
    className="d-flex align-items-center cursor-pointer badge badge-outline-primary px-3 py-1"
    title="Thay đổi ngày đơn hàng"
    onClick={onClick}
    ref={ref}
    style={{
      minWidth: "165px",
      justifyContent: "center",
      paddingLeft: value ? "28px" : undefined,
      paddingRight: value ? "28px" : undefined,
    }}
  >
    <i className="simple-icon-clock mr-2" style={{ fontSize: "14px" }} />
    <span style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
      {value || "Hôm nay"}
    </span>
    <style>{`
      .react-datepicker__day--disabled {
        color: #d2d2d2 !important;
        background-color: transparent !important;
        cursor: not-allowed !important;
        opacity: 0.5;
      }
      .react-datepicker__close-icon {
        position: absolute !important;
        top: 50% !important;
        right: 8px !important;
        transform: translateY(-50%) !important;
        height: 20px !important;
        width: 20px !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        background: transparent !important;
        border: none !important;
        cursor: pointer !important;
        outline: none !important;
        z-index: 2 !important;
      }
      .react-datepicker__close-icon::after {
        content: "\\00d7" !important;
        font-family: inherit !important;
        font-size: 15px !important;
        font-weight: bold !important;
        line-height: 1 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 18px !important;
        height: 18px !important;
        border-radius: 50% !important;
        background-color: rgba(20, 83, 136, 0.12) !important;
        color: #145388 !important;
        padding: 0 !important;
        margin: 0 !important;
        position: static !important;
        transition: all 0.15s ease-in-out !important;
      }
      .react-datepicker__close-icon:hover::after {
        background-color: #dc3545 !important;
        color: #ffffff !important;
      }
    `}</style>
  </div>
));

class DefaultDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      license: false,
      USER_PARENT_ID: localStorage.getItem("b"),

      itemsTable: [],
      isLoadingItemsTable: true,
      selectedFloorTable: 100,
      floorsActiveId: [],
      itemsOrderStatus: {
        order: 0,
        totalOrder: 0,
        pending: 0,
        totalPendingPayment: 0,
        tablePendingPayment: 0,
        totalTableHasGuest: 0,
      },
      itemsPending: [],
      itemsDone: [],
      itemsRefund: [],

      itemsPendingBill: [],

      selectedItemsPending: [],
      selectedItemsDone: [],
      selectedItemsRefund: [],

      itemsRecentOrder: [],

      messagesData: [],
      messageDefaultValue: {
        selectedUser: {},
        props: null,
      },
      aboutProps: {
        message_item_id: 0,
        message_user_id: 0,
      },

      cashs: [
        { cash: 1000, quantity: 0 },
        { cash: 2000, quantity: 0 },
        { cash: 5000, quantity: 0 },
        { cash: 10000, quantity: 0 },
        { cash: 20000, quantity: 0 },
        { cash: 50000, quantity: 0 },
        { cash: 100000, quantity: 0 },
        { cash: 200000, quantity: 0 },
        { cash: 500000, quantity: 0 },
      ],
      cashsPay: [],
      isCustomPay: false,
      customCustomerPay: 0,
      customCustomerPayRaw: "",
      creditFullOrderWarningModalOpen: false,

      store: getStore(),
      orders: [],
      itemsChange: [],
      _itemsChange: [],
      orders_fr_server: [],
      ordersId: [],
      productChoose: [],

      customer_name: "",
      customer_phone: "",
      selectedCustomerId: null,
      suggestions: [],
      customerSuggestionField: "customer_phone",
      eInvoiceInfoModalOpen: false,
      eInvoiceBackdateWarningModalOpen: false,
      eInvoice_customer_name: "Bán cho người tiêu dùng",
      eInvoice_customer_phone: "",
      eInvoice_customer_tax_id: "",
      eInvoice_customer_address: "",
      eInvoice_customer_email: "",
      isLoadingCustomer: false,

      btnDropup: false,

      //invoices
      companyName: localStorage.getItem("companyName"),
      companyAddress: localStorage.getItem("companyAddress"),
      companyLogo: localStorage.getItem("companyLogo"),
      companyWebsite: localStorage.getItem("companyWebsite"),

      items: [],
      items_id: [],
      dataOrderNow: [],
      dataProvisionalInvoice: [],
      provisionalBillIds: [],
      deletedProvisionalItems: [],
      currentPin: null,
      currentPinPrint: null,
      dataOrderHistory: [],
      billDate: "",
      pin_print: "", // Mã hóa đơn theo format YYMMDDX (sẽ được generate khi load page)
      discount_form: {
        orders_id: [],
        user_id: "",
        note: "",
        value: "",
        type: "percent",
        saved: false,
        max: null,
        isManual: false,
      },
      is_open_modal_discount_tax_fee: false,
      active_order_adjustment_modal: "discount",
      is_open_modal_discount_tax_fee_nested: false,
      is_open_modal_discount: false,
      modalWizard: false,
      products_select_discount: [],

      modalProvisionalInvoice: false,
      modalOrderHistory: false,
      modalFullOrders: false,
      modalOrderOpen: false,
      modalKeyboardShortcuts: false,
      modalMobileOrderStatus: false,
      modalMobileReceiveOrder: false,
      fabMenuOpen: false,
      isShippingModalOpen: false,

      tax_fee: {
        orders_id: [],
        user_id: "",
        note: "",
        value: "",
        type: "percent",
        calculation: "added",
        saved: false,
        isManual: false,
      },
      is_open_modal_taxfee: false,
      products_select_taxfee: [],

      fee_other: {
        orders_id: [],
        user_id: "",
        label: "shipping",
        note: "",
        value: "",
        type: "percent",
        applyOn: "after_discount",
        saved: false,
        isManual: false,
      },
      is_open_modal_fee_other: false,
      products_select_fee_other: [],
      isChecked: false,
      refund_to_customer: 0,
      data_customer: [],
      customer_debt: "",
      customer_debt_limit: 0,
      debtWarningModalOpen: false,
      bypassDebtLimit: false,
      pendingPaymentAction: null,
      data_orders: [],
      info_table: "",
      data_stock: {},
      data_stock_in_order_component: {
        loading: true,
        data: null, // Hoặc [] tùy theo cấu trúc dữ liệu
      },
      switchChecked: {},

      menus: [],
      ordersFiltered: [],
      listsData: [],
      activeIndex: 99,
      categoryId: 0,
      search: "",
      store: getStore(),
      is_loading_data: true,
      showAddProductWarning: false,
      promotions: [],
      activePromotions: [],
      selected_promotions: [], // KM đã được chọn từ modal

      // Promotion states
      available_promotions: [],
      available_promotions_loading: false,

      width: this.getWidth(),

      // Barcode Scanner state
      isScannerOpen: false,

      // Payment & Shipping
      paymentMethod: "cash",
      // shippingCarrier: null, // Unified into shipping_provider below

      // Staff selection (persisted to localStorage)
      selectedStaff: localStorage.getItem("selectedStaff") || null,
      staffList: [],
      // Cashier account detection (child users who are not parent)
      isCashierAccount:
        localStorage.getItem("user_id") !== localStorage.getItem("b"),

      paymentMethod: "cash", // Default payment method
      customOrderDate: null,

      // Shipping integration state
      is_shipping: false,
      shipping_provider: null,
      shipping_fee: 0,
      receiver_address: "",
      receiver_province: null,
      receiver_district: null,
      receiver_ward: null,
      connected_providers: [],
      provinces: [],
      districts: [],
      wards: [],
      is_calculating_fee: false,
      shipping_receiver_name: "",
      shipping_receiver_phone: "",
      shipping_cod: false,
      shipping_cod_amount: 0,
      shipping_free: false,
      shipping_weight: 500,
      shipping_length: 20,
      shipping_width: 20,
      shipping_height: 10,
      shipping_note: "",
      shipping_required_note: "",

      // E-Invoice state
      eInvoiceEnabled: false,
      issueEInvoice: false,

      // Submit guard
      isSubmitting: false,

      // Shift session
      shift_required: false,
      is_shift_open: false,
      save_provisional_when_print: true,
      print_customer_provisional: true,
      print_customer_invoice: true,

      // Auto-print payload for new online pending orders
      autoPrintOnlineItems: [],
      autoPrintOnlineBillDate: "",
      autoPrintOnlineTimeStart: "",
      autoPrintOnlinePinPrint: "",
      autoPrintOnlineCustomerName: "",
      autoPrintOnlineCustomerPhone: "",
      autoPrintOnlineCustomerAddress: "",
      autoPrintOnlineDeliveryTime: "",
      autoPrintOnlineTableName: "",
      autoPrintOnlineJobKey: "",
      terminalId: "",
      onlinePrintTerminalId: "",
      onlineCustomerTerminalId: "",
      onlineKitchenTerminalId: "",
      autoPrintOnlineCustomer: false,
      autoPrintOnlineKitchen: false,
      webPrintMode: getWebPrintMode(),
      webPrintDocumentType: getWebPrintDocumentType(),
      browserPrintConfirmOpen: false,
      browserPrintDocumentType: "",

      // Suggestions (upsell/cross-sell)
      suggestionData: { frequently_bought: [], cross_category: [], upsell: {} },
      suggestionCacheKey: "",
      isAddProductModalOpen: false,
      formUser: {},
      hasTemplateProducts: false,
      showTemplate: false,
      canDismissTemplate: false,
    };
    this.socket = createSocket();

    this.autoPrintCustomerRef = React.createRef();
    this.autoPrintKitchenRef = React.createRef();
    this.autoPrintCustomerComponentRef = React.createRef();
    this.autoPrintCustomerTriggerRef = React.createRef();
    this.autoPrintKitchenTriggerRef = React.createRef();
    this.autoPrintQueue = Promise.resolve();
    this.autoPrintRetryTimers = new Set();
    this.isDrainingOnlinePrintJobs = false;
    this.pendingBrowserPrintResolver = null;
    this.pendingBrowserPrintJob = null;
    this.pendingBrowserPrintFallbackTimer = null;

    // Biến để lưu trữ timerId của debounce
    this.debounceTimer = null;
    this.addProductWarningTimer = null;

    this.onUpdateOrderStatus = this.onUpdateOrderStatus.bind(this);

    this.onCheckItemPending = this.onCheckItemPending.bind(this);
    this.onCheckItemDone = this.onCheckItemDone.bind(this);
    this.onCheckItemRefund = this.onCheckItemRefund.bind(this);

    this.onActions = this.onActions.bind(this);
  }

  getDefaultCashs = () => [
    { cash: 1000, quantity: 0 },
    { cash: 2000, quantity: 0 },
    { cash: 5000, quantity: 0 },
    { cash: 10000, quantity: 0 },
    { cash: 20000, quantity: 0 },
    { cash: 50000, quantity: 0 },
    { cash: 100000, quantity: 0 },
    { cash: 200000, quantity: 0 },
    { cash: 500000, quantity: 0 },
  ];

  getDefaultDiscountForm = () => ({
    orders_id: [],
    user_id: "",
    note: "",
    value: "",
    type: "percent",
    saved: false,
    max: null,
    isManual: false,
  });

  getDefaultTaxFee = () => ({
    orders_id: [],
    user_id: "",
    note: "",
    value: "",
    type: "percent",
    calculation: "added",
    saved: false,
    isManual: false,
  });

  getDefaultFeeOther = () => ({
    orders_id: [],
    user_id: "",
    label: "shipping",
    note: "",
    value: "",
    type: "percent",
    applyOn: "after_discount",
    saved: false,
    isManual: false,
  });

  getResetOrderDraftState = () => ({
    orders: [],
    itemsChange: [],
    _itemsChange: [],
    ordersFiltered: [],
    modalOrderOpen: false,
    customer_name: "",
    customer_phone: "",
    selectedCustomerId: null,
    suggestions: [],
    receiver_address: "",
    customer_debt: 0,
    customer_debt_limit: 0,
    isDebtLimitConfirmed: false,
    refund_to_customer: 0,
    cashsPay: [],
    isCustomPay: false,
    customCustomerPay: 0,
    customCustomerPayRaw: "",
    creditFullOrderWarningModalOpen: false,
    cashs: this.getDefaultCashs(),
    isChecked: false,
    info_table: "",
    table_id: "",
    selected_promotions: [],
    available_promotions: [],
    manual_promotions: [],
    suggestionData: {
      frequently_bought: [],
      cross_category: [],
      upsell: {},
    },
    suggestionCacheKey: "",
    paymentMethod: "cash",
    shippingCarrier: null,
    shipping_provider: null,
    is_shipping: false,
    shipping_fee: 0,
    receiver_province: null,
    receiver_district: null,
    receiver_ward: null,
    shipping_receiver_name: "",
    shipping_receiver_phone: "",
    shipping_cod: false,
    shipping_cod_amount: 0,
    shipping_free: false,
    shipping_weight: 500,
    shipping_length: 20,
    shipping_width: 20,
    shipping_height: 10,
    shipping_note: "",
    shipping_required_note: "",
    deletedProvisionalItems: [],
    provisionalBillIds: [],
    currentPin: null,
    currentPinPrint: null,
    discount_form: this.getDefaultDiscountForm(),
    tax_fee: this.getDefaultTaxFee(),
    fee_other: this.getDefaultFeeOther(),
    customOrderDate: null,
    eInvoice_customer_name: "Bán cho người tiêu dùng",
    eInvoice_customer_phone: "",
    eInvoice_customer_tax_id: "",
    eInvoice_customer_address: "",
    eInvoice_customer_email: "",
  });

  // ============ KEYBOARD SHORTCUTS HANDLER ============
  handleKeyDown = (e) => {
    // Bỏ qua nếu đang focus vào input, textarea, select
    const activeElement = document.activeElement;
    const isTyping =
      activeElement &&
      (activeElement.tagName === "INPUT" ||
        activeElement.tagName === "TEXTAREA" ||
        activeElement.tagName === "SELECT" ||
        activeElement.isContentEditable);

    // F1: Mở trang hướng dẫn
    if (e.key === "F1") {
      e.preventDefault();
      window.open("https://docs.vmass.vn", "_blank");
      return;
    }

    // F2: Focus vào ô tìm kiếm
    if (e.key === "F2") {
      e.preventDefault();
      const searchInput =
        document.querySelector(".search input") ||
        document.querySelector('input[name="search"]');
      if (searchInput) {
        searchInput.focus();
        searchInput.select();
      }
      return;
    }

    // F3: Mở trang thêm sản phẩm mới
    if (e.key === "F3") {
      e.preventDefault();
      this.props.history.push("/app/pages/product");
      return;
    }

    // F4: Mở modal chiết khấu/thuế/phí (nếu có order)
    if (e.key === "F4") {
      e.preventDefault();
      if (this.state.orders && this.state.orders.length > 0) {
        this.setState({
          is_open_modal_discount_tax_fee: true,
          active_order_adjustment_modal: "discount",
        });
      } else {
        NotificatioErrController(
          this.props.intl.formatMessage({
            id: "home.notify.no-order-discount",
          }),
        );
      }
      return;
    }

    // F8: In hóa đơn tạm tính (Preview)
    if (e.key === "F8") {
      e.preventDefault();
      if (this.state.orders && this.state.orders.length > 0) {
        // Trigger print provisional invoice button
        const printBtn = document.querySelector(
          '[data-id="btn-print-provisional"]',
        );
        if (printBtn) {
          printBtn.click();
        } else {
          NotificatioErrController(
            this.props.intl.formatMessage({
              id: "home.notify.open-menu-print",
            }),
          );
        }
      } else {
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "home.notify.no-order-print" }),
        );
      }
      return;
    }

    // F9: Thanh toán / Đặt hàng
    if (e.key === "F9") {
      e.preventDefault();
      if (this.state.orders && this.state.orders.length > 0) {
        // Trigger the payment submit button
        const paymentBtn = document.querySelector('[data-id="btn-payment"]');
        if (paymentBtn) {
          paymentBtn.click();
        } else {
          NotificatioErrController(
            this.props.intl.formatMessage({ id: "home.notify.no-payment-btn" }),
          );
        }
      } else {
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "home.notify.no-order-pay" }),
        );
      }
      return;
    }

    // F10: Lưu hóa đơn tạm (Provisional Invoice)
    if (e.key === "F10") {
      e.preventDefault();
      if (this.state.orders && this.state.orders.length > 0) {
        // Trigger save provisional invoice button
        const saveBtn = document.querySelector(
          '[data-id="btn-save-provisional"]',
        );
        if (saveBtn) {
          saveBtn.click();
        } else {
          // Fallback: call the save function directly if available
          if (typeof this.handleSaveOrdersProvisionInvoice === "function") {
            this.handleSaveOrdersProvisionInvoice();
          } else {
            NotificatioErrController(
              this.props.intl.formatMessage({
                id: "home.notify.save-not-supported",
              }),
            );
          }
        }
      } else {
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "home.notify.no-order-save" }),
        );
      }
      return;
    }
  };

  delay = (ms = 0) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  resolvePrintableNode = (target) => {
    if (!target) return null;

    if (target instanceof HTMLElement) {
      return target;
    }

    try {
      const node = ReactDOM.findDOMNode(target);
      return node instanceof HTMLElement ? node : null;
    } catch (error) {
      return null;
    }
  };

  formatPrintBillDate = (dateValue) => {
    if (!dateValue) return getDateWithFormat();

    let m = moment(dateValue, ["YYYY-MM-DD", "DD/MM/YYYY"], true);
    if (!m.isValid()) {
      m = moment(dateValue);
    }
    if (m.isValid()) return m.format("DD/MM/YYYY");

    return getDateWithFormat();
  };

  setAutoPrintPayload = (payload = {}) =>
    new Promise((resolve) => {
      this.setState(
        {
          autoPrintOnlineItems: payload.items || [],
          autoPrintOnlineBillDate: payload.billDate || getDateWithFormat(),
          autoPrintOnlineTimeStart: payload.timeStart || "",
          autoPrintOnlinePinPrint: payload.pinPrint || "",
          autoPrintOnlineCustomerName: payload.customerName || "",
          autoPrintOnlineCustomerPhone: payload.customerPhone || "",
          autoPrintOnlineCustomerAddress: payload.customerAddress || "",
          autoPrintOnlineDeliveryTime: payload.deliveryTime || "",
          autoPrintOnlineTableName: payload.tableName || "",
          autoPrintOnlineJobKey: payload.jobKey || "",
        },
        resolve,
      );
    });

  triggerBrowserPrint = (triggerRef) => {
    const printButton = triggerRef?.current;
    if (!printButton || typeof printButton.click !== "function") {
      return false;
    }
    printButton.click();
    return true;
  };

  prepareAutoPrintCustomerInvoice = async () => {
    if (
      this.autoPrintCustomerComponentRef.current &&
      typeof this.autoPrintCustomerComponentRef.current.prepareForPrint ===
        "function"
    ) {
      await this.autoPrintCustomerComponentRef.current.prepareForPrint();
    }
  };

  printDomNodeSilently = async (
    domNode,
    configuredPrinterName = null,
    documentType = "customer",
  ) => {
    if (!domNode || !window.electronAPI?.printSilent) return false;

    const printableNode = this.resolvePrintableNode(domNode);
    if (!printableNode) {
      console.log("Auto print skipped: printable node not found");
      return false;
    }

    const htmlContent = buildSilentPrintHtml(printableNode.outerHTML, {
      paperWidthMm: getStoredPrintPaperWidthMm(documentType),
      documentType,
    });
    const printerName =
      configuredPrinterName ||
      localStorage.getItem("defaultPrinter") ||
      localStorage.getItem("default_printer") ||
      null;

    try {
      const result = await window.electronAPI.printSilent(
        htmlContent,
        printerName,
      );
      if (result?.success !== true) {
        console.log("Auto print failed:", result?.error);
        return false;
      }
      return true;
    } catch (error) {
      console.log("Auto print error:", error);
      return false;
    }
  };

  getOnlinePrintDocumentTypes = () => {
    const enabledTypes = getEnabledOnlinePrintTypes({
      customer: this.state.autoPrintOnlineCustomer,
      kitchen: this.state.autoPrintOnlineKitchen,
    });
    const assignedTypes = enabledTypes.filter((type) => {
      const assignedTerminalId =
        type === "customer"
          ? this.state.onlineCustomerTerminalId
          : this.state.onlineKitchenTerminalId;
      return assignedTerminalId === this.state.terminalId;
    });

    if (isElectron) return assignedTypes;
    return assignedTypes.filter(
      (type) => type === this.state.webPrintDocumentType,
    );
  };

  isActiveOnlinePrintTerminal = () =>
    Boolean(
      this.state.terminalId && this.getOnlinePrintDocumentTypes().length > 0,
    );

  reportOnlinePrintResult = async (jobId, success, error = "") => {
    const tokenStr = localStorage.getItem("access_token");
    return axios.post(
      `${END_POINT}/online-print-jobs/${jobId}/result`,
      {
        terminal_id: this.state.terminalId,
        success,
        error,
      },
      { headers: { Authorization: `Bearer ${tokenStr}` } },
    );
  };

  getLocallyCompletedOnlinePrintJobs = () => {
    try {
      const parsed = JSON.parse(
        localStorage.getItem("onlinePrintCompletedJobs") || "[]",
      );
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  markOnlinePrintLocallyCompleted = (jobId) => {
    const completed = this.getLocallyCompletedOnlinePrintJobs();
    const next = [jobId, ...completed.filter((id) => id !== jobId)].slice(
      0,
      200,
    );
    localStorage.setItem("onlinePrintCompletedJobs", JSON.stringify(next));
  };

  clearOnlinePrintLocalCompletion = (jobId) => {
    const completed = this.getLocallyCompletedOnlinePrintJobs();
    localStorage.setItem(
      "onlinePrintCompletedJobs",
      JSON.stringify(completed.filter((id) => id !== jobId)),
    );
  };

  printClaimedOnlineJobInBrowser = (job) =>
    new Promise((resolve) => {
      this.pendingBrowserPrintResolver = resolve;
      this.pendingBrowserPrintJob = job;
      this.pendingBrowserPrintFallbackTimer = setTimeout(
        () => this.finishBrowserPrintDecision(false),
        10 * 60 * 1000,
      );
      this.setState(
        {
          browserPrintConfirmOpen: false,
          browserPrintDocumentType: job.document_type,
          webPrintMode: getWebPrintMode(),
        },
        () => {
          const triggerRef =
            job.document_type === "customer"
              ? this.autoPrintCustomerTriggerRef
              : this.autoPrintKitchenTriggerRef;
          if (!this.triggerBrowserPrint(triggerRef)) {
            this.finishBrowserPrintDecision(false);
          }
        },
      );
    });

  handleBrowserPrintClosed = () => {
    if (!this.pendingBrowserPrintResolver || !this.pendingBrowserPrintJob) {
      return;
    }

    if (getWebPrintMode() === "kiosk-silent") {
      this.finishBrowserPrintDecision(true);
      return;
    }

    this.setState({ browserPrintConfirmOpen: true });
  };

  finishBrowserPrintDecision = (printed) => {
    if (this.pendingBrowserPrintFallbackTimer) {
      clearTimeout(this.pendingBrowserPrintFallbackTimer);
      this.pendingBrowserPrintFallbackTimer = null;
    }
    const resolve = this.pendingBrowserPrintResolver;
    this.pendingBrowserPrintResolver = null;
    this.pendingBrowserPrintJob = null;
    this.setState({ browserPrintConfirmOpen: false });
    if (resolve) resolve(printed);
  };

  retryBrowserPrint = () => {
    if (!this.pendingBrowserPrintJob) return;
    this.setState({ browserPrintConfirmOpen: false }, () => {
      const triggerRef =
        this.pendingBrowserPrintJob.document_type === "customer"
          ? this.autoPrintCustomerTriggerRef
          : this.autoPrintKitchenTriggerRef;
      if (!this.triggerBrowserPrint(triggerRef)) {
        this.finishBrowserPrintDecision(false);
      }
    });
  };

  printClaimedOnlineJob = async ({ job, orders }) => {
    const completedBills = (() => {
      try {
        return JSON.parse(
          localStorage.getItem("localPrintCompletedBills") || "[]",
        );
      } catch (e) {
        return [];
      }
    })();

    if (job.bill_id && completedBills.includes(job.bill_id)) {
      this.markOnlinePrintLocallyCompleted(job.id);
      await this.reportOnlinePrintResult(job.id, true, "");
      this.clearOnlinePrintLocalCompletion(job.id);
      return true;
    }

    if (this.getLocallyCompletedOnlinePrintJobs().includes(job.id)) {
      await this.reportOnlinePrintResult(job.id, true);
      this.clearOnlinePrintLocalCompletion(job.id);
      return true;
    }

    const firstOrder = orders[0] || {};
    await this.setAutoPrintPayload({
      items: orders,
      billDate: this.formatPrintBillDate(firstOrder.date),
      timeStart: firstOrder.time || "",
      pinPrint: firstOrder.pin_print || "",
      customerName: firstOrder.customer_name || "",
      customerPhone: firstOrder.phone || "",
      customerAddress: firstOrder.customer_address || "",
      deliveryTime: firstOrder.delivery_time || "",
      tableName: firstOrder.user_identify || "",
      jobKey: job.id,
    });
    await this.delay(150);

    if (!isElectron) {
      const printed = await this.printClaimedOnlineJobInBrowser(job);
      if (printed) {
        this.markOnlinePrintLocallyCompleted(job.id);
      }
      await this.reportOnlinePrintResult(
        job.id,
        printed,
        printed ? "" : "Người dùng chọn để in lại sau",
      );
      if (printed) {
        this.clearOnlinePrintLocalCompletion(job.id);
      }
      return printed;
    }

    const isCustomer = job.document_type === "customer";
    const printerName =
      (isCustomer
        ? localStorage.getItem("onlineCustomerPrinter")
        : localStorage.getItem("onlineKitchenPrinter")) ||
      localStorage.getItem("defaultPrinter") ||
      localStorage.getItem("default_printer") ||
      null;
    const printableRef = isCustomer
      ? this.autoPrintCustomerRef
      : this.autoPrintKitchenRef;

    if (!printerName) {
      const error = isCustomer
        ? "Chưa chọn máy in hóa đơn khách"
        : "Chưa chọn máy in phiếu bếp/bar";
      await this.reportOnlinePrintResult(job.id, false, error);
      NotificationManager.error(error, "Tự in đơn online", 5000);
      return false;
    }

    if (isCustomer) {
      await this.prepareAutoPrintCustomerInvoice();
    }

    const printed = await this.printDomNodeSilently(
      printableRef.current,
      printerName,
      isCustomer ? "customer" : "kitchen",
    );
    if (printed) {
      this.markOnlinePrintLocallyCompleted(job.id);
    }
    await this.reportOnlinePrintResult(
      job.id,
      printed,
      printed ? "" : `Không thể in bằng máy ${printerName}`,
    );
    if (printed) {
      this.clearOnlinePrintLocalCompletion(job.id);
    }

    if (!printed) {
      NotificationManager.error(
        `Không thể tự in ${isCustomer ? "hóa đơn khách" : "phiếu bếp/bar"}`,
        "Tự in đơn online",
        5000,
      );
    }
    return printed;
  };

  scheduleOnlinePrintRetry = (attempts = 1) => {
    const delayMs = getOnlinePrintRetryDelay(attempts);
    const timer = setTimeout(() => {
      this.autoPrintRetryTimers.delete(timer);
      this.scheduleOnlinePrintDrain();
    }, delayMs);
    this.autoPrintRetryTimers.add(timer);
  };

  drainOnlinePrintJobs = async () => {
    if (this.isDrainingOnlinePrintJobs || !this.isActiveOnlinePrintTerminal()) {
      return;
    }

    const documentTypes = this.getOnlinePrintDocumentTypes();
    if (!documentTypes.length) return;

    this.isDrainingOnlinePrintJobs = true;
    const tokenStr = localStorage.getItem("access_token");

    try {
      while (this.isActiveOnlinePrintTerminal()) {
        const response = await axios.post(
          `${END_POINT}/online-print-jobs/claim`,
          {
            terminal_id: this.state.terminalId,
            terminal_kind: isElectron ? "electron" : "web",
            document_types: documentTypes,
          },
          { headers: { Authorization: `Bearer ${tokenStr}` } },
        );
        const claimed = response.data?.data;
        if (!claimed?.job) break;

        const printed = await this.printClaimedOnlineJob(claimed);
        if (!printed && claimed.job.attempts < ONLINE_PRINT_MAX_ATTEMPTS) {
          this.scheduleOnlinePrintRetry(claimed.job.attempts);
        }
        await this.delay(250);
      }
    } catch (error) {
      if (error.response?.status !== 403) {
        console.log("Online print queue error:", error);
        this.scheduleOnlinePrintRetry(2);
      }
    } finally {
      this.isDrainingOnlinePrintJobs = false;
    }
  };

  scheduleOnlinePrintDrain = () => {
    if (isElectron) return;
    this.autoPrintQueue = this.autoPrintQueue
      .then(() => this.drainOnlinePrintJobs())
      .catch((error) => {
        console.log("Online print queue error:", error);
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location && this.props.location.aboutProps) {
      const { message_item_id, message_user_id } =
        this.props.location.aboutProps;

      if (
        message_item_id &&
        message_user_id &&
        message_item_id != this.state.aboutProps.message_item_id &&
        message_user_id != this.state.aboutProps.message_user_id
      ) {
        // call get inbox
        this.socket.emit("message get inbox", {
          // user_id: localStorage.getItem('user_id'),
          user_id: this.state.USER_PARENT_ID,
        });
      }
    }

    // Sync search keyword from Redux to component state and re-fetch data
    if (prevProps.searchKeyword !== this.props.searchKeyword) {
      this.setState({ search: this.props.searchKeyword || "" }, () => {
        // Debounce search if needed, but dataListRender is already an async call
        this.dataListRender();
      });
    }

    // if (prevState.orders !== this.state.orders) {
    //     this.evaluateAndApplyPromotion();
    // }
  }

  groupProvisionalInvoices = (invoices) => {
    if (!invoices || !Array.isArray(invoices)) return [];

    const groupOrders = (orders) => {
      if (!orders || !Array.isArray(orders)) return [];
      const grouped = [];
      orders.forEach((order) => {
        const match = grouped.find((g) => {
          const getProdName = (o) => o.product?.name || o.name || "";
          const isSameProduct = getProdName(g) === getProdName(order);
          const isSamePrice =
            parseFloat(g.price || 0) === parseFloat(order.price || 0);
          const isSameSize = (g.size || "") === (order.size || "");
          const isSameFlavor = (g.flavor || "") === (order.flavor || "");
          const isSameTopping = (g.topping || "") === (order.topping || "");
          const isSameIce = (g.ice || "") === (order.ice || "");
          const isSameSugar = (g.sugar || "") === (order.sugar || "");
          const isSameNote = (g.note || "") === (order.note || "");

          return (
            isSameProduct &&
            isSamePrice &&
            isSameSize &&
            isSameFlavor &&
            isSameTopping &&
            isSameIce &&
            isSameSugar &&
            isSameNote
          );
        });

        if (match) {
          match.count = (match.count || 1) + (order.count || 1);
          if (!match.ids) {
            match.ids = [match.id];
          }
          match.ids.push(order.id);
        } else {
          grouped.push({
            ...order,
            count: order.count || 1,
            ids: [order.id],
          });
        }
      });
      return grouped;
    };

    return invoices.map((invoice) => ({
      ...invoice,
      orders: groupOrders(invoice.orders),
    }));
  };

  onWindowFocus = () => {
    this.settingRender();
  };

  componentDidMount() {
    window.addEventListener("focus", this.onWindowFocus);
    this.checkAccept();
    this.fetchStaffList();
    window.addEventListener("resize", this.handleResize);
    // Keyboard shortcuts listener
    window.addEventListener("keydown", this.handleKeyDown);

    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    // Set search context cho Navbar - reset về dashboard khi quay lại trang chủ
    this.props.setSearchContext("dashboard");

    this.socket.emit("join room", {
      room_id: this.state.USER_PARENT_ID,
    });

    if (isElectron && window.electronAPI?.getTerminalId) {
      window.electronAPI.getTerminalId().then((terminalId) => {
        this.setState({ terminalId }, this.scheduleOnlinePrintDrain);
      });
    } else {
      this.setState(
        {
          terminalId: getOrCreateWebPrintTerminalId(),
          webPrintMode: getWebPrintMode(),
          webPrintDocumentType: getWebPrintDocumentType(),
        },
        this.scheduleOnlinePrintDrain,
      );
    }

    this.socket.on("connect", this.scheduleOnlinePrintDrain);
    this.socket.on("online-print-job-created", this.scheduleOnlinePrintDrain);

    // Listen for alert-mp3
    this.socket.on("alert-mp3", () => {
      try {
        let alertSound = document.getElementById("call-service-alert-sound");
        if (alertSound) {
          alertSound.play();
        }
      } catch (error) {
        console.log("Error playing alert sound:", error);
      }
    });

    // Listen for call service alerts from guests
    this.socket.on("call-service-alert", (res) => {
      const { message, table_identify, table_id } = res;

      // Play alert sound
      try {
        let alertSound = document.getElementById("call-service-alert-sound");
        if (alertSound) {
          alertSound.play();
        }
      } catch (error) {
        console.log("Error playing alert sound:", error);
      }

      // Callback khi popup bị đóng (click)
      const onDismiss = () => {
        // Đánh dấu đã đọc dựa vào item_id
        this.socket.emit("update-seen-alert-data-by-item-id", {
          user_id: localStorage.getItem("b"),
          item_id: String(table_id || ""),
          type: "service",
        });
      };

      NotificationManager.warning(
        message ||
          `Bàn ${table_identify} - ${this.props.intl.formatMessage({
            id: "home.alert.call-payment",
          })}`,
        "Thông báo!",
        0, // 0 = persistent, won't auto-close until clicked
        onDismiss,
        null,
        "filled",
      );
    });

    // Listen for bell button alerts from guests (Gọi phục vụ)
    this.socket.on("call-bell-alert", (res) => {
      const { message, table_identify, table_id } = res;

      // Play alert sound
      try {
        let alertSound = document.getElementById("call-bell-alert-sound");
        if (alertSound) {
          alertSound.play();
        }
      } catch (error) {
        console.log("Error playing alert sound:", error);
      }

      // Callback khi popup bị đóng (click)
      const onDismiss = () => {
        // Đánh dấu đã đọc dựa vào item_id
        this.socket.emit("update-seen-alert-data-by-item-id", {
          user_id: localStorage.getItem("b"),
          item_id: String(table_id || ""),
          type: "service",
        });
      };

      NotificationManager.info(
        message ||
          `Bàn ${table_identify} - ${this.props.intl.formatMessage({
            id: "home.alert.call-service",
          })}`,
        this.props.intl.formatMessage({ id: "home.alert.call-service" }),
        0, // 0 = persistent, won't auto-close until clicked
        onDismiss,
        null,
        "filled",
      );
    });

    this.socket.on("refresh-recent-order", (res) => {
      const { data } = res;
      // console.log('data: ', data);

      this.setState({
        isLoadingItemsTable: false,
        itemsRecentOrder: data?.data,
        itemsOrderStatus: data?.ordersStatus,
        floorsActiveId: data?.floorsActiveId,
        dataProvisionalInvoice: this.groupProvisionalInvoices(
          data?.OrdersProvisionInvoice,
        ),
        itemsTable: isCurrentFloor({
          current: this.state.selectedFloorTable,
          get: data?.tables?.data?.getFloor,
        })
          ? data?.tables?.data
          : this.state.itemsTable,
      });
    });

    this.socket.on("refresh-pending-order", (res) => {
      const {
        data: { data },
      } = res;
      this.setState({
        itemsPending: data,
        selectedItemsPending: [],
      });
    });

    this.socket.on("refresh-done-order", (res) => {
      const {
        data: { data },
      } = res;
      this.setState({
        itemsDone: data,
        selectedItemsDone: [],
      });
    });

    this.socket.on("refresh-refund-order", (res) => {
      const {
        data: { data },
      } = res;
      this.setState({
        itemsRefund: data,
        selectedItemsRefund: [],
      });
    });

    this.socket.on("message get inbox", (res) => {
      const {
        data: { data },
      } = res;

      if (IsRedirectFromAlert(this.props)) {
        // console.log('from alert');

        const { message_item_id, message_user_id } =
          this.props.location.aboutProps;

        // console.log(data);
        // console.log({ message_item_id, message_user_id } );

        let selectedUserDefault = null;
        if (message_item_id.indexOf(".") >= 0) {
          // guest
          let table_chair_id = message_item_id.split(".")[0];
          let sender_id = message_item_id.split(".")[1];
          let receive_id = message_user_id;

          selectedUserDefault = data.filter(
            (ibx) =>
              ibx.sender_id == sender_id &&
              ibx.receive_id == receive_id &&
              ibx.table_chair_id == table_chair_id,
          );
        } else {
          // store
          selectedUserDefault = data.filter(
            (ibx) =>
              [ibx.friend_id, ibx.user_id].includes(
                parseInt(message_user_id),
              ) &&
              [ibx.friend_id, ibx.user_id].includes(parseInt(message_item_id)),
          );
          // selectedUserDefault = data.filter(ibx => ibx.friend_id == message_user_id && ibx.user_id == message_item_id)
        }
        selectedUserDefault = selectedUserDefault.length
          ? selectedUserDefault[0]
          : null;

        // console.log(selectedUserDefault);

        if (selectedUserDefault) {
          this.setState({
            messagesData: data,
            messageDefaultValue: {
              selectedUser: selectedUserDefault,
              props: this.props,
            },
            aboutProps: {
              message_item_id: message_item_id,
              message_user_id: message_user_id,
            },
          });
        }
      } else {
        this.setState({
          messagesData: data,
        });
      }
    });

    // 2. Lắng nghe sự kiện 'refresh-stock' để cập nhật state của component này
    this.socket.on("refresh-stock", (res) => {
      const data = res?.data?.data;
      const dataWasDownNew = res?.data?.dataWasDownNew;
      if (Array.isArray(data)) {
        this.setState((prev) => ({
          ...prev,
          data_stock_in_order_component: {
            loading: false,
            data: data,
          },
        }));
      }

      // Hiển thị popup thông báo nếu có nguyên liệu xuống dưới mức quy định (20% hoặc 10%)
      if (Array.isArray(dataWasDownNew) && dataWasDownNew.length > 0) {
        dataWasDownNew.forEach((stock) => {
          NotificationManager.warning(
            `Nguyên liệu "${stock.name}" còn dưới ${stock.type}%`,
            this.props.intl.formatMessage({ id: "home.alert.stock-warning" }),
            5000,
            null,
            null,
            "filled",
          );
        });
      }
    });

    this.socket.on("broadcast", () => {
      // reload inbox
      this.socket.emit("message get inbox", {
        // user_id: localStorage.getItem('user_id'),
        user_id: this.state.USER_PARENT_ID,
      });
    });

    this.socket.on("refresh-product", () => {
      this.dataListRender();
    });

    this.addProductWarningTimer = setTimeout(() => {
      this.setState({ showAddProductWarning: true });
    }, 3000);

    this.onUpdateData();
    this.renderLengthBill();
    this.dataListRender();
    this.getAllOrders();
    this.fetchConnectedProviders();
    this.fetchEInvoiceConfig();
    this.renderDataProvisionalInvoice();
    this.dataRenderPromotion();
    this.dataRenderUser();
    this.settingRender();
  }

  componentWillUnmount() {
    window.removeEventListener("focus", this.onWindowFocus);
    window.removeEventListener("resize", this.handleResize);
    // Remove keyboard shortcuts listener
    window.removeEventListener("keydown", this.handleKeyDown);
    if (this.socket) {
      // Gỡ bỏ tất cả các listeners đã đăng ký
      this.socket.off("refresh-recent-order");
      this.socket.off("refresh-pending-order");
      this.socket.off("refresh-done-order");
      this.socket.off("refresh-refund-order");
      this.socket.off("message get inbox");
      this.socket.off("refresh-stock");
      this.socket.off("broadcast");
      this.socket.off("refresh-product");
      this.socket.off("connect", this.scheduleOnlinePrintDrain);
      this.socket.off(
        "online-print-job-created",
        this.scheduleOnlinePrintDrain,
      );
      // Thêm bất kỳ listeners nào khác bạn đã đăng ký

      // Sau đó đóng kết nối
      this.socket.close();
    }
    if (this.addProductWarningTimer) {
      clearTimeout(this.addProductWarningTimer);
      this.addProductWarningTimer = null;
    }

    this.autoPrintQueue = Promise.resolve();
    this.autoPrintRetryTimers.forEach((timer) => clearTimeout(timer));
    this.autoPrintRetryTimers.clear();
    this.isDrainingOnlinePrintJobs = false;
    if (this.pendingBrowserPrintResolver) {
      this.pendingBrowserPrintResolver(false);
      this.pendingBrowserPrintResolver = null;
      this.pendingBrowserPrintJob = null;
    }
    if (this.pendingBrowserPrintFallbackTimer) {
      clearTimeout(this.pendingBrowserPrintFallbackTimer);
      this.pendingBrowserPrintFallbackTimer = null;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
  }

  dataListRender() {
    const { categoryId, search } = this.state;
    const store = this.state.store || getStore();
    let tokenStr = localStorage.getItem("access_token");

    if (!store && !tokenStr) return false;

    const headers = tokenStr ? { Authorization: `Bearer ${tokenStr}` } : {};
    const storeQuery = store ? `&store=${encodeURIComponent(store)}` : "";

    axios
      .get(
        `${
          END_POINT + "/product/guest"
        }?categoryId=${categoryId}&search=${encodeURIComponent(search || "")}${storeQuery}`,
        { headers },
      )
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        if (!data || !Array.isArray(data.data)) {
          this.setState({ menus: [], is_loading_data: false });
          return;
        }

        let menu = [];

        // best seller - goi y mon ngon
        let template = {
          id: 0,
          name: "Khuyên dùng",
          data: data.data.filter((p) => !!p.bestter),
        };

        // Only show if there are recommended items
        if (template.data.length > 0) {
          menu.push(template);
        }

        // group by category
        let category_id = [];
        data.data.forEach((p) => {
          const categoryObj = p.category || {
            id: p.category_id || 0,
            name: "Chưa phân loại",
          };
          const catId = categoryObj.id;
          const catName = categoryObj.name;

          if (!category_id.includes(catId)) {
            category_id.push(catId);

            template = {
              id: catId,
              name: catName,
              data: [],
            };
            template.data.push(p);
            menu.push(template);
          } else {
            menu.forEach((m) => {
              if (catId === m.id) {
                m.data.push(p);
              }
            });
          }
        });

        // state
        const hasTemplateProducts =
          Array.isArray(data.data) &&
          data.data.some((p) => Boolean(p.isTemplate));

        this.setState(
          {
            store,
            menus: menu,
            hasTemplateProducts,
            is_loading_data: false,
          },
          () => {
            this.checkAndUpdateWizardStatus();
          },
        );
      })
      .catch((err) => {
        const message =
          err?.response?.data?.responseText || "Lỗi kết nối server";
        console.error("[dataListRender] Error:", err?.message || err);
        NotificationManager.error(message, "Lỗi !", 3000, null, null, "filled");
        this.setState({ is_loading_data: false });
        return false;
      });
  }

  renderCategories() {
    return this.state.menus.map((categories, index) => {
      return (
        <span
          onClick={() => {
            this.onClickCategory(categories.name, index);
          }}
          key={categories.id}
          id={index}
          className={
            this.state.activeIndex === index
              ? "active-menu nav_items cursor-pointer py-1 px-3"
              : "nav_items cursor-pointer py-1 px-3"
          }
        >
          {categories.name}
        </span>
      );
    });
  }

  settingRender() {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/setting"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        // console.log('data_setting: ', data);
        const setting = data.data;
        if (data) {
          this.setState(
            (prevState) => ({
              ...prevState,
              shift_required: setting.shift_required || false,
              switchChecked: {
                ...prevState.switchChecked,
                switchCheckedBill: setting.bill_cashier,
                switchCheckedBillQr: setting.bill_qr,
                switchCheckedBillBar: setting.bill_bar,
                switchCheckedTemBar: setting.tem_bar,
                switchCheckedTemCashier: setting.tem_cashier,
                switchCheckedOrderOne: setting.order_processing_one,
                switchCheckedOrderTwo: setting.order_processing_two,
                switchCheckedOrderThree: setting.order_processing_three,
              },
              save_provisional_when_print:
                setting.save_provisional_when_print !== undefined
                  ? setting.save_provisional_when_print
                  : true,
              print_customer_provisional:
                setting.print_customer_provisional !== undefined
                  ? setting.print_customer_provisional
                  : true,
              print_customer_invoice:
                setting.print_customer_invoice !== undefined
                  ? setting.print_customer_invoice
                  : true,
              autoPrintOnlineCustomer:
                setting.auto_print_online_customer === true,
              autoPrintOnlineKitchen:
                setting.auto_print_online_kitchen === true,
              onlinePrintTerminalId: setting.online_print_terminal_id || "",
              onlineCustomerTerminalId:
                setting.online_print_customer_terminal_id ||
                setting.online_print_terminal_id ||
                "",
              onlineKitchenTerminalId:
                setting.online_print_kitchen_terminal_id ||
                setting.online_print_terminal_id ||
                "",
              webPrintMode: getWebPrintMode(),
              webPrintDocumentType: getWebPrintDocumentType(),
            }),
            this.scheduleOnlinePrintDrain,
          );

          // Check shift status if shift_required is enabled
          if (setting.shift_required) {
            this.checkShiftStatus();
          }
        } else {
          NotificatioErrController("Không có dữ liệu");
        }
      })
      .catch((err) => {
        NotificatioErrController(err?.response?.data?.responseText);
      });
  }

  checkShiftStatus = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/shift-session/check/status"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        this.setState({ is_shift_open: !!res.data.is_shift_open });
      })
      .catch(() => {
        this.setState({ is_shift_open: false });
      });
  };

  // Suggestion (upsell/cross-sell)
  fetchProductSuggestions = () => {
    const { orders } = this.state;
    if (!orders || orders.length === 0) {
      this.setState({
        suggestionData: {
          frequently_bought: [],
          cross_category: [],
          upsell: {},
        },
        suggestionCacheKey: "",
      });
      return;
    }

    const product_ids = [...new Set(orders.map((o) => o.id))];
    const category_ids = [
      ...new Set(orders.map((o) => o.product?.category_id).filter(Boolean)),
    ];

    const cacheKey = product_ids.sort((a, b) => a - b).join(",");
    if (cacheKey === this.state.suggestionCacheKey) return;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(
        `${END_POINT}/suggestion?product_ids=${product_ids.join(",")}&category_ids=${category_ids.join(",")}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        this.setState({
          suggestionData: res.data.data || {
            frequently_bought: [],
            cross_category: [],
            upsell: {},
          },
          suggestionCacheKey: cacheKey,
        });
      })
      .catch(() => {});
  };

  handleUpgradeSize = (order, newSize) => {
    const orders = this.state.orders.map((o) => {
      if (o !== order) return o;

      // Detect fashion/retail: uses selectedAttributes.size or order.size string
      const isFashion =
        !o.sizeSelectedId?.length &&
        (o.selectedAttributes?.size || (o.size && typeof o.size === "string"));

      if (isFashion && o.variants?.length) {
        // Fashion/Retail: find matching variant for new size + existing attributes
        const newSelectedAttrs = { ...o.selectedAttributes };
        newSelectedAttrs.size = { value: newSize.name, label: newSize.name };

        const matchedVariant = o.variants.find((v) =>
          Object.keys(newSelectedAttrs).every(
            (key) =>
              v.attributes?.[key]?.value === newSelectedAttrs[key]?.value,
          ),
        );

        let newPrice;
        if (matchedVariant) {
          const promo = parseFloat(matchedVariant.promo_price);
          const base = parseFloat(matchedVariant.price);
          newPrice =
            !isNaN(promo) && promo > 0 ? promo : !isNaN(base) ? base : 0;
        } else {
          // Fallback to sizeSettings price
          newPrice =
            parseFloat(newSize.promo_price) > 0
              ? parseFloat(newSize.promo_price)
              : parseFloat(newSize.value) || 0;
        }

        return {
          ...o,
          size: newSize.name,
          selectedAttributes: newSelectedAttrs,
          id_variant: matchedVariant ? matchedVariant.id : o.id_variant,
          price: newPrice,
          product: { ...o.product, price: newPrice },
        };
      }

      // F&B logic (original)
      const newPrice =
        parseFloat(newSize.promo_price) > 0
          ? parseFloat(newSize.promo_price)
          : parseFloat(newSize.value) || 0;

      // Recalculate price with existing toppings
      let totalPrice = newPrice;
      if (o.toppingSelectedId?.length && o.toppingSettings) {
        const selectedToppings = o.toppingSettings.filter((t) =>
          o.toppingSelectedId.includes(t.id),
        );
        for (const t of selectedToppings) {
          totalPrice +=
            parseFloat(t.promo_price) > 0
              ? parseFloat(t.promo_price)
              : parseFloat(t.value) || 0;
        }
      }

      return {
        ...o,
        sizeSelectedId: [newSize.id],
        sizeName: newSize.name,
        price: totalPrice,
        product: { ...o.product, price: totalPrice },
      };
    });
    this.setState({ orders });
  };

  handleAddTopping = (order, topping) => {
    const orders = this.state.orders.map((o) => {
      if (o !== order) return o;

      const toppingPrice =
        parseFloat(topping.promo_price) > 0
          ? parseFloat(topping.promo_price)
          : parseFloat(topping.value) || 0;

      return {
        ...o,
        toppingSelectedId: [...(o.toppingSelectedId || []), topping.id],
        toppingName: [...(o.toppingName || []), topping.name],
        toppingValue: [...(o.toppingValue || []), topping.value],
        price: parseFloat(o.price) + toppingPrice,
        product: {
          ...o.product,
          price: parseFloat(o.price) + toppingPrice,
        },
      };
    });
    this.setState({ orders });
  };

  // Barcode Scanner handlers
  handleOpenScanner = () => {
    this.setState({ isScannerOpen: true });
  };

  handleCloseScanner = () => {
    this.setState({ isScannerOpen: false });
  };

  handleBarcodeScan = (result) => {
    // Close scanner modal
    // this.setState({ isScannerOpen: false });

    // Update search keyword with scanned barcode
    this.props.updateSearchKeyword(result);

    // Trigger search submit
    this.props.submitSearchByEnter();

    // Reset input về rỗng sau khi submit
    setTimeout(() => {
      this.props.updateSearchKeyword("");
    }, 500);

    // Show success notification
    NotificationManager.success(
      `Đã quét: ${result}`,
      this.props.intl.formatMessage({ id: "home.notify.scan-success" }),
      2000,
      null,
      null,
      "filled",
    );
  };

  renderDataProvisionalInvoice() {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/order/order_provision_invoice"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        return res.data;
      })
      .then(async (data) => {
        if (data) {
          await this.setState((prevState) => ({
            ...prevState,
            dataProvisionalInvoice: this.groupProvisionalInvoices(data.data),
          }));
        } else {
          NotificatioErrController("Không có dữ liệu");
        }
      })
      .catch((err) => {
        NotificatioErrController(err?.response?.data?.responseText);
      });
  }

  dataRenderPromotion = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/promotion/promotion-active"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        // Dữ liệu trả về giờ đã bao gồm 'variants' và 'options' trong mỗi sản phẩm
        const promotions = res.data.data;

        this.setState((prev) => ({
          ...prev,
          promotions: promotions,
          // activePromotions: promotions,
          activePromotions: promotions.filter((p) => p.isAutoUse === true),
        }));
      })
      .catch((err) => {
        NotificatioErrController(err?.response?.data?.responseText);
        return false;
      });
  };

  dataRenderUser = () => {
    let tokenStr = localStorage.getItem("access_token");
    if (!tokenStr) return;
    axios
      .get(`${END_POINT + "/user"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        if (!data || !data.data) return;
        const user = data.data;
        const userDomain = user.domain || "";
        if (userDomain) {
          localStorage.setItem("vmass_store_domain", userDomain);
          localStorage.setItem("domain", userDomain);
        }
        const savedData = {
          companyName: user.companyName || "",
          domain: userDomain,
          phone: user.phoneNumber || user.hotline || "",
          email: user.email || "",
          companyAddress: user.companyAddress || user.address || "",
          namePay: user.namePay || "",
          numberPay: user.numberPay || "",
          bankPay: user.bankPay || "",
          login_status: user.login_status || "",
          products: [
            { id: 1, nameProduct: "", category: "", price: "" },
            { id: 2, nameProduct: "", category: "", price: "" },
            { id: 3, nameProduct: "", category: "", price: "" },
          ],
        };

        this.handleLoginStatus(user.login_status);

        const storeChanged = userDomain && userDomain !== this.state.store;
        this.setState(
          {
            formUser: savedData,
            showTemplate: Boolean(user.showTemplate),
            canDismissTemplate:
              Number(user.id) === Number(user.idParent) || Boolean(user.admin),
            ...(storeChanged ? { store: userDomain } : {}),
          },
          () => {
            this.checkAndUpdateWizardStatus();
            if (
              storeChanged ||
              !this.state.menus ||
              this.state.menus.length === 0
            ) {
              this.dataListRender();
            }
          },
        );
      })
      .catch((err) => {
        console.error("[dataRenderUser] Error:", err);
      });
  };

  onClickCategory = (name, index) => {
    let listsData = [...this.state.menus];

    if (name === "all") {
      // const listsData = [...this.state.menus];
      const removeFirstElement = listsData.shift();
      this.setState((prev) => ({
        ...prev,
        listsData: listsData,
        activeIndex: 99,
      }));
    } else {
      const listsSort = listsData.find((menu) => menu.name === name);

      const lists = listsSort?.data?.map((d) => d);

      this.setState((prev) => ({
        ...prev,
        listsData: [{ name: name, data: lists }],
        activeIndex: index,
      }));
    }
  };

  resetMessageDefaultValue = () => {
    if (this.props.location && this.props.location.aboutProps) {
      this.props.location.aboutProps = {};
    }
    this.setState({
      messageDefaultValue: {
        selectedUser: {},
        props: null,
      },
      aboutProps: {
        message_item_id: 0,
        message_user_id: 0,
      },
    });
  };

  checkAccept = () => {
    let tokenStr = localStorage.getItem("access_token");

    return axios
      .get(`${END_POINT + "/user-license/check_accept"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState({
          isLoading: true,
          license: data.data,
        });

        return data.data;
      })
      .catch((err) => {
        return false;
      });
  };

  onCheckItemPending = (e, id) => {
    let selectedItems = this.state.selectedItemsPending;
    if (selectedItems.includes(id)) {
      selectedItems = selectedItems.filter((x) => x !== id);
    } else {
      selectedItems.push(id);
    }
    this.setState({
      selectedItemsPending: selectedItems,
    });
    document.activeElement.blur();
  };

  onCheckItemDone = (e, id) => {
    let selectedItems = this.state.selectedItemsDone;
    if (selectedItems.includes(id)) {
      selectedItems = selectedItems.filter((x) => x !== id);
    } else {
      selectedItems.push(id);
    }
    this.setState({
      selectedItemsDone: selectedItems,
    });
    document.activeElement.blur();
    // Đã bỏ gọi getAllOrders() để tránh giật UI khi click chọn sản phẩm
  };

  onCheckItemRefund = (e, id) => {
    let selectedItems = this.state.selectedItemsRefund;
    if (selectedItems.includes(id)) {
      selectedItems = selectedItems.filter((x) => x !== id);
    } else {
      selectedItems.push(id);
    }
    this.setState({
      selectedItemsRefund: selectedItems,
    });
    document.activeElement.blur();
  };

  // Batch selection functions for group checkboxes
  onCheckMultiplePending = (ids, shouldSelect) => {
    let selectedItems = [...this.state.selectedItemsPending];
    if (shouldSelect) {
      // Add all ids that are not already selected
      ids.forEach((id) => {
        if (!selectedItems.includes(id)) {
          selectedItems.push(id);
        }
      });
    } else {
      // Remove all ids
      selectedItems = selectedItems.filter((x) => !ids.includes(x));
    }
    this.setState({
      selectedItemsPending: selectedItems,
    });
    document.activeElement.blur();
  };

  onCheckMultipleRefund = (ids, shouldSelect) => {
    let selectedItems = [...this.state.selectedItemsRefund];
    if (shouldSelect) {
      ids.forEach((id) => {
        if (!selectedItems.includes(id)) {
          selectedItems.push(id);
        }
      });
    } else {
      selectedItems = selectedItems.filter((x) => !ids.includes(x));
    }
    this.setState({
      selectedItemsRefund: selectedItems,
    });
    document.activeElement.blur();
  };

  onCheckMultipleDone = (ids, shouldSelect) => {
    let selectedItems = [...this.state.selectedItemsDone];
    if (shouldSelect) {
      ids.forEach((id) => {
        if (!selectedItems.includes(id)) {
          selectedItems.push(id);
        }
      });
    } else {
      selectedItems = selectedItems.filter((x) => !ids.includes(x));
    }
    this.setState({
      selectedItemsDone: selectedItems,
    });
    document.activeElement.blur();
  };

  onUpdateSelectedFloorTable = (floor) => {
    // Dùng USER_PARENT_ID để cashier có thể load data của owner khi chuyển khu vực
    const user_id =
      this.state.USER_PARENT_ID || localStorage.getItem("user_id");
    this.socket.emit("refresh-recent-order", {
      user_id,
      floor,
    });
    this.setState({
      selectedFloorTable: floor,
    });
  };

  onUpdateData = async (orders_id = []) => {
    // console.log('updateStockCalled');
    // Dùng USER_PARENT_ID để cashier có thể load data của owner (parent user)
    const user_id =
      this.state.USER_PARENT_ID || localStorage.getItem("user_id");

    // Cập nhật stock sau khi có sản phẩm mới thanh toán
    this.socket.emit("refresh-stock", {
      user_id,
      orders_id,
    });
    this.socket.emit("refresh-recent-order", {
      user_id,
      floor: this.state.selectedFloorTable,
    });
    this.socket.emit("refresh-pending-order", {
      user_id,
    });
    this.socket.emit("refresh-done-order", {
      user_id,
    });
    this.socket.emit("refresh-refund-order", {
      user_id,
    });
    this.socket.emit("refresh-alert-data", {
      user_id,
    });

    this.socket.emit("message get inbox", {
      user_id,
    });
  };

  onUpdateOrderStatus(ids, status) {
    // console.log('ids: ', ids);
    let tokenStr = localStorage.getItem("access_token");
    return axios
      .put(
        `${END_POINT + "/order/status"}`,
        {
          arrayId: ids,
          status_id: status,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        NotificationManager.primary(
          this.props.intl.formatMessage({ id: "home.notify.updated" }),
          this.props.intl.formatMessage({ id: "home.notify.success" }),
          3000,
          null,
          null,
          "filled",
        );

        if (status === STATUS.COMPLETED || status === STATUS.PAYMENTED) {
          this.socket.emit("alert-paymenter", {
            user_id: localStorage.getItem("user_id"),
          });

          // // Cập nhật stock sau khi có sản phẩm mới thanh toán
          // this.socket.emit('refresh-stock', {
          //     user_id: localStorage.getItem('user_id'),
          // });
        }

        // this.socket.on('refresh-stock', (res) => {
        //     const {
        //         data: { data },
        //     } = res;
        //     this.setState((prev) => ({
        //         ...prev,
        //         data_stock: {
        //             loading: false,
        //             data: data,
        //         },
        //     }));
        // });

        this.onUpdateData(ids);
      })
      .catch((err) => {
        NotificationManager.error(
          this.props.intl.formatMessage({ id: "home.notify.update-failed" }),
          this.props.intl.formatMessage({ id: "home.notify.error" }),
          3000,
          null,
          null,
          "filled",
        );
      });
  }

  onUpdateTransferTable = (orders, item) => {
    let tokenStr = localStorage.getItem("access_token");
    return axios
      .put(
        `${END_POINT + "/order/table"}`,
        {
          orders,
          user_identify: item.identify,
          table_id: item.id,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        NotificationManager.primary(
          this.props.intl.formatMessage({ id: "home.notify.transfer-success" }),
          this.props.intl.formatMessage({ id: "home.notify.success" }),
          3000,
          null,
          null,
          "filled",
        );

        this.socket.emit("refresh-recent-order", {
          user_id: localStorage.getItem("user_id"),
          floor: this.state.selectedFloorTable,
        });
      })
      .catch((err) => {
        NotificationManager.error(
          this.props.intl.formatMessage({ id: "home.notify.transfer-failed" }),
          this.props.intl.formatMessage({ id: "home.notify.error" }),
          3000,
          null,
          null,
          "filled",
        );
      });
  };

  onActions(selectedItems, action, item, from) {
    if (selectedItems.length < 1) return false;

    if ("table" === from) {
      this.setState({
        isLoadingItemsTable: true,
      });
    }

    switch (action) {
      case "pending":
        this.onUpdateOrderStatus(selectedItems, STATUS.PENDING);
        break;
      case "done":
        this.onUpdateOrderStatus(selectedItems, STATUS.COMPLETED);
        break;
      case "end":
        this.onUpdateOrderStatus(selectedItems, STATUS.PAYMENTED);
        break;
      case "refund":
        this.onUpdateOrderStatus(selectedItems, STATUS.CLOSED);
        break;
      case "transfer":
        this.onUpdateTransferTable(selectedItems, item);
        break;
      case "destroy":
        this.onUpdateOrderStatus(selectedItems, STATUS.DESTROY);
        break;
      case "change":
        this.changeOrders();
        break;
      default:
        break;
    }
  }

  changeOrders = () => {
    const { itemsDone, selectedItemsDone } = this.state;

    // Safeguard: check if data exists
    if (!itemsDone?.length || !selectedItemsDone?.length) {
      console.warn("changeOrders: itemsDone or selectedItemsDone is empty");
      return;
    }

    let itemsChange = [];
    for (let i = 0; i < selectedItemsDone.length; i++) {
      const foundItem = itemsDone.find(
        (item) => item.id === selectedItemsDone[i],
      );
      if (foundItem) {
        // Normalize the item to have required properties for ListOrders component
        const normalizedItem = {
          ...foundItem,
          // Ensure 'name' property exists at root level (ListOrders expects order.name or order.product.name)
          name: foundItem.name || foundItem.product?.name || "Unknown",
          // Ensure 'price' is a number
          price: parseFloat(foundItem.price) || 0,
          // Ensure 'count' exists and is a number
          count: parseInt(foundItem.count) || 1,
        };
        itemsChange.push(normalizedItem);
      }
    }

    if (itemsChange.length === 0) {
      console.warn("changeOrders: No matching items found");
      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      itemsChange,
      _itemsChange: itemsChange,
    }));
  };

  getDiscountTaxFee = () => {
    let tokenStr = localStorage.getItem("access_token");

    // console.log('discount_tax_fee: !!!');
    return axios
      .get(`${END_POINT + "/order/discount_tax_fee"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        // console.log('discount_tax_fee: ', data);
        // this.setState({
        //     discount_tax_fee: data.data,
        // });
        // return data.data;
      })
      .catch((err) => {
        return false;
      });
  };

  onToggleDetail = async ({ product, name, value }) => {
    // toggle hiển thị hoặc không
    if (name === "detailDisplay") {
      product[name] = !product[name];
    } else if (name === "orderDisplay") {
      product[name] = !product[name];
    }

    // check vào các giá trị size, topping, ice, sugar
    else {
      let _value = value;

      // size và topping thì cho mảng các giá trị
      // Vì Topping thì có thể mix nhiều loại
      // Size thì luôn luôn required 1 loại
      if (
        name === "sizeSelectedId" ||
        name === "flavorSelectedId" ||
        name === "toppingSelectedId"
      ) {
        if (name === "sizeSelectedId" || name === "flavorSelectedId") {
          // Safeguard: Kiểm tra product.size tồn tại
          const optionList =
            name === "sizeSelectedId" ? product.size : product.flavor;
          const selectedItem = optionList?.find((p) => p.id === _value);
          if (selectedItem && name === "sizeSelectedId") {
            product.sizeName = selectedItem.name;
            product.sizeValue = Number(selectedItem.value);
          }
          if (selectedItem && name === "flavorSelectedId") {
            product.flavorName = selectedItem.name;
            product.flavorValue =
              parseFloat(selectedItem.promo_price) > 0
                ? selectedItem.promo_price
                : selectedItem.value;
          }
          _value = [_value];
        } else if (name === "toppingSelectedId") {
          // Safeguard: Khởi tạo mảng nếu chưa tồn tại
          if (!Array.isArray(product[name])) {
            product[name] = [];
          }

          // Kiểm tra xem value đã có trong mảng chưa
          if (product[name].includes(value)) {
            // Bỏ chọn topping
            _value = product[name].filter((_item) => _item !== value);
          } else {
            // Thêm topping mới
            product[name].push(_value);
            _value = product[name];
          }
        }
      }

      product[name] = _value;

      // Lấy danh sách các giá trị 'value' từ mảng 'topping' dựa trên 'id' trong 'toppingSelectedId'
      // Chỉ xử lý khi toppingSelectedId là một mảng hợp lệ
      if (
        Array.isArray(product.toppingSelectedId) &&
        product.toppingSelectedId.length > 0
      ) {
        const selectedToppingsName = product.toppingSelectedId.map(
          (selectedId) => {
            const topping = product.topping?.find(
              (item) => item.id === selectedId,
            );
            return topping ? topping.name : null;
          },
        );
        const selectedToppingsValue = product.toppingSelectedId.map(
          (selectedId) => {
            const topping = product.topping?.find(
              (item) => item.id === selectedId,
            );
            if (!topping) return null;
            // Use promo_price if available (discounted topping)
            if (topping.promo_price && parseFloat(topping.promo_price) > 0) {
              return topping.promo_price;
            }
            return topping.value;
          },
        );
        product.toppingName = selectedToppingsName;
        product.toppingValue = selectedToppingsValue;
      }
    }

    this.filterOrders();
    // await this.onClickImage(product, 'nonePlusCount');
    // }
  };

  onClickImage = async (product, plus, quantity = 1) => {
    // Cho phép cashier thêm sản phẩm mà không cần kiểm tra quyền
    const isCashierPage = window.location.pathname.startsWith("/cashier");
    if (!isCashierPage && !isRorF("orders_table")) return false;

    const parsedQuantity = parseInt(quantity, 10);
    const quantityToAdd =
      Number.isNaN(parsedQuantity) || parsedQuantity < 1 ? 1 : parsedQuantity;

    if (
      Array.isArray(product.flavor) &&
      product.flavor.length > 0 &&
      (!Array.isArray(product.flavorSelectedId) ||
        product.flavorSelectedId.length === 0)
    ) {
      NotificationManager.warning("Vui lòng chọn vị trước khi gọi món");
      product.detailDisplay = true;
      this.setState((prev) => ({ ...prev }));
      return false;
    }

    const selected = product?.selectedAttributes ?? {};
    const variantsList = product?.variants ?? [];

    // Lấy danh sách các key từ selectedAttributes -> ["size", "color", "material"]
    const attributeKeys = Object.keys(selected);

    let foundVariant; // Khai báo biến trước

    // Thêm điều kiện kiểm tra attributeKeys có rỗng không
    if (attributeKeys.length > 0) {
      foundVariant = variantsList.find((variant) => {
        return attributeKeys.every((key) => {
          // Dùng `?.` để truy cập an toàn vào `attributes` của từng variant
          return variant?.attributes?.[key]?.value === selected[key].value;
        });
      });
    }

    // Gán SKU (cách viết ngắn gọn hơn)
    const id_variant = foundVariant ? foundVariant.id : null;

    const equar = (a, b) => {
      if (a.length !== b.length) {
        return false;
      } else {
        for (let i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) {
            return false;
          }
        }
        return true;
      }
    };
    const size = product?.selectedAttributes?.size?.label;
    const color = product?.selectedAttributes?.color?.label;
    const material = product?.selectedAttributes?.material?.label;

    // Xác định xem đang thêm gift hay regular item
    const isAddingGift = plus === "gift";

    // F&B Auto-select smallest size logic (Cafe/Restaurant)
    // Nếu sản phẩm có size set nhưng chưa chọn, mặc định chọn size nhỏ nhất
    if (
      (!product.variants || product.variants.length === 0) &&
      product.size &&
      product.size.length > 0 &&
      (!product.sizeSelectedId || product.sizeSelectedId.length === 0)
    ) {
      // Sort size by value (price) ascending
      const sortedSizes = [...product.size].sort(
        (a, b) => parseFloat(a.value) - parseFloat(b.value),
      );
      if (sortedSizes.length > 0) {
        const smallestSize = sortedSizes[0];
        // Set default selection
        product.sizeSelectedId = [smallestSize.id];
        // Update sizeName logic for grouping (find_order)
        product.sizeName = smallestSize.name;
        // console.log("[AutoSelect] Defaulted to smallest size:", smallestSize.name);
      }
    }

    // Find Order - QUAN TRỌNG: Gift items (price=0) KHÔNG được merge với regular items
    const find_order = this.state.orders.find((_product) => {
      // Kiểm tra sản phẩm cùng id và các thuộc tính
      const basicMatch =
        (_product.priceType || "retail") === (product.priceType || "retail") &&
        _product.size === size &&
        _product.color === color &&
        _product.material === material &&
        _product.iceSelectedValue === product.iceSelectedValue &&
        _product.sugarSelectedValue === product.sugarSelectedValue &&
        _product.sizeName === product.sizeName &&
        _product.flavorName === product.flavorName &&
        (product.toppingName
          ? equar(_product.toppingName, product.toppingName)
          : _product.toppingName === product.toppingName) &&
        _product.id === product.id;

      if (!basicMatch) return false;

      // QUAN TRỌNG: Chỉ merge nếu cả 2 cùng là gift hoặc cùng là regular
      const existingIsGift = parseFloat(_product.price) === 0;

      // Gift chỉ merge với gift, regular chỉ merge với regular
      return isAddingGift === existingIsGift;
    });

    // === XÁC ĐỊNH GIÁ (Price Determination) ===
    // Ưu tiên: foundVariant price > product.price_sale (nếu sale) > product.price
    let price;

    const bt = String(product.business_type || "")
      .toLowerCase()
      .trim();
    const isFnB = bt === "cafe" || bt === "restaurant";

    if (!isFnB && product.priceType === "wholesale") {
      if (foundVariant) {
        price = parseFloat(foundVariant.price_wholesale) || 0;
      } else {
        price = parseFloat(product.price_wholesale) || 0;
      }
    } else if (foundVariant) {
      // Sản phẩm có variant (thời trang/retail): lấy giá từ variant đã match
      const variantPromo = parseFloat(foundVariant.promo_price);
      const variantPrice = parseFloat(foundVariant.price);
      if (!isNaN(variantPromo) && variantPromo > 0) {
        price = variantPromo;
      } else if (!isNaN(variantPrice)) {
        price = variantPrice;
      } else {
        price = parseFloat(product.price) || 0;
      }
    } else if (product.active_sale) {
      // Sản phẩm đơn giản đang sale: dùng giá sale (với fallback an toàn)
      const saleParsed = parseFloat(product.price_sale);
      price =
        !isNaN(saleParsed) && saleParsed > 0
          ? saleParsed
          : parseFloat(product.price) || 0;
    } else {
      // Sản phẩm đơn giản không sale: dùng giá gốc
      price = parseFloat(product.price) || 0;
    }

    let category_id = product.category.id;

    // size (FnB: product.size settings)
    if (product.sizeSelectedId.length) {
      const find_size = product.size.find((_size) =>
        product.sizeSelectedId.includes(_size.id),
      );
      if (find_size) {
        if (find_size.promo_price && parseFloat(find_size.promo_price) > 0) {
          price = parseFloat(find_size.promo_price);
        } else {
          price = parseFloat(find_size.value) || price;
        }
      }
    }

    if (product.flavorSelectedId?.length) {
      const findFlavor = product.flavor?.find((flavor) =>
        product.flavorSelectedId.includes(flavor.id),
      );
      if (findFlavor) {
        const flavorPrice =
          parseFloat(findFlavor.promo_price) > 0
            ? parseFloat(findFlavor.promo_price)
            : parseFloat(findFlavor.value) || 0;
        price = parseFloat(price) + flavorPrice;
      }
    }

    // topping
    if (product.toppingSelectedId.length) {
      const find_topping = product.topping.filter((_size) =>
        product.toppingSelectedId.includes(_size.id),
      );

      for (let i = 0; i < find_topping.length; i++) {
        // Use promo_price if available (discounted topping), same pattern as size
        const toppingPrice =
          find_topping[i].promo_price &&
          parseFloat(find_topping[i].promo_price) > 0
            ? parseFloat(find_topping[i].promo_price)
            : parseFloat(find_topping[i].value);
        price = parseFloat(price) + toppingPrice;
      }
    }

    // === Safety Net: đảm bảo price luôn là số hợp lệ ===
    if (isNaN(price) || price === null || price === undefined) {
      console.warn(
        "[onClickImage] Price was NaN/null, falling back to 0. Product:",
        product.name,
      );
      price = 0;
    }

    // Update giá tiền nếu đã tồn tại
    if (find_order) {
      const orders = this.state.orders.map((o) => {
        // Kiểm tra match cơ bản
        const basicMatch =
          o.size === find_order.size &&
          o.color === find_order.color &&
          o.material === find_order.material &&
          o.iceSelectedValue === find_order.iceSelectedValue &&
          o.sugarSelectedValue === find_order.sugarSelectedValue &&
          o.sizeName === find_order.sizeName &&
          o.flavorName === find_order.flavorName &&
          o.toppingName === find_order.toppingName &&
          o.id === find_order.id;

        if (!basicMatch) return o;

        // QUAN TRỌNG: Chỉ update nếu cùng loại (gift với gift, regular với regular)
        const existingIsGift = parseFloat(o.price) === 0;
        if (isAddingGift !== existingIsGift) return o;

        // Đúng item để update
        return {
          ...o,
          product: {
            name: product.name,
            price: price,
            category_id,
            sale_unit: product.sale_unit,
          },
          unit: product.sale_unit,
          count: plus === "nonePlusCount" ? 1 : o.count + quantityToAdd,
          price: plus === "gift" ? 0 : price,
          priceType: product.priceType || "retail",
          id_variant: id_variant || null,
          selectedAttributes: product.selectedAttributes, // Update attributes if they change context
          sizeSettings: product.size,
          flavorSettings: product.flavor,
          toppingSettings: product.topping,
          variants: product.variants || o.variants || [],
        };
      });
      await this.setState({ orders });
      this.filterOrders();
    } else {
      let orders = this.state.orders;

      orders.push({
        id: product.id,
        priceType: product.priceType || "retail",
        product: {
          name: product.name,
          price:
            plus === "gift"
              ? 0
              : typeof price === "string"
                ? parseFloat(price)
                : price,
          category_id,
          sale_unit: product.sale_unit,
          tax_rate: parseFloat(product.tax_rate) || 0,
        },
        unit: product.sale_unit,
        id_variant: id_variant || null,
        name: product.name,
        tax_rate: parseFloat(product.tax_rate) || 0,
        price:
          plus === "gift"
            ? 0
            : typeof price === "string"
              ? parseFloat(price)
              : price,
        count: plus === "nonePlusCount" ? 1 : quantityToAdd,
        note: product.note,
        size: size !== "" ? size : "",
        color: color !== "" ? color : "",
        material: material !== "" ? material : "",
        iceSelectedValue: product.iceSelectedValue,
        sugarSelectedValue: product.sugarSelectedValue,
        sizeSelectedId: product.sizeSelectedId,
        sizeName: product.sizeName,
        sizeValue: product.sizeValue,
        flavorSelectedId: product.flavorSelectedId,
        flavorName: product.flavorName,
        flavorValue: product.flavorValue,
        toppingSelectedId: product.toppingSelectedId,
        toppingName: product.toppingName,
        toppingValue: product.toppingValue,
        previewDisplay: false,
        selectedAttributes: product.selectedAttributes, // Pass all selected attributes
        sizeSettings: product.size, // Pass definitions for dynamic lookup
        flavorSettings: product.flavor,
        toppingSettings: product.topping, // Pass definitions for dynamic lookup
        variants: product.variants || [], // Pass variants for fashion/retail price lookup
      });
      await this.setState({ orders });
      this.filterOrders();
    }

    // Xóa ô tìm kiếm khi người dùng chọn 1 item
    this.props.updateSearchKeyword("");

    await this.setState((prev) => ({
      ...prev,
      billDate: getDateWithFormat(),
    }));
    this.renderLengthBill();

    // Chỉ gọi fetchAvailablePromotions khi thêm sản phẩm thường, KHÔNG gọi khi thêm gift
    // Vì khi thêm gift từ handleSubmitModalDiscountTaxFee, discount_form đã được set đúng
    if (plus !== "gift") {
      await this.fetchAvailablePromotions();
      this.fetchProductSuggestions();
    }

    // Accept scroll body
    document.body.classList.remove("noscroll");
    document.body.classList.remove("modal-open");
  };

  filterOrders = async () => {
    const { orders } = this.state;
    await this.setState((prev) => ({
      ...prev,
      ordersFiltered: this.consolidateOrders(orders),
    }));
  };

  consolidateOrders = (orders) => {
    const consolidatedOrders = {};

    orders.forEach((order) => {
      const key = `${order.product_id}-${order.status_id}-${order.ice}-${order.sugar}-${order.size}-${order.flavor}-${order.topping}`;

      if (!consolidatedOrders[key]) {
        consolidatedOrders[key] = {
          ...order,
          count: 1,
        };
      } else {
        consolidatedOrders[key].count += 1;
      }
    });

    return Object.values(consolidatedOrders);
  };

  renderLengthBill = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/bill/length_bill"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err?.response?.data?.responseText);
        return false;
      });
  };

  // getOrders = () => {
  //     let childelement = this.ChildElement.current;
  //     let listOrders = childelement?.state?.orders;
  //     return this.setState({ orders: listOrders });
  // };

  calTotalPrice = (orders) => {
    let total = 0;
    for (let i = 0; i < orders.length; i++) {
      let order = orders[i];

      total += parseInt(order.price) * order.count;
    }
    return total;
  };

  toggleDebtWarningModal = () => {
    this.setState({
      debtWarningModalOpen: !this.state.debtWarningModalOpen,
      isSubmitting: false,
    });
  };

  handleConfirmDebtOverLimit = () => {
    const nextPayment = this.state.pendingPaymentAction;
    this.setState(
      {
        debtWarningModalOpen: false,
        bypassDebtLimit: true,
      },
      () => {
        this.handleSubmit(nextPayment);
      },
    );
  };

  onChangeShippingCarrier = (value) => {
    this.setState(
      {
        shipping_provider: value,
        is_shipping: !!value,
        isShippingModalOpen: !!value, // Auto open modal when carrier selected
      },
      () => {
        if (value) {
          this.setState({
            shipping_receiver_name: this.state.customer_name || "",
            shipping_receiver_phone: this.state.customer_phone || "",
            shipping_cod: this.state.paymentMethod === "cash",
            shipping_cod_amount: this.calTotalPrice(this.state.orders),
            shipping_free: false,
            shipping_weight: 500,
            shipping_length: 20,
            shipping_width: 20,
            shipping_height: 10,
            shipping_note: "Giao hàng từ VMASS",
            shipping_required_note: "CHOXEMHANGKHONGTHU",
          });
          this.fetchProvinces(value);
        } else {
          // Reset shipping data if no provider selected
          this.setState({
            shipping_fee: 0,
            receiver_province: null,
            receiver_district: null,
            receiver_ward: null,
            shipping_receiver_name: "",
            shipping_receiver_phone: "",
            shipping_cod: false,
            shipping_cod_amount: 0,
            shipping_free: false,
            shipping_weight: 500,
            shipping_length: 20,
            shipping_width: 20,
            shipping_height: 10,
            shipping_note: "",
            shipping_required_note: "",
          });
        }
      },
    );
  };

  toggleShippingModal = () => {
    this.setState((prevState) => {
      const willOpen = !prevState.isShippingModalOpen;
      const updates = { isShippingModalOpen: willOpen };
      if (willOpen) {
        updates.shipping_receiver_name =
          prevState.shipping_receiver_name || prevState.customer_name || "";
        updates.shipping_receiver_phone =
          prevState.shipping_receiver_phone || prevState.customer_phone || "";
        updates.shipping_cod = prevState.paymentMethod === "cash";
        updates.shipping_cod_amount = this.calTotalPrice(prevState.orders);

        if (
          prevState.shipping_weight === undefined ||
          prevState.shipping_weight === null
        )
          updates.shipping_weight = 500;
        if (
          prevState.shipping_length === undefined ||
          prevState.shipping_length === null
        )
          updates.shipping_length = 20;
        if (
          prevState.shipping_width === undefined ||
          prevState.shipping_width === null
        )
          updates.shipping_width = 20;
        if (
          prevState.shipping_height === undefined ||
          prevState.shipping_height === null
        )
          updates.shipping_height = 10;
        if (
          prevState.shipping_note === undefined ||
          prevState.shipping_note === null
        )
          updates.shipping_note = "Giao hàng từ VMASS";
        if (
          prevState.shipping_required_note === undefined ||
          prevState.shipping_required_note === null
        )
          updates.shipping_required_note = "CHOXEMHANGKHONGTHU";
        if (
          prevState.shipping_free === undefined ||
          prevState.shipping_free === null
        )
          updates.shipping_free = false;
      }
      return updates;
    });
  };

  toggleAddProductModal = () => {
    this.setState((prevState) => ({
      isAddProductModalOpen: !prevState.isAddProductModalOpen,
    }));
  };

  onChange = (e) => {
    if (e.target) {
      const {
        target: { name, value },
      } = e;

      this.setState(
        (prev) => ({
          ...prev,
          [name]: value,
          ...(name === "customer_name" || name === "customer_phone"
            ? {
                selectedCustomerId: null,
                customer_debt: 0,
                customer_debt_limit: 0,
                isDebtLimitConfirmed: false,
              }
            : {}),
        }),
        () => {
          this.findCustomer();
          // Gọi fetchAvailablePromotions sau khi state đã cập nhật xong
          if (name === "customer_phone") {
            this.fetchAvailablePromotions();
          }
        },
      );

      const trimmedValue = value.trim();
      const isCustomerSuggestionField =
        name === "customer_name" || name === "customer_phone";
      const minLength = name === "customer_phone" ? 4 : 2;

      if (isCustomerSuggestionField && trimmedValue.length >= minLength) {
        this.fetchSuggestions(trimmedValue, name);
      } else if (isCustomerSuggestionField) {
        clearTimeout(this.debounceTimer);
        this.setState({
          suggestions: [],
          isLoadingCustomer: false,
          customerSuggestionField: name,
        });
      }
    }
  };

  fetchSuggestions = (keyword, sourceField = "customer_phone") => {
    clearTimeout(this.debounceTimer);

    const trimmedKeyword = keyword.trim();

    if (!trimmedKeyword) {
      this.setState({
        suggestions: [],
        isLoadingCustomer: false,
        customerSuggestionField: sourceField,
      });
      return;
    }

    this.debounceTimer = setTimeout(() => {
      this.setState({
        isLoadingCustomer: true,
        customerSuggestionField: sourceField,
      });

      let tokenStr = localStorage.getItem("access_token");
      axios
        .get(
          `${END_POINT + "/customer/search"}?keyword=${encodeURIComponent(
            trimmedKeyword,
          )}`,
          {
            headers: { Authorization: `Bearer ${tokenStr}` },
          },
        )
        .then((res) => {
          const response = res.data; // Lấy dữ liệu từ res.data
          if (
            response &&
            response.status === 200 &&
            Array.isArray(response.data)
          ) {
            const suggestionsList = response.data;
            this.setState({ suggestions: suggestionsList });

            if (
              sourceField === "customer_phone" &&
              trimmedKeyword.replace(/\D/g, "").length >= 9
            ) {
              const cleanKeyword = trimmedKeyword.replace(/\D/g, "");
              const exactMatch = suggestionsList.find((c) => {
                const cPhone = (c && c.phone ? String(c.phone) : "")
                  .trim()
                  .replace(/\D/g, "");
                return cPhone && cPhone === cleanKeyword;
              });

              if (exactMatch) {
                this.setState({
                  selectedCustomerId: exactMatch.id || null,
                  customer_debt: exactMatch.debt || 0,
                  customer_debt_limit: exactMatch.debt_limit || 0,
                });
              } else {
                this.setState({
                  selectedCustomerId: null,
                  customer_debt: 0,
                  customer_debt_limit: 0,
                });
              }
            }
          } else {
            this.setState({ suggestions: [] });
            console.error("API response error:", response.responseText);
          }
        })
        .catch((error) => {
          // Xử lý lỗi chi tiết hơn
          if (error.response) {
            console.error("API Error:", error.response.data);
          } else {
            console.error("Network or other error:", error.message);
          }
          this.setState({ suggestions: [] });
        })
        .finally(() => {
          this.setState({ isLoadingCustomer: false });
        });
    }, 200);
  };

  // Phương thức xử lý khi người dùng click vào một gợi ý
  handleSuggestionClick = async (customer) => {
    await this.setState({
      selectedCustomerId: customer.id || null,
      customer_name: customer.name,
      customer_phone: customer.phone,
      receiver_address: customer.address || "",
      customer_debt: customer.debt || 0,
      customer_debt_limit: customer.debt_limit || 0,
      suggestions: [], // Ẩn danh sách gợi ý
    });
    await this.fetchAvailablePromotions();
  };

  handleSubmit = async (payment) => {
    // Guard: chống double-click / double-submit
    if (this.state.isSubmitting) return;

    // Guard: Chốt ca - kiểm tra ca làm việc
    if (this.state.shift_required && !this.state.is_shift_open) {
      NotificationManager.error(
        "Vui lòng mở ca trước khi bán hàng",
        "",
        5000,
        null,
        null,
        "filled",
      );
      return;
    }

    this.setState({ isSubmitting: true });
    const {
      orders,
      refund_to_customer,
      customer_name,
      customer_phone,
      isChecked,
      info_table,
      store,
      hash,
      table_id,
      paymentMethod,
      receiver_address,
    } = this.state;

    const totalPriceDebt = this.calTotalPrice(orders);
    const hasCustomerInfo =
      Boolean((customer_name || "").trim()) ||
      Boolean((customer_phone || "").trim()) ||
      Boolean((receiver_address || "").trim());

    if (!orders.length) {
      this.setState({ isSubmitting: false });
      return NotificationManager.warning(
        "Vui lòng chọn sản phẩm để đặt hàng",
        "",
        3000,
        null,
        null,
        "filled",
      );
    }

    if ((refund_to_customer > 0 || isChecked) && !hasCustomerInfo) {
      this.setState({ isSubmitting: false });
      return NotificationManager.warning(
        "Cần thêm thông tin của khách hàng để ghi nhận công nợ",
        isChecked === true
          ? `Số tiền khách nợ: ${AddCommaNumber(totalPriceDebt)}`
          : `Số tiền khách nợ: ${AddCommaNumber(refund_to_customer)}`,
        5000,
        null,
        null,
        "filled",
      );
    }

    const isCreditOrder = isChecked === true || paymentMethod === "credit";
    const currentOrderDebt = isCreditOrder
      ? totalPriceDebt
      : refund_to_customer > 0
        ? refund_to_customer
        : 0;

    const priorDebt = parseFloat(this.state.customer_debt) || 0;
    const debtLimit = parseFloat(this.state.customer_debt_limit) || 0;
    const totalDebtAfter = priorDebt + currentOrderDebt;

    if (
      currentOrderDebt > 0 &&
      debtLimit > 0 &&
      totalDebtAfter > debtLimit &&
      !this.state.bypassDebtLimit
    ) {
      this.setState({
        isSubmitting: false,
        debtWarningModalOpen: true,
        pendingPaymentAction: payment,
      });
      return;
    }

    if (this.state.bypassDebtLimit) {
      this.setState({ bypassDebtLimit: false });
    }

    // Re-validate promotions before checkout
    const { selected_promotions } = this.state;
    if (selected_promotions && selected_promotions.length > 0) {
      try {
        let tokenCheck = localStorage.getItem("access_token");
        const cartData = orders.map((item) => ({
          id: item.id,
          quantity: item.count || 1,
          price: parseFloat(item.price) || 0,
          category_id: item.category ? item.category.id : null,
        }));
        const validateRes = await axios.post(
          `${END_POINT}/promotion/validate-checkout`,
          {
            promotionIds: selected_promotions.map((p) => p.id),
            cartData,
            customerPhone: customer_phone || null,
          },
          { headers: { Authorization: `Bearer ${tokenCheck}` } },
        );
        if (validateRes.data && !validateRes.data.valid) {
          const invalidNames = validateRes.data.invalidPromotions
            .map((p) => `${p.name || "KM #" + p.id}: ${p.message}`)
            .join(", ");
          this.setState({ isSubmitting: false });
          return NotificationManager.error(
            `Khuyến mại không còn hợp lệ: ${invalidNames}`,
            "",
            5000,
            null,
            null,
            "filled",
          );
        }
      } catch (err) {
        console.error("Lỗi validate khuyến mại:", err);
        // Allow checkout to proceed if validation service fails
      }
    }

    let tokenStr = localStorage.getItem("access_token");
    const is_updating_provisional =
      this.state.provisionalBillIds && this.state.provisionalBillIds.length > 0;

    if (info_table === "" || payment) {
      return await axios
        .post(
          `${END_POINT + "/bill/guest_order_done"}`,
          {
            deleted_orders: this.state.deletedProvisionalItems,
            pin: is_updating_provisional ? this.state.currentPin : "",
            pin_print: is_updating_provisional
              ? this.state.currentPinPrint
              : "",
            data: orders,
            store: store,
            phone: customer_phone,
            name: customer_name,
            address: this.state.receiver_address || "",
            hash: hash || "",
            table_id:
              (info_table && info_table.item && info_table.item.id) ||
              table_id ||
              "",
            paid: payment,
            payment_method: paymentMethod,
            staff_id: this.state.selectedStaff || null,
            discount: this.state.discount_form,
            tax_fee: this.state.tax_fee,
            shipping_fee: this.state.shipping_fee,
            fee_other: {
              ...this.state.fee_other,
              label: normalizeFeeOtherLabel(this.state.fee_other?.label),
            },
            date: this.state.customOrderDate
              ? moment(this.state.customOrderDate).format("YYYY-MM-DD")
              : undefined,
          },
          { headers: { Authorization: `Bearer ${tokenStr}` } },
        )
        .then(async (res) => {
          return res.data;
        })
        .then(async (data) => {
          // console.log('data: ', data);
          const { bill_id } = data;

          if (bill_id) {
            try {
              const key = "localPrintCompletedBills";
              const completed = JSON.parse(localStorage.getItem(key) || "[]");
              if (!completed.includes(bill_id)) {
                localStorage.setItem(
                  key,
                  JSON.stringify([bill_id, ...completed].slice(0, 200)),
                );
              }
            } catch (e) {
              console.error("Error saving completed bill ID:", e);
            }
          }

          // If this order came from a provisional invoice, the server logic (CreateGuestOrderDone)
          // handles updating the status to PAYMENTED/COMPLETED/PENDING based on settings.
          // We do NOT manualy set it to 2223 (CANCEL) anymore.
          if (
            this.state.provisionalBillIds &&
            this.state.provisionalBillIds.length > 0
          ) {
            // Clear the IDs so they don't get reused
            this.setState({
              provisionalBillIds: [],
              deletedProvisionalItems: [],
              currentPin: null,
              currentPinPrint: null,
            });
          } else {
            this.setState({
              deletedProvisionalItems: [],
              currentPin: null,
              currentPinPrint: null,
            });
          }

          NotificationManager.primary(
            data.responseText,
            "",
            3000,
            null,
            null,
            "filled",
          );

          // Thông báo phụ khi có chiết khấu/thuế/phí được tạo
          const appliedExtras = [];
          if (this.state.discount_form.saved && this.state.discount_form.value)
            appliedExtras.push("chiết khấu");
          if (this.state.tax_fee.saved && this.state.tax_fee.value)
            appliedExtras.push("thuế phí");
          if (this.state.fee_other.saved && this.state.fee_other.value)
            appliedExtras.push("phụ phí");
          if (appliedExtras.length > 0) {
            NotificationManager.primary(
              `Đã áp dụng ${appliedExtras.join(", ")} thành công`,
              "",
              3000,
              null,
              null,
              "filled",
            );
          }
          this.socket.emit("refresh-bestseller", {
            user_id: localStorage.getItem("user_id"),
            type: localStorage.getItem("selectedDropdownBestSeller"),
          });
          this.socket.emit("refresh-recent-order", {
            user_id: localStorage.getItem("user_id"),
            floor: 0,
          });

          // Cập nhật stock sau khi có sản phẩm mới thanh toán
          this.socket.emit("refresh-stock", {
            user_id: localStorage.getItem("user_id"),
          });

          this.socket.emit("create logs", {
            user_id: localStorage.getItem("user_id"),
            message: LogsHelper["order-done"],
          });
          if (refund_to_customer > 0) {
            this.socket.emit("create logs", {
              user_id: localStorage.getItem("user_id"),
              message: LogsHelper["customer-debt-create"],
            });
          }
          this.socket.emit("refresh-pending-order", {
            user_id: localStorage.getItem("user_id"),
          });
          this.socket.emit("refresh-done-order", {
            user_id: localStorage.getItem("user_id"),
          });
          this.socket.emit("refresh-refund-order", {
            user_id: localStorage.getItem("user_id"),
          });
          this.socket.emit("alert-paymenter", {
            user_id: localStorage.getItem("user_id"),
          });
          // refresh alert data
          this.socket.emit("refresh-alert-data", {
            user_id: localStorage.getItem("user_id"),
          });

          // if ((name = 'paymented')) {
          //     this.socket.emit('create logs', {
          //         user_id: localStorage.getItem('user_id'),
          //         message: LogsHelper['invoice-print'],
          //     });
          // }

          //getIdOrders
          await this.updateStock(bill_id);

          // await this.getIdOrdersNow(bill_id);

          if (this.state.is_shipping) {
            await this.handleCreateShippingOrder(bill_id);
          }

          // SePay E-Invoice: Luôn gửi hóa đơn khi thanh toán nếu đã cấu hình
          // - Checkbox tick = Phát hành chính thức (is_draft: false)
          // - Checkbox không tick = Lưu nháp (is_draft: true)
          if (this.state.eInvoiceEnabled && payment !== "provisionalInvoice") {
            await this.handleIssueEInvoice(bill_id);
          }

          if (hasCustomerInfo && payment !== "provisionalInvoice") {
            this.createCustomerDone();
          }

          //invoices
          if (orders.length > 0) {
            this.dataOrdersRender();
          }

          // Record promotion usage (auto + manual)
          if (
            (this.state.selected_promotions &&
              this.state.selected_promotions.length > 0) ||
            (this.state.available_promotions &&
              this.state.available_promotions.some(
                (p) => p.benefit && p.benefit.actualDiscount > 0,
              ))
          ) {
            this.handleRecordPromotionUsage(bill_id);
          }

          await this.setState({
            orders: [],
            customer_name: "",
            customer_phone: "",
            selectedCustomerId: null,
            receiver_address: "",
            customer_debt: 0,
            customer_debt_limit: 0,
            isDebtLimitConfirmed: false,
            suggestions: [],
            info_table: "",
            table_id: "",
            selected_promotions: [],
            available_promotions: [],
            suggestionData: {
              frequently_bought: [],
              cross_category: [],
              upsell: {},
            },
            suggestionCacheKey: "",
            cashsPay: [],
            cashs: [
              { cash: 1000, quantity: 0 },
              { cash: 2000, quantity: 0 },
              { cash: 5000, quantity: 0 },
              { cash: 10000, quantity: 0 },
              { cash: 20000, quantity: 0 },
              { cash: 50000, quantity: 0 },
              { cash: 100000, quantity: 0 },
              { cash: 200000, quantity: 0 },
              { cash: 500000, quantity: 0 },
            ],
            modalOrderOpen: false,
            isChecked: false,
            paymentMethod: "cash",
            shippingCarrier: null,
            shipping_provider: null,
            is_shipping: false,
            shipping_fee: 0,
            shipping_receiver_name: "",
            shipping_receiver_phone: "",
            shipping_cod: false,
            shipping_cod_amount: 0,
            shipping_free: false,
            issueEInvoice:
              (this.state.eInvoiceConfig &&
                this.state.eInvoiceConfig.auto_issue) ||
              false,
            discount_form: {
              orders_id: [],
              user_id: "",
              note: "",
              value: "",
              type: "percent",
              saved: false,
              max: null,
              isManual: false,
            },
            tax_fee: {
              orders_id: [],
              user_id: "",
              note: "",
              value: "",
              type: "percent",
              calculation: "added",
              saved: false,
              isManual: false,
            },
            fee_other: {
              orders_id: [],
              user_id: "",
              label: "shipping",
              note: "",
              value: "",
              type: "percent",
              applyOn: "after_discount",
              saved: false,
              isManual: false,
            },
            customOrderDate: null,
          });

          // Refresh pin_print cho đơn hàng tiếp theo
          this.getAllOrders();
        })
        .catch((err) => {
          console.error("Lỗi khi tạo đơn hàng:", err);
          NotificationManager.error(
            err?.response?.data?.responseText ||
              "Có lỗi xảy ra khi tạo đơn hàng",
            "Lỗi !",
            3000,
            null,
            null,
            "filled",
          );
        })
        .finally(() => {
          this.setState({ isSubmitting: false });
        });
    } else {
      if (this.state.orders.length < 1) {
        this.setState({ isSubmitting: false });
        NotificationManager.error(
          "Chưa đặt sản phẩm. Thêm ít nhất 1 sản phẩm",
          "Lỗi !",
          3000,
          null,
          null,
          "filled",
        );
        return false;
      }

      // axios submit
      axios
        .post(`${END_POINT + "/bill/guest-pending"}`, {
          data: this.state.orders,
          store: window.location.host.split(".")[0],
          phone: this.state.customer_phone,
          name: this.state.customer_name,
          address: this.state.receiver_address || "",
          hash: info_table.item.user.companyMenuHash,
          table_id: info_table.item.id,
          payment_method: this.state.paymentMethod,
          staff_id: this.state.selectedStaff || null,
          discount: this.state.discount_form,
          tax_fee: this.state.tax_fee,
          shipping_fee: this.state.shipping_fee,
          fee_other: {
            ...this.state.fee_other,
            label: normalizeFeeOtherLabel(this.state.fee_other?.label),
          },
          date: this.state.customOrderDate
            ? moment(this.state.customOrderDate).format("YYYY-MM-DD")
            : undefined,
        })
        .then(async (res) => {
          // console.log('res: ', res.data);
          return res.data;
        })
        .then(async (data) => {
          const { bill_id } = data;

          if (bill_id) {
            try {
              const key = "localPrintCompletedBills";
              const completed = JSON.parse(localStorage.getItem(key) || "[]");
              if (!completed.includes(bill_id)) {
                localStorage.setItem(
                  key,
                  JSON.stringify([bill_id, ...completed].slice(0, 200)),
                );
              }
            } catch (e) {
              console.error("Error saving completed bill ID:", e);
            }
          }

          // If this order came from a provisional invoice, mark the original provisional items as Cancelled/Used (2223)
          if (
            this.state.provisionalBillIds &&
            this.state.provisionalBillIds.length > 0
          ) {
            let tokenStr = localStorage.getItem("access_token");
            await axios
              .put(
                `${END_POINT + "/order/status"}`,
                {
                  arrayId: this.state.provisionalBillIds,
                  status_id: 2223, // PROVISIONAL_INVOICE_CANCEL
                },
                { headers: { Authorization: `Bearer ${tokenStr}` } },
              )
              .catch((err) => {
                console.warn(
                  "Failed to update provisional invoice status:",
                  err,
                );
              });
            // Clear the IDs so they don't get reused
            this.setState({
              provisionalBillIds: [],
              deletedProvisionalItems: [],
              currentPin: null,
              currentPinPrint: null,
            });
          } else {
            this.setState({
              deletedProvisionalItems: [],
              currentPin: null,
              currentPinPrint: null,
            });
          }
          // console.log('data: ', data);
          NotificationManager.primary(
            data.responseText,
            "",
            3000,
            null,
            null,
            "filled",
          );

          // Thông báo phụ khi có chiết khấu/thuế/phí được tạo
          const appliedExtras2 = [];
          if (this.state.discount_form.saved && this.state.discount_form.value)
            appliedExtras2.push("chiết khấu");
          if (this.state.tax_fee.saved && this.state.tax_fee.value)
            appliedExtras2.push("thuế phí");
          if (this.state.fee_other.saved && this.state.fee_other.value)
            appliedExtras2.push("phụ phí");
          if (appliedExtras2.length > 0) {
            NotificationManager.primary(
              `Đã áp dụng ${appliedExtras2.join(", ")} thành công`,
              "",
              3000,
              null,
              null,
              "filled",
            );
          }

          // real-time
          this.socket.emit("refresh-bestseller", {
            user_id: localStorage.getItem("user_id"),
            type: localStorage.getItem("selectedDropdownBestSeller"),
          });
          this.socket.emit("refresh-recent-order", {
            user_id: localStorage.getItem("user_id"),
            floor: 0,
            user_identify: this.state.user_identify || "",
            table_id: this.state.table_id || "",
          });
          this.socket.emit("refresh-pending-order", {
            user_id: localStorage.getItem("user_id"),
          });
          this.socket.emit("refresh-done-order", {
            user_id: localStorage.getItem("user_id"),
          });
          this.socket.emit("refresh-refund-order", {
            user_id: localStorage.getItem("user_id"),
          });

          // refresh alert data
          this.socket.emit("refresh-alert-data", {
            user_id: localStorage.getItem("user_id"),
          });

          // Cập nhật stock sau khi có sản phẩm mới thanh toán
          this.socket.emit("refresh-stock", {
            user_id: localStorage.getItem("user_id"),
          });

          // // refresh alert data
          // this.socket.emit('refresh-alert-data', {
          //     user_id: localStorage.getItem('user_id'),
          // });

          // // re-mind order after 2 minutes
          // this.socket.emit('remind-created-orders', {
          //     data: this.state.orders,
          //     user_id: localStorage.getItem('user_id'),
          //     bill_id,
          // });

          // Accept scroll body
          document.body.classList.remove("noscroll");
          document.body.classList.remove("modal-open");

          //getIdOrders
          await this.updateStock(bill_id);

          // await this.getIdOrdersNow(bill_id);

          if (this.state.is_shipping) {
            await this.handleCreateShippingOrder(bill_id);
          }

          // Note: Unpaid guest-pending orders do NOT issue e-invoices (only issued when paid at guest_order_done)

          // Skip point accumulation for pending orders (table orders not yet paid)
          // if (customer_phone && customer_name) {
          //   this.createCustomerDone();
          // }

          //invoices
          if (orders.length > 0) {
            this.dataOrdersRender();
          }

          // Record promotion usage (auto + manual)
          if (
            (this.state.selected_promotions &&
              this.state.selected_promotions.length > 0) ||
            (this.state.available_promotions &&
              this.state.available_promotions.some(
                (p) => p.benefit && p.benefit.actualDiscount > 0,
              ))
          ) {
            this.handleRecordPromotionUsage(bill_id);
          }

          await this.setState({
            orders: [],
            customer_name: "",
            customer_phone: "",
            selectedCustomerId: null,
            receiver_address: "",
            customer_debt: 0,
            customer_debt_limit: 0,
            isDebtLimitConfirmed: false,
            selected_promotions: [],
            available_promotions: [],
            suggestionData: {
              frequently_bought: [],
              cross_category: [],
              upsell: {},
            },
            suggestionCacheKey: "",
            cashsPay: [],
            cashs: [
              { cash: 1000, quantity: 0 },
              { cash: 2000, quantity: 0 },
              { cash: 5000, quantity: 0 },
              { cash: 10000, quantity: 0 },
              { cash: 20000, quantity: 0 },
              { cash: 50000, quantity: 0 },
              { cash: 100000, quantity: 0 },
              { cash: 200000, quantity: 0 },
              { cash: 500000, quantity: 0 },
            ],
            modalOrderOpen: false,
            isChecked: false,
            info_table: "",
            paymentMethod: "cash",
            shippingCarrier: null,
            shipping_provider: null,
            is_shipping: false,
            shipping_fee: 0,
            shipping_receiver_name: "",
            shipping_receiver_phone: "",
            shipping_cod: false,
            shipping_cod_amount: 0,
            shipping_free: false,
            discount_form: {
              orders_id: [],
              user_id: "",
              note: "",
              value: "",
              type: "percent",
              saved: false,
              max: null,
              isManual: false,
            },
            tax_fee: {
              orders_id: [],
              user_id: "",
              note: "",
              value: "",
              type: "percent",
              calculation: "added",
              saved: false,
              isManual: false,
            },
            fee_other: {
              orders_id: [],
              user_id: "",
              label: "shipping",
              note: "",
              value: "",
              type: "percent",
              applyOn: "after_discount",
              saved: false,
              isManual: false,
            },
            customOrderDate: null,
          });

          // Refresh pin_print cho đơn hàng tiếp theo
          this.getAllOrders();
        })
        .catch((err) => {
          NotificationManager.error(
            err?.response?.data?.responseText,
            "Lỗi !",
            3000,
            null,
            null,
            "filled",
          );
        })
        .finally(() => {
          this.setState({ isSubmitting: false });
        });
    }
  };

  handleSubmitChange = async () => {
    const { customer_name, customer_phone, itemsChange, _itemsChange } =
      this.state;

    const idItemsChange = itemsChange.map((item) => item.id);
    let itemsRemove = _itemsChange.filter(
      (item) => !idItemsChange.includes(item.id),
    );
    const idItemsRemove = itemsRemove.map((item) => item.id);

    this.setState((prev) => ({
      ...prev,
      discount_form: {
        ...prev.discount_form,
        orders_id: idItemsChange,
      },
      tax_fee: {
        ...prev.tax_fee,
        orders_id: idItemsChange,
      },
      fee_other: {
        ...prev.fee_other,
        orders_id: idItemsChange,
      },
    }));

    // save discount
    if (this.state.discount_form.saved) {
      await this.handleSaveDiscount();
    }

    // save tax fee
    if (this.state.tax_fee.saved) {
      await this.handleSaveTaxFee();
    }

    // save fee other
    if (this.state.fee_other.saved) {
      await this.handleSaveFeeOther();
    }
    // const totalPriceDebt = this.calTotalPrice(orders);

    if (customer_phone && customer_name === "") {
      return NotificationManager.warning(
        "Hãy thêm tên của khách hàng",
        "",
        5000,
        null,
        null,
        "filled",
      );
    }

    if (customer_phone === "" && customer_name) {
      return NotificationManager.warning(
        "Hãy thêm số điện thoại của khách hàng",
        "",
        5000,
        null,
        null,
        "filled",
      );
    }

    // Skip point accumulation during order changes/updates
    // if (customer_phone && customer_name) {
    //   this.createCustomerDone();
    // }

    let tokenStr = localStorage.getItem("access_token");
    if (idItemsRemove?.length) {
      return await axios
        .put(
          `${END_POINT + "/order/change-order"}`,
          {
            itemsDelete: idItemsRemove,
          },
          { headers: { Authorization: `Bearer ${tokenStr}` } },
        )
        .then(async (res) => {
          return res.data;
        })
        .then(async (data) => {
          NotificationManager.primary(
            data.responseText,
            "",
            3000,
            null,
            null,
            "filled",
          );

          this.socket.emit("create logs", {
            user_id: localStorage.getItem("user_id"),
            message: LogsHelper["order-change"],
          });
          // this.socket.emit('refresh-pending-order', {
          //     user_id: localStorage.getItem('user_id'),
          // });
          this.socket.emit("refresh-done-order", {
            user_id: localStorage.getItem("user_id"),
          });

          await this.setState({
            itemsChange: [],
            _itemsChange: [],
            customer_name: "",
            customer_phone: "",
            selectedCustomerId: null,
            receiver_address: "",
            customer_debt: 0,
            customer_debt_limit: 0,
            isDebtLimitConfirmed: false,
            cashsPay: [],
            cashs: [
              { cash: 1000, quantity: 0 },
              { cash: 2000, quantity: 0 },
              { cash: 5000, quantity: 0 },
              { cash: 10000, quantity: 0 },
              { cash: 20000, quantity: 0 },
              { cash: 50000, quantity: 0 },
              { cash: 100000, quantity: 0 },
              { cash: 200000, quantity: 0 },
              { cash: 500000, quantity: 0 },
            ],
          });
        })
        .catch((err) => {});
    }
    await this.setState({
      itemsChange: [],
      _itemsChange: [],
      customer_name: "",
      customer_phone: "",
      selectedCustomerId: null,
      receiver_address: "",
      customer_debt: 0,
      customer_debt_limit: 0,
      isDebtLimitConfirmed: false,
      cashsPay: [],
      cashs: [
        { cash: 1000, quantity: 0 },
        { cash: 2000, quantity: 0 },
        { cash: 5000, quantity: 0 },
        { cash: 10000, quantity: 0 },
        { cash: 20000, quantity: 0 },
        { cash: 50000, quantity: 0 },
        { cash: 100000, quantity: 0 },
        { cash: 200000, quantity: 0 },
        { cash: 500000, quantity: 0 },
      ],
    });
  };

  createCustomerDone = () => {
    const {
      orders,
      itemsChange,
      customer_name,
      customer_phone,
      selectedCustomerId,
      refund_to_customer,
      discount_form,
      tax_fee,
      fee_other,
      receiver_address,
      // cashsPay,
    } = this.state;

    let items = itemsChange?.length ? itemsChange : orders;

    // Tính toán lại giá trị chính xác bằng các hàm helper đã có
    const total_discount_price = this.GetTotalDiscountPrice(
      items,
      discount_form,
    );
    const adjustmentPercentageBase = getPostDiscountSubtotal(
      this.calTotalPrice(items),
      total_discount_price,
    );
    const total_taxfee_price = this.GetTotalTaxFeePrice(
      items,
      tax_fee,
      adjustmentPercentageBase,
      discount_form,
    );
    const total_taxfee_payable =
      tax_fee && tax_fee.calculation === "included" ? 0 : total_taxfee_price;
    const feePercentageBase = getFeeApplicationBase(
      this.calTotalPrice(items),
      adjustmentPercentageBase,
      fee_other && fee_other.applyOn,
    );
    const total_fee_other_price = this.GetTotalFeeOtherPrice(
      items,
      fee_other,
      feePercentageBase,
    );

    const total_price_orders = this.calTotalPrice(items);

    // Tổng giá trị cuối cùng sau chiết khấu, thuế và phí
    const total_price =
      total_price_orders -
      total_discount_price +
      total_taxfee_payable +
      total_fee_other_price;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT + "/customer/create-order-done"}`,
        {
          customer_id: selectedCustomerId,
          name: customer_name,
          phone: customer_phone,
          email: "",
          address: receiver_address || "",
          point: total_price / 1000,
          armorial: "",
          used: 1,
          tags: [],
          debt: this.state.isChecked
            ? total_price
            : refund_to_customer > 0
              ? refund_to_customer
              : 0,
          dynamic_form: "",
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )

      .then((res) => {
        return res.data;
      })
      .then((data) => {
        NotificationManager.primary(
          data.responseText,
          "",
          3000,
          null,
          null,
          "filled",
        );
        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["customer-create"],
        });
      })
      .catch((err) => {
        NotificatioErrController("Có lỗi xảy ra khi tích điểm khách hàng");
      });
  };

  findCustomer = () => {
    const { customer_phone, data_customer } = this.state;
    const cleanPhone = (customer_phone || "").trim().replace(/\D/g, "");

    if (!data_customer || data_customer.length === 0) {
      let tokenStr = localStorage.getItem("access_token");
      axios
        .get(`${END_POINT + "/customer"}`, {
          headers: { Authorization: `Bearer ${tokenStr}` },
        })
        .then((res) => res.data)
        .then((data) => {
          const list = data.data || [];
          this.setState({ data_customer: list });
          if (cleanPhone.length >= 9) {
            const matched = list.find((c) => {
              const cPhone = (c && c.phone ? String(c.phone) : "")
                .trim()
                .replace(/\D/g, "");
              return cPhone && cPhone === cleanPhone;
            });
            if (matched) {
              this.setState({
                selectedCustomerId: matched.id || null,
                customer_name: this.state.customer_name || matched.name || "",
                receiver_address:
                  this.state.receiver_address || matched.address || "",
                customer_debt: matched.debt || 0,
                customer_debt_limit: matched.debt_limit || 0,
              });
            }
          }
        })
        .catch(() => {});
    }

    if (
      cleanPhone.length >= 9 &&
      Array.isArray(data_customer) &&
      data_customer.length > 0
    ) {
      const matchedCustomer = data_customer.find((c) => {
        const cPhone = (c && c.phone ? String(c.phone) : "")
          .trim()
          .replace(/\D/g, "");
        return cPhone && cPhone === cleanPhone;
      });

      if (matchedCustomer) {
        this.setState({
          selectedCustomerId: matchedCustomer.id || null,
          customer_name: this.state.customer_name || matchedCustomer.name || "",
          receiver_address:
            this.state.receiver_address || matchedCustomer.address || "",
          customer_debt: matchedCustomer.debt || 0,
          customer_debt_limit: matchedCustomer.debt_limit || 0,
        });
        return;
      }
    }

    this.setState({
      customer_debt: 0,
      customer_debt_limit: 0,
    });
  };

  getAllOrders = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/order/all"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        const orders = data.data || [];
        // Sử dụng giờ VN (UTC+7) để đồng bộ với server
        const m = this.state.customOrderDate
          ? moment(this.state.customOrderDate)
          : moment().utcOffset(7);
        const prefix = m.format("YYMMDD");

        let maxSeq = 0;
        for (const order of orders) {
          const pinStr = String(order.pin_print || "");
          if (pinStr.startsWith(prefix)) {
            const seq = parseInt(pinStr.substring(prefix.length), 10);
            if (!isNaN(seq) && seq > maxSeq) {
              maxSeq = seq;
            }
          }
        }

        const nextPinPrint = `${prefix}${maxSeq + 1}`;
        this.setState({ pin_print: nextPinPrint });
      })
      .catch((err) => {
        const m = this.state.customOrderDate
          ? moment(this.state.customOrderDate)
          : moment().utcOffset(7);
        this.setState({ pin_print: m.format("YYMMDD") + "1" });
      });
  };

  fetchConnectedProviders = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/shipping/connected`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ connected_providers: res.data.data });
          // No longer auto-select default provider - user must choose manually
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 403) {
          // Shipping not linked or no permission, ignore
          return;
        }
        console.error("fetchConnectedProviders error", err);
      });
  };

  fetchEInvoiceConfig = () => {
    const user_id = localStorage.getItem("b");
    axios
      .get(`${END_POINT}/api/einvoice/config?user_id=${user_id}`)
      .then((res) => {
        if (res.data && res.data.data && res.data.data.is_active) {
          const config = res.data.data;
          this.setState({
            eInvoiceEnabled: true,
            eInvoiceConfig: config,
            issueEInvoice: config.auto_issue || false,
          });
        }
      })
      .catch((err) => {
        // E-Invoice not configured, ignore
        console.log("E-Invoice not configured:", err.message);
      });
  };

  isOrderBackdated = (targetDate = this.state.customOrderDate) => {
    if (!targetDate) return false;
    return (
      moment(targetDate).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")
    );
  };

  onChangeIssueEInvoice = (checked) => {
    if (checked && this.isOrderBackdated()) {
      this.setState({
        eInvoiceBackdateWarningModalOpen: true,
      });
      return;
    }
    this.setState({ issueEInvoice: checked });
    if (checked) {
      this.toggleEInvoiceInfoModal();
    }
  };

  confirmIssueEInvoiceBackdate = () => {
    this.setState(
      {
        issueEInvoice: true,
        eInvoiceBackdateWarningModalOpen: false,
      },
      () => {
        this.toggleEInvoiceInfoModal();
      },
    );
  };

  cancelIssueEInvoiceBackdate = () => {
    this.setState({
      issueEInvoice: false,
      eInvoiceBackdateWarningModalOpen: false,
    });
  };

  handleChangeCustomOrderDate = (date) => {
    const isBackdate = this.isOrderBackdated(date);
    this.setState({ customOrderDate: date }, () => {
      this.getAllOrders();
      if (isBackdate && this.state.issueEInvoice) {
        this.setState({ eInvoiceBackdateWarningModalOpen: true });
      }
    });
  };

  handleResetCustomOrderDate = () => {
    this.setState({ customOrderDate: null }, () => {
      this.getAllOrders();
    });
  };

  toggleEInvoiceInfoModal = () => {
    this.setState((prevState) => {
      const nextState = {
        eInvoiceInfoModalOpen: !prevState.eInvoiceInfoModalOpen,
      };
      if (!prevState.eInvoiceInfoModalOpen) {
        if (!prevState.eInvoice_customer_name) {
          nextState.eInvoice_customer_name = "Bán cho người tiêu dùng";
        }
        if (!prevState.eInvoice_customer_phone && prevState.customer_phone) {
          nextState.eInvoice_customer_phone = prevState.customer_phone;
        }
      }
      return nextState;
    });
  };

  handleIssueEInvoice = async (bill_id) => {
    const tokenStr = localStorage.getItem("access_token");
    const user_id = localStorage.getItem("b");
    const {
      orders,
      customer_name,
      customer_phone,
      paymentMethod,
      discount_form,
      tax_fee,
      issueEInvoice,
      eInvoiceConfig,
      eInvoice_customer_name,
      eInvoice_customer_phone,
      eInvoice_customer_tax_id,
      eInvoice_customer_address,
      eInvoice_customer_email,
    } = this.state;

    // If user did not check the box to issue electronic invoice, do not issue
    if (!issueEInvoice) {
      console.log("[eInvoice] Skipped: Checkbox off");
      return;
    }

    // Calculate totals
    const subtotal = orders.reduce(
      (sum, item) => sum + item.price * item.count,
      0,
    );
    const discountAmount = discount_form?.saved
      ? parseFloat(discount_form.value) || 0
      : 0;
    const vatRate = tax_fee?.saved ? parseFloat(tax_fee.value) || 0 : 0;

    // Prepare items for SePay format
    const invoiceItems = orders.map((item, index) => ({
      line_number: index + 1,
      line_type: 1, // 1 = hàng hóa thông thường
      item_code: item.product_id || `SP${String(index + 1).padStart(3, "0")}`,
      item_name: item.product_name || item.name || "Sản phẩm",
      unit: item.unit || item.product?.sale_unit || "cái",
      quantity: item.count || 1,
      unit_price: item.price || 0,
    }));

    // Map payment method
    const paymentMethodMap = {
      cash: "TM", // Tiền mặt
      bank: "CK", // Chuyển khoản
      card: "CK", // Thẻ -> Chuyển khoản
      momo: "KHAC", // Ví điện tử
      default: "TM/CK", // Mặc định
    };

    try {
      const res = await axios.post(
        `${END_POINT}/api/einvoice/issue`,
        {
          user_id,
          bill_id,
          // Customer info
          customer_name:
            eInvoice_customer_name ||
            customer_name ||
            "Bán cho người tiêu dùng",
          customer_phone: eInvoice_customer_phone || customer_phone || "",
          customer_address: eInvoice_customer_address || "",
          customer_email: eInvoice_customer_email || "",
          customer_tax_id: eInvoice_customer_tax_id || "",
          // Invoice data
          subtotal: subtotal,
          discount_amount: discountAmount,
          vat_rate: vatRate,
          payment_method: paymentMethodMap[paymentMethod] || "TM/CK",
          items: invoiceItems,
          note: `Đơn hàng ${bill_id}`,
          invoice_date: moment().format("YYYY-MM-DD"),
          // Checked = Official (is_draft: false), Unchecked = Draft (is_draft: true)
          // Since we already filtered out the "Don't create" case above,
          // if we are here and issueEInvoice is false, it means we WANT a draft.
          is_draft: !issueEInvoice,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );

      if (res.data) {
        NotificatioSucController(
          res.data.message ||
            this.props.intl.formatMessage({ id: "einvoice.success.issued" }),
        );
        this.setState({
          eInvoice_customer_name: "Bán cho người tiêu dùng",
          eInvoice_customer_phone: "",
          eInvoice_customer_tax_id: "",
          eInvoice_customer_address: "",
          eInvoice_customer_email: "",
        });
      }
    } catch (err) {
      console.error("E-Invoice issue error:", err.response?.data || err);
      NotificatioErrController(
        err.response?.data?.responseText ||
          err.response?.data?.error ||
          this.props.intl.formatMessage({ id: "einvoice.error.issue-failed" }),
      );
    }
  };

  fetchProvinces = (provider) => {
    if (!provider) return;
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/shipping/provinces/${provider}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ provinces: res.data.data });
        }
      })
      .catch((err) => console.error("fetchProvinces error", err));
  };

  fetchDistricts = (provider, provinceId) => {
    if (!provider || !provinceId) return;
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/shipping/districts/${provider}/${provinceId}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            districts: res.data.data,
            receiver_district: null,
            receiver_ward: null,
            wards: [],
          });
        }
      })
      .catch((err) => console.error("fetchDistricts error", err));
  };

  fetchWards = (provider, districtId) => {
    if (!provider || !districtId) return;
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/shipping/wards/${provider}/${districtId}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ wards: res.data.data, receiver_ward: null });
        }
      })
      .catch((err) => console.error("fetchWards error", err));
  };

  handleCalculateFee = () => {
    const {
      shipping_provider,
      receiver_province,
      receiver_district,
      receiver_ward,
      shipping_weight,
      shipping_length,
      shipping_width,
      shipping_height,
      shipping_cod,
      shipping_cod_amount,
    } = this.state;

    if (!shipping_provider || !receiver_district) return;

    this.setState({ is_calculating_fee: true });
    let tokenStr = localStorage.getItem("access_token");

    const weight = parseInt(shipping_weight) || 500;
    const length = parseInt(shipping_length) || 20;
    const width = parseInt(shipping_width) || 20;
    const height = parseInt(shipping_height) || 10;
    const codValue = shipping_cod ? parseFloat(shipping_cod_amount) || 0 : 0;

    axios
      .post(
        `${END_POINT}/shipping/calculate-fee`,
        {
          provider: shipping_provider,
          to_province_id: receiver_province ? receiver_province.value : null,
          to_district_id: receiver_district.value,
          to_ward_code: receiver_ward ? receiver_ward.value : null,
          weight: weight,
          length: length,
          width: width,
          height: height,
          cod_value: codValue,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({ shipping_fee: res.data.data.fee });
        } else {
          NotificatioErrController(res.data.message || "Lỗi tính phí ship");
        }
      })
      .catch((err) => {
        console.error("Calculate fee error", err);
        NotificatioErrController("Lỗi kết nối API vận chuyển");
      })
      .finally(() => {
        this.setState({ is_calculating_fee: false });
      });
  };

  onChangeShipping = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    this.setState({ [name]: val }, () => {
      if (name === "shipping_provider") {
        this.fetchProvinces(val);
      }
    });
  };

  onSelectShippingAddress = (name, selectedOption) => {
    this.setState({ [name]: selectedOption }, () => {
      const { shipping_provider } = this.state;
      if (name === "receiver_province") {
        this.fetchDistricts(shipping_provider, selectedOption.value);
      } else if (name === "receiver_district") {
        this.fetchWards(shipping_provider, selectedOption.value);
        this.handleCalculateFee();
      } else if (name === "receiver_ward") {
        this.handleCalculateFee();
      }
    });
  };

  handleCreateShippingOrder = async (bill_id) => {
    const {
      shipping_provider,
      receiver_address,
      receiver_province,
      receiver_district,
      receiver_ward,
      shipping_receiver_name,
      shipping_receiver_phone,
      shipping_cod,
      shipping_cod_amount,
      shipping_free,
      shipping_weight,
      shipping_length,
      shipping_width,
      shipping_height,
      shipping_note,
      shipping_required_note,
      orders,
      shipping_fee,
    } = this.state;

    if (
      !shipping_provider ||
      !receiver_address ||
      !receiver_province ||
      !receiver_district ||
      !shipping_receiver_name ||
      !shipping_receiver_name.trim() ||
      !shipping_receiver_phone ||
      !shipping_receiver_phone.trim()
    ) {
      return NotificatioErrController(
        "Vui lòng nhập đầy đủ thông tin giao nhận hàng",
      );
    }

    let tokenStr = localStorage.getItem("access_token");
    const weight = parseInt(shipping_weight) || 500;
    const length = parseInt(shipping_length) || 20;
    const width = parseInt(shipping_width) || 20;
    const height = parseInt(shipping_height) || 10;
    const codValue = shipping_cod ? parseFloat(shipping_cod_amount) || 0 : 0;

    try {
      const res = await axios.post(
        `${END_POINT}/shipping/create-order`,
        {
          provider: shipping_provider,
          bill_id: bill_id,
          receiver_name: shipping_receiver_name.trim(),
          receiver_phone: shipping_receiver_phone.trim(),
          receiver_address: `${receiver_address}, ${
            receiver_ward?.label || ""
          }, ${receiver_district?.label || ""}, ${
            receiver_province?.label || ""
          }`,
          receiver_province_id: receiver_province.value,
          receiver_district_id: receiver_district.value,
          receiver_ward_code: receiver_ward ? receiver_ward.value : null,
          receiver_province_name: receiver_province.label,
          receiver_district_name: receiver_district.label,
          receiver_ward_name: receiver_ward ? receiver_ward.label : "",
          weight: weight,
          length: length,
          width: width,
          height: height,
          cod_amount: codValue,
          is_free: shipping_free,
          note: shipping_note || "Giao hàng từ VMASS",
          required_note: shipping_required_note,
          items: orders.map((o) => ({
            name: o.product_name || o.name,
            quantity: o.count,
            weight: 200,
          })),
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );

      if (res.data.success) {
        NotificatioSucController(
          `Đã tạo vận đơn: ${res.data.data.tracking_code}`,
        );
      } else {
        NotificatioErrController(res.data.message || "Lỗi tạo vận đơn");
      }
    } catch (error) {
      console.error("Create shipping order error", error);
      NotificatioErrController("Lỗi kết nối API vận chuyển khi tạo đơn");
    }
  };

  updateStock = (bill_id) => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/order/all_orders_today"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        const dataOrderNow = data.data.filter((d) => d.bill_id === bill_id);
        const arrayId = dataOrderNow.map((d) => d.id);
        this.onUpdateData(arrayId);
      });
  };

  onHandlerDeleteOrderPending = (order, idx) => {
    // Track deleted provisional items to cancel them on server
    if (order.bill && order.bill.id) {
      const orderIdsToDelete =
        Array.isArray(order.ids) && order.ids.length
          ? order.ids
          : [order.orderId || order.id];
      this.setState((prevState) => ({
        deletedProvisionalItems: [
          ...new Set([
            ...(prevState.deletedProvisionalItems || []),
            ...orderIdsToDelete,
          ]),
        ],
      }));
    }

    const { orders, itemsChange } = this.state;
    let items = itemsChange?.length ? itemsChange : orders;

    const ordersFilter = items.filter(
      // (or) => or.id !== order.id
      (or, index) => index !== idx,
    );

    const newOrders = itemsChange?.length ? [] : ordersFilter;
    const newItemsChange = itemsChange?.length ? ordersFilter : [];

    this.setState(
      {
        orders: newOrders,
        itemsChange: newItemsChange,
      },
      () => {
        if (newOrders.length > 0) {
          this.fetchAvailablePromotions();
        } else if (!newItemsChange.length) {
          this.setState(this.getResetOrderDraftState());
        }
      },
    );
  };

  //Invoices
  dataOrdersRender = async () => {
    let tokenStr = localStorage.getItem("access_token");

    const ordersId = this.state.orders.map((d) => d.id);
    if (ordersId === null) return false;

    await axios
      .post(
        `${END_POINT + "/bill/invoice_by_orders_id"}`,
        {
          orders: ordersId,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        const result = [];
        for (let i = 0; i < data.data.length; i++) {
          const find_item_id = result.find(
            (_item) => _item.product_id === data.data[i].product_id,
          );

          if (find_item_id) {
            // Có thì cộng số lượng lên
            find_item_id.count = find_item_id.count + 1;
            find_item_id.price =
              parseFloat(find_item_id.price) + parseFloat(data.data[i].price);
          } else {
            result.push(data.data[i]);
          }
        }

        this.setState(
          {
            itemsPendingBill: result,
            items_id: data.data,
            // billDate: getDateWithFormat(),
            bill: data?.data[0]?.bill?.id,
            products_select_discount: GetProductsSelectDiscount(data.data),
          },
          () => {
            // Sau khi có dữ liệu items, fetch promotions
            this.fetchAvailablePromotions(result);
          },
        );
        // console.log('itemsPendingBill: ', this.state.itemsPendingBill);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Debounced wrapper cho fetchAvailablePromotions
  fetchAvailablePromotions = () => {
    if (this._fetchPromotionsTimer) clearTimeout(this._fetchPromotionsTimer);
    this._fetchPromotionsTimer = setTimeout(() => {
      this._fetchAvailablePromotionsImpl();
    }, 300);
  };

  // Lấy danh sách khuyến mại khả dụng từ API
  _fetchAvailablePromotionsImpl = () => {
    const { orders, selected_promotions, customer_phone } = this.state;
    if (!orders || orders.length === 0) return;

    this.setState({ available_promotions_loading: true });

    let tokenStr = localStorage.getItem("access_token");

    // Chuẩn bị cartData từ items
    const cartData = orders.map((item) => ({
      id: item.id,
      quantity: item.count || 1,
      price: item.price,
      category_id:
        item.product && item.product.category_id
          ? item.product.category_id
          : null,
    }));

    // Lấy phone từ items (nếu có)
    const customerPhone = customer_phone ? customer_phone : null;

    axios
      .post(
        `${END_POINT + "/promotion/available"}`,
        {
          cartData,
          customerPhone,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then(async (data) => {
        // console.log('PROMOTION_AVAILABLE: ', data);

        const promotions = data.data.filter((p) => p.isAutoUse === true) || [];

        // Tính tổng discount từ tất cả các khuyến mại stackable (tự động)
        // Nếu có non-stackable, chỉ lấy 1 cái (cái có giá trị cao nhất)
        let autoDiscount = 0;
        let autoPromotionNames = [];

        const stackablePromos = promotions.filter(
          (p) => p.isStackable !== false,
        );
        const nonStackablePromos = promotions.filter(
          (p) => p.isStackable === false,
        );

        // Cộng dồn tất cả stackable promotions (tự động)
        stackablePromos.forEach((promo) => {
          if (promo.benefit?.actualDiscount) {
            autoDiscount += parseFloat(promo.benefit.actualDiscount) || 0;
            autoPromotionNames.push(promo.name);
          }
        });

        // Nếu có non-stackable, chọn cái có giá trị cao nhất
        if (nonStackablePromos.length > 0) {
          const bestNonStackable = nonStackablePromos.reduce(
            (best, current) => {
              const bestVal = best.benefit?.actualDiscount || 0;
              const currentVal = current.benefit?.actualDiscount || 0;
              return currentVal > bestVal ? current : best;
            },
            nonStackablePromos[0],
          );

          if (bestNonStackable.benefit?.actualDiscount) {
            autoDiscount +=
              parseFloat(bestNonStackable.benefit.actualDiscount) || 0;
            autoPromotionNames.push(bestNonStackable.name);
          }
        }

        // ========== BẢO TOÀN KHUYẾN MẠI THỦ CÔNG ĐÃ CHỌN ==========
        // Tính lại giá trị discount từ các khuyến mại thủ công đã chọn
        let manualDiscount = 0;
        let manualPromotionNames = [];
        const manualPromotionsFromAPI = data.data.filter(
          (p) => p.isAutoUse === false,
        );

        if (selected_promotions && selected_promotions.length > 0) {
          // Lọc ra các promotions đã chọn còn hợp lệ (vẫn có trong danh sách từ API)
          const selectedIds = new Set(
            selected_promotions.map((item) => item.id),
          );
          const validSelectedPromos = manualPromotionsFromAPI.filter((item) =>
            selectedIds.has(item.id),
          );

          // Cộng dồn discount từ các khuyến mại thủ công đã chọn
          validSelectedPromos.forEach((promo) => {
            if (promo.benefit?.actualDiscount) {
              manualDiscount += parseFloat(promo.benefit.actualDiscount) || 0;
              manualPromotionNames.push(promo.name);
            }
          });
        }

        // Tổng discount = auto + manual, cap không vượt tổng đơn
        const orderTotal = this.calTotalPrice(orders);
        const totalDiscount = Math.min(
          autoDiscount + manualDiscount,
          orderTotal,
        );
        const appliedPromotionNames = [
          ...autoPromotionNames,
          ...manualPromotionNames,
        ];

        this.setState({
          available_promotions: promotions,
          manual_promotions: manualPromotionsFromAPI,
          available_promotions_loading: false,
        });

        if (totalDiscount > 0) {
          await this.setState((prevState) => ({
            ...prevState,
            discount_form: {
              ...prevState.discount_form,
              saved: true,
              value: Math.round(totalDiscount).toString(),
              type: "price",
              note: appliedPromotionNames.join(", "),
              max: null,
              isManual: false, // Được set từ promotion tự động
            },
          }));
        } else {
          // ========== BẢO TOÀN CHIẾT KHẤU THỦ CÔNG ==========
          // Nếu không có khuyến mại nào từ hệ thống/manual promotions được chọn
          // Nhưng đang có chiết khấu thủ công (do user tự nhập, isManual: true)
          // thì không được reset.
          const { discount_form } = this.state;

          if (discount_form.isManual && discount_form.value) {
            // Giữ nguyên chiết khấu thủ công
            await this.setState((prevState) => ({
              ...prevState,
              discount_form: {
                ...prevState.discount_form,
                saved: true,
              },
            }));
          } else {
            // Nếu không phải chiết khấu thủ công (là auto-promotion cũ)
            // hoặc không có gì, thì reset
            await this.setState((prevState) => ({
              ...prevState,
              discount_form: {
                ...prevState.discount_form,
                saved: false,
                value: "",
                type: "price",
                note: "",
                max: null,
                isManual: false,
              },
            }));
          }
        }

        // Xử lý quà tặng (GIVE_GIFT)
        const allGifts = [];
        promotions.forEach((promo) => {
          if (promo.benefit?.gifts && Array.isArray(promo.benefit.gifts)) {
            promo.benefit.gifts.forEach((gift) => {
              allGifts.push({
                ...gift,
                promotionName: promo.name,
                benefitDescription: promo.benefit?.description || promo.name,
              });
            });
          }
        });

        // Nếu có quà tặng, tìm sản phẩm trong menus và thêm vào giỏ hàng
        if (allGifts.length > 0) {
          const { menus, orders } = this.state;

          // Lấy tất cả sản phẩm từ menus
          // Cấu trúc menus: [{id, name, data: [products...]}, ...]
          let allProducts = [];
          if (Array.isArray(menus)) {
            menus.forEach((menu) => {
              if (menu.data && Array.isArray(menu.data)) {
                allProducts = allProducts.concat(menu.data);
              }
            });
          }

          for (const gift of allGifts) {
            const giftProductId = gift.productId || gift.id;
            const giftQuantity = parseInt(gift.quantity) || 1;
            // Sử dụng benefitDescription (ví dụ: "Tặng 2 sản phẩm khi mua 10 sản phẩm")
            const giftNote =
              gift.benefitDescription || gift.promotionName || "Quà tặng";

            // Tìm sản phẩm trong menus có id khớp
            const giftProduct = allProducts.find((p) => p.id === giftProductId);

            if (giftProduct) {
              // Kiểm tra số lượng quà hiện có trong giỏ hàng
              const existingGiftInCart = orders.find(
                (o) => o.id === giftProductId && parseFloat(o.price) === 0,
              );

              const currentGiftQty = existingGiftInCart
                ? existingGiftInCart.count || 1
                : 0;

              // Nếu cần thêm quà (số lượng mới > số lượng hiện có)
              if (giftQuantity > currentGiftQty) {
                const qtyToAdd = giftQuantity - currentGiftQty;

                // Tạo bản sao product với note là description chi tiết
                const giftProductWithNote = {
                  ...giftProduct,
                  note: `🎁 ${giftNote}`,
                };

                // Gọi onClickImage để thêm quà vào giỏ hàng
                for (let i = 0; i < qtyToAdd; i++) {
                  await this.onClickImage(giftProductWithNote, "gift");
                }
              }
            } else {
              console.log(
                `Không tìm thấy sản phẩm quà tặng với id: ${giftProductId}`,
              );
            }
          }
        }
      })
      .catch((err) => {
        console.error("Lỗi khi lấy khuyến mại:", err);
        this.setState({
          available_promotions: [],
          available_promotions_loading: false,
        });
      });
  };

  // Ghi log sử dụng khuyến mại (cả auto và manual)
  handleRecordPromotionUsage = async (billId) => {
    const {
      selected_promotions,
      available_promotions,
      orders,
      customer_phone,
    } = this.state;

    // Gộp tất cả promotions đã áp dụng: auto (có actualDiscount > 0) + manual
    const allAppliedPromotions = [];

    // Auto promotions từ available_promotions
    if (available_promotions && available_promotions.length > 0) {
      for (const promo of available_promotions) {
        if (promo.benefit && promo.benefit.actualDiscount > 0) {
          allAppliedPromotions.push(promo);
        }
      }
    }

    // Manual promotions từ selected_promotions
    if (selected_promotions && selected_promotions.length > 0) {
      for (const promo of selected_promotions) {
        // Tránh trùng lặp nếu promotion đã có trong auto
        const alreadyAdded = allAppliedPromotions.some(
          (p) => p.id === promo.id,
        );
        if (!alreadyAdded) {
          allAppliedPromotions.push(promo);
        }
      }
    }

    if (allAppliedPromotions.length === 0) return;

    let tokenStr = localStorage.getItem("access_token");

    // Tính tổng giá trị đơn hàng
    const orderTotal = orders.reduce((total, item) => {
      return total + parseFloat(item.price) * (item.count || 1);
    }, 0);

    // Ghi log cho từng promotion đã sử dụng
    for (const promo of allAppliedPromotions) {
      try {
        await axios.post(
          `${END_POINT}/promotion/record-usage`,
          {
            promotionId: promo.id,
            customerPhone: customer_phone || null,
            billId,
            discountAmount:
              promo.benefit && promo.benefit.actualDiscount
                ? promo.benefit.actualDiscount
                : 0,
            giftItems:
              promo.benefit && promo.benefit.gifts ? promo.benefit.gifts : null,
            orderTotal,
          },
          { headers: { Authorization: `Bearer ${tokenStr}` } },
        );
      } catch (err) {
        console.error("Lỗi khi ghi log khuyến mại:", err);
      }
    }
  };

  handleToggleModalDiscount = () => {
    this.setState({
      is_open_modal_discount: !this.state.is_open_modal_discount,
    });
  };

  handleToggleModalDiscountTaxFee = (adjustmentType) => {
    const supportedTypes = ["discount", "tax", "fee"];
    const shouldOpen = supportedTypes.includes(adjustmentType);

    this.setState((previousState) => ({
      is_open_modal_discount_tax_fee: shouldOpen
        ? true
        : !previousState.is_open_modal_discount_tax_fee,
      active_order_adjustment_modal: shouldOpen
        ? adjustmentType
        : previousState.active_order_adjustment_modal,
    }));
  };

  handleToggleModalDiscountTaxFeeNested = () => {
    this.setState({
      is_open_modal_discount_tax_fee_nested:
        !this.state.is_open_modal_discount_tax_fee_nested,
    });
  };

  // getIdOrdersNow = (bill_id) => {
  //   // console.log('Selected Items for Invoice:', bill_id);
  //   // console.log('Discount Form State:', this.state.discount_form);
  //   // console.log('Tax Fee State:', this.state.tax_fee);
  //   // console.log('Fee Other State:', this.state.fee_other);

  //   let tokenStr = localStorage.getItem("access_token");
  //   axios
  //     .get(`${END_POINT + "/order/all_orders_today"}`, {
  //       headers: { Authorization: `Bearer ${tokenStr}` },
  //     })
  //     .then((res) => res.data)
  //     .then(async (data) => {
  //       // console.log('data: ', data);
  //       const dataOrderNow = data.data.filter((d) => d.bill_id === bill_id);
  //       const arrayId = dataOrderNow.map((d) => d.id);
  //       // console.log('dataOrderNow: ', dataOrderNow);
  //       // console.log('arrayId: ', arrayId);
  //       this.setState((prev) => ({
  //         ...prev,
  //         orders_fr_server: data.data,
  //         discount_form: {
  //           ...prev.discount_form,
  //           orders_id: arrayId,
  //         },
  //         tax_fee: {
  //           ...prev.tax_fee,
  //           orders_id: arrayId,
  //         },
  //         fee_other: {
  //           ...prev.fee_other,
  //           orders_id: arrayId,
  //         },
  //       }));

  //       // save discount
  //       if (this.state.discount_form.saved) {
  //         // console.log('Attempting to save discount with orders_id:', this.state.discount_form.orders_id);
  //         await this.handleSaveDiscount();
  //       }

  //       // save tax fee
  //       if (this.state.tax_fee.saved) {
  //         // console.log('Attempting to save tax fee with orders_id:', this.state.tax_fee.orders_id);
  //         await this.handleSaveTaxFee();
  //       }

  //       // save fee other
  //       if (this.state.fee_other.saved) {
  //         // console.log('Attempting to save fee other with orders_id:', this.state.fee_other.orders_id);
  //         await this.handleSaveFeeOther();
  //       }
  //     });
  // };

  handleSubmitModalDiscountTaxFee = async (selectedPromotions = []) => {
    const { orders, manual_promotions, available_promotions, menus } =
      this.state;

    // ========== TÍNH LẠI DISCOUNT TỪ ĐẦU ==========
    // 1. Tính discount từ các khuyến mại TỰ ĐỘNG (available_promotions)
    let autoDiscount = 0;
    let autoPromotionNames = [];

    if (available_promotions && available_promotions.length > 0) {
      const stackablePromos = available_promotions.filter(
        (p) => p.isStackable !== false,
      );
      const nonStackablePromos = available_promotions.filter(
        (p) => p.isStackable === false,
      );

      // Cộng dồn tất cả stackable auto promotions
      stackablePromos.forEach((promo) => {
        if (promo.benefit?.actualDiscount) {
          autoDiscount += parseFloat(promo.benefit.actualDiscount) || 0;
          autoPromotionNames.push(promo.name);
        }
      });

      // Nếu có non-stackable, chọn cái có giá trị cao nhất
      if (nonStackablePromos.length > 0) {
        const bestNonStackable = nonStackablePromos.reduce((best, current) => {
          const bestVal = best.benefit?.actualDiscount || 0;
          const currentVal = current.benefit?.actualDiscount || 0;
          return currentVal > bestVal ? current : best;
        }, nonStackablePromos[0]);

        if (bestNonStackable.benefit?.actualDiscount) {
          autoDiscount +=
            parseFloat(bestNonStackable.benefit.actualDiscount) || 0;
          autoPromotionNames.push(bestNonStackable.name);
        }
      }
    }

    // 2. Tính discount từ các khuyến mại THỦ CÔNG mới được chọn
    let manualDiscount = 0;
    let manualPromotionNames = [];
    let matchedPromos = [];

    if (selectedPromotions && selectedPromotions.length > 0) {
      // DEBUG: Log để kiểm tra dữ liệu đầu vào
      console.log("=== DEBUG GIFT PROMOTIONS ===");
      console.log("selectedPromotions from modal: ", selectedPromotions);
      console.log("manual_promotions from state: ", manual_promotions);

      // Lọc ra các promotions được chọn từ manual_promotions (có benefit.actualDiscount)
      const selectedIds = new Set(selectedPromotions.map((item) => item.id));
      console.log("selectedIds: ", selectedIds);

      matchedPromos = manual_promotions.filter((item) =>
        selectedIds.has(item.id),
      );

      console.log("matchedPromos from manual_promotions: ", matchedPromos);
      console.log(
        "matchedPromos benefits with gifts: ",
        matchedPromos.map((p) => ({ name: p.name, benefit: p.benefit })),
      );

      // Cộng dồn tất cả manual promotions
      matchedPromos.forEach((promo) => {
        if (promo.benefit?.actualDiscount) {
          manualDiscount += parseFloat(promo.benefit.actualDiscount) || 0;
          manualPromotionNames.push(promo.name);
        }
      });
    }

    // 3. Tổng discount = auto + manual (KHÔNG cộng dồn với giá trị cũ)
    // Cap discount để không vượt quá tổng đơn hàng
    const orderTotal = this.calTotalPrice(orders);
    const totalDiscount = Math.min(autoDiscount + manualDiscount, orderTotal);
    const appliedPromotionNames = [
      ...autoPromotionNames,
      ...manualPromotionNames,
    ];

    // ========== THU THẬP TẤT CẢ QUÀ TẶNG TRƯỚC KHI XÓA ==========
    // Collect gifts từ BOTH auto promotions VÀ manual promotions
    const allGifts = [];

    // Thu thập gifts từ khuyến mại TỰ ĐỘNG (available_promotions)
    if (available_promotions && available_promotions.length > 0) {
      available_promotions.forEach((promo) => {
        if (promo.benefit?.gifts && Array.isArray(promo.benefit.gifts)) {
          promo.benefit.gifts.forEach((gift) => {
            allGifts.push({
              ...gift,
              promotionName: promo.name,
              benefitDescription: promo.benefit?.description || promo.name,
              source: "auto",
            });
          });
        }
      });
    }

    // Thu thập gifts từ khuyến mại THỦ CÔNG được chọn (matchedPromos)
    matchedPromos.forEach((promo) => {
      if (promo.benefit?.gifts && Array.isArray(promo.benefit.gifts)) {
        promo.benefit.gifts.forEach((gift) => {
          allGifts.push({
            ...gift,
            promotionName: promo.name,
            benefitDescription: promo.benefit?.description || promo.name,
            source: "manual",
          });
        });
      }
    });

    // ========== XÓA TẤT CẢ GIFT ITEMS CŨ TRƯỚC KHI THÊM MỚI ==========
    // Gift items được nhận diện bằng price = 0 HOẶC note chứa "🎁"
    const ordersWithoutGifts = orders.filter((order) => {
      const isGiftByPrice = parseFloat(order.price) === 0;
      const isGiftByNote = order.note && order.note.includes("🎁");
      // Giữ lại nếu KHÔNG phải gift
      return !isGiftByPrice && !isGiftByNote;
    });

    // Cập nhật state orders để xóa gifts cũ
    await this.setState({ orders: ordersWithoutGifts });

    // Nếu có quà tặng, tìm sản phẩm trong menus và thêm vào giỏ hàng
    if (allGifts.length > 0) {
      // Lấy tất cả sản phẩm từ menus
      let allProducts = [];
      if (Array.isArray(menus)) {
        menus.forEach((menu) => {
          if (menu.data && Array.isArray(menu.data)) {
            allProducts = allProducts.concat(menu.data);
          }
        });
      }

      for (const gift of allGifts) {
        const giftProductId = gift.productId || gift.id;
        const giftQuantity = parseInt(gift.quantity) || 1;
        const giftNote =
          gift.benefitDescription || gift.promotionName || "Quà tặng";

        // Tìm sản phẩm trong menus có id khớp
        const giftProduct = allProducts.find((p) => p.id === giftProductId);

        if (giftProduct) {
          // Vì đã xóa hết gifts cũ (ordersWithoutGifts), currentGiftQty sẽ luôn = 0
          // Nên tất cả gifts mới sẽ được thêm vào
          const qtyToAdd = giftQuantity;

          // Tạo bản sao product với note là description chi tiết
          const giftProductWithNote = {
            ...giftProduct,
            note: `🎁 ${giftNote}`,
          };

          // Gọi onClickImage để thêm quà vào giỏ hàng
          for (let i = 0; i < qtyToAdd; i++) {
            await this.onClickImage(giftProductWithNote, "gift");
          }
        } else {
          console.log(
            `Không tìm thấy sản phẩm quà tặng với id: ${giftProductId}`,
          );
          NotificationManager.warning(
            `Sản phẩm quà tặng "${giftNote}" không tìm thấy trong menu. Vui lòng kiểm tra lại.`,
            "",
            5000,
            null,
            null,
            "filled",
          );
        }
      }
    }

    // 4. Cập nhật state - THAY THẾ hoàn toàn selected_promotions VÀ ĐÓNG MODAL
    // Lấy giá trị thủ công hiện từ state
    const currentDiscountForm = this.state.discount_form;

    // Xác định giá trị discount cuối cùng:
    // - Nếu có promotion được chọn (totalDiscount > 0), dùng giá trị từ promotion
    // - Nếu không có promotion nhưng có giá trị thủ công, giữ nguyên giá trị thủ công
    let finalDiscountForm;
    if (totalDiscount > 0) {
      // Có promotion -> sử dụng giá trị từ promotion
      finalDiscountForm = {
        ...currentDiscountForm,
        saved: true,
        value: Math.round(totalDiscount).toString(),
        type: "price",
        note: appliedPromotionNames.join(", "),
        max: null,
        isManual: false, // Ưu tiên khuyến mãi hệ thống
      };
    } else if (currentDiscountForm.value && currentDiscountForm.type) {
      // Không có promotion nhưng có giá trị thủ công -> giữ nguyên và set saved: true
      finalDiscountForm = {
        ...currentDiscountForm,
        saved: true,
        isManual: true, // Đánh dấu là thủ công
      };
    } else {
      // Không có gì -> reset
      finalDiscountForm = {
        ...currentDiscountForm,
        saved: false,
        value: "",
        isManual: false,
      };
    }

    this.setState({
      // THAY THẾ danh sách khuyến mại thủ công đã chọn (không cộng dồn)
      selected_promotions: selectedPromotions,
      discount_form: finalDiscountForm,
      // ĐÓNG MODAL SAU KHI CẬP NHẬT
      is_open_modal_discount_tax_fee: false,
    });
  };

  handleSubmitOrderAdjustment = (
    adjustmentType,
    draft,
    selectedPromotions = [],
  ) => {
    const nextValues = {
      ...draft,
      saved: !!draft.value,
      isManual: !!draft.value,
    };

    if (adjustmentType === "discount") {
      this.setState(
        (previousState) => ({
          discount_form: {
            ...previousState.discount_form,
            ...nextValues,
          },
        }),
        () => this.handleSubmitModalDiscountTaxFee(selectedPromotions),
      );
      return;
    }

    const stateKey = adjustmentType === "tax" ? "tax_fee" : "fee_other";
    this.setState((previousState) => ({
      [stateKey]: {
        ...previousState[stateKey],
        ...nextValues,
      },
      is_open_modal_discount_tax_fee: false,
    }));
  };

  handleOnChangeModalDiscountTaxFee = (e, inputType, valueType) => {
    let { name, value } = e.target;
    // const { discount_form, tax_fee, fee_other } = this.state;

    // Nếu là trường value và không phải là thay đổi type (percent/price), loại bỏ các ký tự không phải số
    if (name === "value" && !valueType) {
      value = value.toString().replace(/\D/g, "");
    }

    // Tùy thuộc vào loại input (discount, tax, fee), cập nhật state tương ứng
    this.setState((prevState) => ({
      [`${inputType}`]: {
        ...prevState[`${inputType}`],
        isManual: true,
        [name]:
          valueType === "percent"
            ? "percent"
            : valueType === "price"
              ? "price"
              : value,
      },
    }));
  };

  handleSaveDiscount = async () => {
    const { discount_form } = this.state;

    let tokenStr = localStorage.getItem("access_token");

    return await axios
      .put(
        `${END_POINT + "/order/discount"}`,
        {
          orders_id: discount_form.orders_id,
          value: discount_form.value.toString().replace(/\./g, ""),
          // value: Math.floor(parseFloat(discount_form.value)),
          type: discount_form.type,
          bill_id: "",
          note: discount_form.note,
          max: discount_form.max,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificationManager.primary(
          data.responseText,
          "",
          3000,
          null,
          null,
          "filled",
        );

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["discount-create"],
        });

        this.setState((prev) => ({
          ...prev,
          discount_form: {
            orders_id: [],
            user_id: "",
            note: "",
            value: "",
            type: "",
            saved: false,
            max: null,
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController("Có lỗi xảy ra khi lưu chiết khấu");
        throw err; // QUAN TRỌNG: Ném lỗi ra ngoài
      });
  };

  handleSaveTaxFee = async () => {
    const { tax_fee } = this.state;
    let tokenStr = localStorage.getItem("access_token");

    return await axios
      .put(
        `${END_POINT + "/order/tax_fee"}`,
        {
          orders_id: tax_fee.orders_id,
          value: tax_fee.value.toString().replace(/\./g, ""),
          // value: Math.floor(parseFloat(tax_fee.value)),
          type: tax_fee.type,
          calculation: tax_fee.calculation || "added",
          bill_id: "",
          note: tax_fee.note,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificationManager.primary(
          data.responseText,
          "",
          3000,
          null,
          null,
          "filled",
        );

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["tax-fee-create"],
        });

        this.setState((prev) => ({
          ...prev,
          tax_fee: {
            orders_id: [],
            user_id: "",
            note: "",
            value: "",
            type: "",
            calculation: "added",
            saved: false,
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController("Có lỗi xảy ra khi lưu thuế phí");
        throw err; // QUAN TRỌNG: Ném lỗi ra ngoài
      });
  };

  handleSaveFeeOther = async () => {
    const { fee_other } = this.state;
    let tokenStr = localStorage.getItem("access_token");
    return await axios
      .put(
        `${END_POINT + "/order/fee_other"}`,
        {
          orders_id: fee_other.orders_id,
          value: fee_other.value.toString().replace(/\./g, ""),
          // value: Math.floor(parseFloat(fee_other.value)),
          type: fee_other.type,
          label: normalizeFeeOtherLabel(fee_other.label),
          bill_id: "",
          note: fee_other.note,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificationManager.primary(
          data.responseText,
          "",
          3000,
          null,
          null,
          "filled",
        );

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["fee-other-create"],
        });

        this.setState((prev) => ({
          ...prev,
          fee_other: {
            orders_id: [],
            user_id: "",
            label: "shipping",
            note: "",
            value: "",
            type: "",
            applyOn: "after_discount",
            saved: false,
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController("Có lỗi xảy ra khi lưu phụ phí");
        throw err; // QUAN TRỌNG: Ném lỗi ra ngoài
      });
  };

  handleRemoveValueModal = async (name) => {
    if (name === "discount") {
      await this.setState((prev) => ({
        ...prev,
        discount_form: {
          orders_id: [],
          user_id: "",
          note: "",
          value: "",
          type: "",
          saved: false,
          max: null,
          isManual: false,
        },
      }));
    }
    if (name === "tax_fee") {
      await this.setState((prev) => ({
        ...prev,
        tax_fee: {
          orders_id: [],
          user_id: "",
          note: "",
          value: "",
          type: "",
          calculation: "added",
          saved: false,
          isManual: false,
        },
      }));
    }
    if (name === "fee_other") {
      await this.setState((prev) => ({
        ...prev,
        fee_other: {
          orders_id: [],
          user_id: "",
          label: "shipping",
          note: "",
          value: "",
          type: "",
          applyOn: "after_discount",
          saved: false,
          isManual: false,
        },
      }));
    }
  };

  onRemoveOrder = (id) => {
    let orders = this.state.orders.filter((_order) => _order.id !== id);
    this.setState({ orders });
  };

  totalPay = async (e, cash) => {
    let { cashs, cashsPay, paymentMethod } = this.state;
    const isFromCredit = paymentMethod === "credit";
    const cashChoose = cashs.findIndex((item) => item.cash === cash);

    if (cashChoose >= 0) {
      cashs[cashChoose].quantity += 1;
      await this.setState({
        cashs,
        cashsPay: cashs,
        isChecked: false,
        paymentMethod: isFromCredit ? "cash" : paymentMethod,
        isCustomPay: false,
        customCustomerPay: 0,
        customCustomerPayRaw: "",
      });
      if (cashsPay) {
        this.cashRefundToCustomer();
      }
    } else {
      cashs.push({
        cash: cash,
        quantity: 1,
      });
      await this.setState({
        cashs,
        cashsPay: cashs,
        isChecked: false,
        paymentMethod: isFromCredit ? "cash" : paymentMethod,
        isCustomPay: false,
        customCustomerPay: 0,
        customCustomerPayRaw: "",
      });
    }

    if (isFromCredit) {
      NotificationManager.info(
        "Đã chuyển hình thức thanh toán về Tiền mặt để ghi nhận trả một phần đơn hàng.",
        "Hình thức thanh toán",
        4000,
      );
    }
  };

  quantityPay = (cash) => {
    const cashsPay = this.state.cashsPay;
    cashsPay.filter((cash) => cash.cash === cash);
  };

  totalCustomerPay = (cashsPay) => {
    if (this.state.isCustomPay) {
      return parseFloat(this.state.customCustomerPay) || 0;
    }
    let total = 0;
    for (let i = 0; i < (cashsPay || []).length; i++) {
      let cash = cashsPay[i];

      total += parseInt(cash.cash, 10) * (cash.quantity || 0);
    }
    return total;
  };

  onChangeCustomerPay = (numericValue, rawValue) => {
    const resetCashs = this.state.cashs.map((item) => ({
      ...item,
      quantity: 0,
    }));
    const isFromCredit = this.state.paymentMethod === "credit";

    this.setState(
      {
        cashs: resetCashs,
        cashsPay: resetCashs,
        isCustomPay: true,
        customCustomerPay: numericValue,
        customCustomerPayRaw: rawValue,
        isChecked: false,
        paymentMethod: isFromCredit ? "cash" : this.state.paymentMethod,
      },
      () => {
        this.cashRefundToCustomer();
        if (isFromCredit && numericValue > 0) {
          NotificationManager.info(
            "Đã chuyển hình thức thanh toán về Tiền mặt để ghi nhận trả một phần đơn hàng.",
            "Hình thức thanh toán",
            4000,
          );
        }
      },
    );
  };

  removeOrders = () => {
    this.setState(this.getResetOrderDraftState());
  };

  cashFill = (name) => {
    return this.state.cashsPay.find(
      (cash) => cash.cash === name && cash.quantity > 0,
    );
  };

  GetTotalPrice = (items) => {
    if (!items.length) return 0;

    const cost = items.reduce((total, item) => {
      return total + item.price * 1;
    }, 0);

    return cost;
  };

  GetOriginalPrice = (item) => {
    if (!item) return 0;

    return parseFloat(item.price) / item.count;
  };

  GetTotalPaymentPrice = (total_price, total_price_discount) => {
    let total_price_val = parseFloat(total_price);
    let total_price_discount_val = parseFloat(total_price_discount);
    let total = 0;

    if (!isNaN(total_price_val) && !isNaN(total_price_discount_val)) {
      total = total_price_val - total_price_discount_val;
    }

    return total > 0 ? Math.round(total) : 0;
  };

  GetDiscountOrderValue = (items, discount, item) => {
    if (!items.length) return 0;

    const reducer = (a, o) => a + o.count;
    const items_count = items.reduce(reducer, 0);

    let price = 0;
    if (discount && discount.saved && discount.value) {
      let discount_value = Math.floor(discount.value);
      if (!isNaN(discount_value)) {
        if (discount.type === "percent") {
          price = discount_value;
        } else if (discount.type === "price") {
          price = (discount_value / items_count) * item.count;
        }
      }
      price = (Math.round(price * 100) / 100).toFixed();
    } else if (item.discount) {
      price = item.discount.value;
    }

    return Number(price);
  };

  GetDiscountOrderType = (discount, item) => {
    let type = "price";

    if (discount && discount.saved && discount.type) {
      type = discount.type;
    } else if (item.discount) {
      type = item.discount.type;
    }
    return type === "percent" ? "%" : "";
  };

  GetDiscountOrderNote = (discount, item) => {
    let note = "";

    if (discount && discount.saved && discount.note) {
      note = discount.note;
    } else if (item.discount) {
      note = item.discount.note;
    }
    return note;
  };

  //ChatGPT rewrite
  GetTotalDiscountPrice = (items, discount) => {
    // console.log('items: ', items);
    // console.log('discount: ', discount);
    if (!items.length) return 0;

    let total_discount = 0;
    items.forEach((item) => {
      const currentDiscount = discount || item.discount;
      if (!currentDiscount) return;

      // Parse value đúng cách - loại bỏ dấu chấm phân cách nghìn
      const discountValue =
        parseFloat(
          String(currentDiscount.value || 0)
            .replace(/\./g, "")
            .replace(",", "."),
        ) || 0;

      if (currentDiscount.type === "percent") {
        total_discount += (item.price * item.count * discountValue) / 100;
      } else if (currentDiscount.type === "price") {
        total_discount = discountValue;
        return false;
      }
    });

    return Math.round(total_discount);
  };

  GetTotalTaxFeePrice = (items, tax_fee, percentageBase, discount) => {
    if (!items || !items.length) return 0;

    const hasManualGlobalTax =
      tax_fee &&
      (tax_fee.saved ||
        tax_fee.isManual ||
        (tax_fee.value !== undefined &&
          tax_fee.value !== null &&
          tax_fee.value !== "" &&
          tax_fee.value !== 0 &&
          tax_fee.value !== "0"));

    if (hasManualGlobalTax) {
      if (
        tax_fee.type === "percent" &&
        Number.isFinite(Number(percentageBase))
      ) {
        return calculateOrderAdjustmentAmount(percentageBase, tax_fee);
      }

      const taxValue =
        parseFloat(
          String(tax_fee.value || 0)
            .replace(/\./g, "")
            .replace(",", "."),
        ) || 0;

      if (tax_fee.type === "percent") {
        let total_tax_fee = 0;
        for (let i = 0; i < items.length; i++) {
          let item = items[i];
          let price_percent = (item.price * item.count * taxValue) / 100;
          total_tax_fee += parseFloat(price_percent);
        }
        return Math.round(total_tax_fee);
      }
      if (tax_fee.type === "price") {
        return Math.round(taxValue);
      }
    }

    // Helper: tính chiết khấu của 1 item dựa trên discount global hoặc per-item
    const getItemDiscount = (item) => {
      const currentDiscount = discount || item.discount;
      if (!currentDiscount) return 0;
      const discountValue =
        parseFloat(
          String(currentDiscount.value || 0)
            .replace(/\./g, "")
            .replace(",", "."),
        ) || 0;
      if (currentDiscount.type === "percent") {
        return (item.price * item.count * discountValue) / 100;
      }
      if (currentDiscount.type === "price" && items.length > 0) {
        // Chiết khấu cố định phân bổ đều cho các item theo tỷ lệ giá trị
        const totalItemsValue = items.reduce(
          (sum, it) => sum + it.price * it.count,
          0,
        );
        if (totalItemsValue > 0) {
          return (discountValue * (item.price * item.count)) / totalItemsValue;
        }
      }
      return 0;
    };

    let total_tax_fee = 0;
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      if (item.tax_fee) {
        if (item.tax_fee.type === "percent") {
          let price_percent =
            (item.price * item.count * parseFloat(item.tax_fee.value || 0)) /
            100;
          total_tax_fee += parseFloat(price_percent);
        } else if (item.tax_fee.type === "price") {
          total_tax_fee += parseFloat(item.tax_fee.value || 0);
        }
      } else {
        const itemTaxRate = parseFloat(
          item.tax_rate !== undefined
            ? item.tax_rate
            : item.product?.tax_rate || 0,
        );
        if (itemTaxRate > 0) {
          // Tính thuế trên giá SAU chiết khấu: (price * count - discount) * taxRate / 100
          const itemTotal = item.price * item.count;
          const itemDiscountAmt = getItemDiscount(item);
          const postDiscountTotal = Math.max(0, itemTotal - itemDiscountAmt);
          let price_percent = (postDiscountTotal * itemTaxRate) / 100;
          total_tax_fee += parseFloat(price_percent);
        }
      }
    }

    return Math.round(total_tax_fee);
  };

  GetTotalFeeOtherPrice = (items, fee_other, percentageBase) => {
    if (!items.length) return 0;

    if (
      fee_other &&
      fee_other.type === "percent" &&
      Number.isFinite(Number(percentageBase))
    ) {
      return calculateOrderAdjustmentAmount(percentageBase, fee_other);
    }

    let total_fee_other = 0;
    for (let i = 0; i < items.length; i++) {
      let item = items[i];

      // load from create
      if (fee_other) {
        // Parse value đúng cách - loại bỏ dấu chấm phân cách nghìn
        const feeValue =
          parseFloat(
            String(fee_other.value || 0)
              .replace(/\./g, "")
              .replace(",", "."),
          ) || 0;

        if (fee_other.type === "percent") {
          let price_percent = (item.price * item.count * feeValue) / 100;
          total_fee_other = total_fee_other + parseFloat(price_percent);
        }
        if (fee_other.type === "price") {
          total_fee_other = feeValue;
          break;
        }
      }

      // load from server
      else if (item.fee_other) {
        if (item.fee_other.type === "percent") {
          let price_percent =
            (item.price * item.count * item.fee_other.value) / 100;
          total_fee_other = total_fee_other + parseFloat(price_percent);
        }
        if (item.fee_other.type === "price") {
          total_fee_other = total_fee_other + parseFloat(item.fee_other.value);
        }
      }
    }

    return Math.round(total_fee_other);
  };

  toggleModalProvisionalInvoice = () => {
    this.setState((prev) => ({
      ...prev,
      modalProvisionalInvoice: !this.state.modalProvisionalInvoice,
    }));
  };

  toggleModalOrderHistory = () => {
    this.setState((prev) => ({
      ...prev,
      modalOrderHistory: !this.state.modalOrderHistory,
    }));
  };

  reOrders = (selectedInvoice) => {
    const { menus } = this.state;

    if (!selectedInvoice || !selectedInvoice.orders) return;

    // 1. Flatten all products from menus for lookup
    const allProducts = [];
    if (menus && Array.isArray(menus)) {
      menus.forEach((category) => {
        if (category.data && Array.isArray(category.data)) {
          allProducts.push(...category.data);
        }
      });
    }

    // Capture IDs of provisional orders to cancel later
    const provisionalBillIds = selectedInvoice.orders.flatMap(
      (o) => o.ids || [o.id],
    );

    // Reuse PIN and PIN_PRINT from provisional invoice if available
    let currentPin = null;
    let currentPinPrint = null;
    if (selectedInvoice.orders && selectedInvoice.orders.length > 0) {
      currentPin = selectedInvoice.orders[0].pin;
      currentPinPrint = selectedInvoice.orders[0].pin_print;
      this.setState({ currentPin, currentPinPrint }); // Update state
    }

    // 2. Hydrate orders with missing settings from fresh product data
    const hydratedOrders = [];
    selectedInvoice.orders.forEach((order) => {
      const productId =
        order.product_id || (order.product ? order.product.id : order.id);
      const productDef = allProducts.find((p) => p.id == productId);

      let sizeSelectedId = [];
      let flavorSelectedId = [];
      let toppingSelectedId = [];
      let iceSelectedValue = order.ice || "";
      let sugarSelectedValue = order.sugar || "";

      if (productDef) {
        // Recover Size ID from name
        let matchedSize = null;
        if (order.size && productDef.size) {
          // DB stores size as "Name,Value" format - extract name
          const sizeName = order.size.split(",")[0]?.trim();
          matchedSize = productDef.size.find((s) => s.name === sizeName);
          if (matchedSize) {
            sizeSelectedId.push(matchedSize.id);
          }
        }

        let matchedFlavor = null;
        let flavorAddon = 0;
        if (order.flavor && productDef.flavor) {
          const flavorName = order.flavor.split(",")[0]?.trim();
          matchedFlavor = productDef.flavor.find(
            (flavor) => flavor.name === flavorName,
          );
          if (matchedFlavor) {
            flavorSelectedId.push(matchedFlavor.id);
            flavorAddon =
              parseFloat(matchedFlavor.promo_price) > 0
                ? parseFloat(matchedFlavor.promo_price)
                : parseFloat(matchedFlavor.value) || 0;
          }
        }

        // Recover Topping IDs from name string
        let toppingAddon = 0;
        if (order.topping && productDef.topping) {
          // DB stores topping as "Name,Value|Name,Value|" format
          const toppingEntries = order.topping
            .split("|")
            .filter((entry) => entry.trim() !== "");
          toppingEntries.forEach((entry) => {
            const toppingName = entry.split(",")[0]?.trim();
            if (!toppingName) return;
            const matched = productDef.topping.find(
              (t) => t.name === toppingName,
            );
            if (matched) {
              toppingSelectedId.push(matched.id);
              // Use promo_price if available (discounted topping)
              toppingAddon +=
                matched.promo_price && parseFloat(matched.promo_price) > 0
                  ? parseFloat(matched.promo_price)
                  : parseFloat(matched.value) || 0;
            }
          });
        }

        // Recalculate price — SAME pattern as onClickImage (lines 1527-1563)
        // 1. Base price
        let price = parseFloat(productDef.price) || 0;
        if (productDef.active_sale && parseFloat(productDef.price_sale) > 0) {
          price = parseFloat(productDef.price_sale);
        }

        // 2. Size REPLACES base price (not adds to it)
        if (sizeSelectedId.length && productDef.size) {
          const find_size = productDef.size.find((s) =>
            sizeSelectedId.some((id) => id == s.id),
          );
          if (find_size) {
            if (
              find_size.promo_price &&
              parseFloat(find_size.promo_price) > 0
            ) {
              price = parseFloat(find_size.promo_price);
            } else {
              price = parseFloat(find_size.value);
            }
          }
        }

        // 3. Flavor and topping add to price
        price = price + flavorAddon + toppingAddon;

        const recalculatedPrice = price;

        hydratedOrders.push({
          ...order,
          orderId: order.id,
          order_id: order.id,
          name: order.name || productDef.name || order?.product?.name || "",
          tax_rate: parseFloat(productDef.tax_rate) || 0,
          price: recalculatedPrice,
          unit: order.unit || productDef.sale_unit || "cái",
          // Override DB format "Name,Value" with clean name only
          size: order.size ? order.size.split(",")[0]?.trim() : "",
          topping: order.topping
            ? order.topping
                .split("|")
                .filter((e) => e.trim() !== "")
                .map((e) => e.split(",")[0]?.trim())
                .join(",")
            : "",
          sizeName: matchedSize ? matchedSize.name : "",
          sizeValue: matchedSize ? parseFloat(matchedSize.value) || 0 : 0,
          flavorName: matchedFlavor ? matchedFlavor.name : "",
          flavorValue: matchedFlavor ? flavorAddon : 0,
          toppingName: toppingSelectedId.map((tid) => {
            const t = productDef.topping?.find((tp) => tp.id === tid);
            return t ? t.name : "";
          }),
          toppingValue: toppingSelectedId.map((tid) => {
            const t = productDef.topping?.find((tp) => tp.id === tid);
            if (!t) return 0;
            return t.promo_price && parseFloat(t.promo_price) > 0
              ? t.promo_price
              : t.value;
          }),
          sizeSettings: productDef.size,
          flavorSettings: productDef.flavor,
          toppingSettings: productDef.topping,
          product: productDef,
          sizeSelectedId,
          flavorSelectedId,
          toppingSelectedId,
          iceSelectedValue,
          sugarSelectedValue,
        });
      } else {
        // Product not found in menus — keep original but mark as missing
        console.warn(
          `ReOrder: Product ID ${productId} not found in menus. Using saved data.`,
        );
        hydratedOrders.push({
          ...order,
          name: order.name || order?.product?.name || "",
          product: order.product || { name: order.name || "" },
          unit: order.unit || order.product?.sale_unit || "cái",
          sizeSettings: [],
          flavorSettings: [],
          toppingSettings: [],
          sizeSelectedId: [],
          flavorSelectedId: [],
          toppingSelectedId: [],
          iceSelectedValue,
          sugarSelectedValue,
        });
      }
    });

    // 3. Restore discount / tax_fee / fee_other from first order
    const firstOrder = selectedInvoice.orders[0];
    let restoredDiscount = {
      orders_id: [],
      user_id: "",
      note: "",
      value: "",
      type: "percent",
      saved: false,
      max: null,
      isManual: false,
    };
    let restoredTaxFee = {
      orders_id: [],
      user_id: "",
      note: "",
      value: "",
      type: "",
      calculation: "added",
      saved: false,
      isManual: false,
    };
    let restoredFeeOther = {
      orders_id: [],
      user_id: "",
      label: "shipping",
      note: "",
      value: "",
      type: "",
      applyOn: "after_discount",
      saved: false,
      isManual: false,
    };

    if (firstOrder) {
      const getFirst = (item) => (Array.isArray(item) ? item[0] : item);

      // --- DISCOUNT ---
      const firstDisc = getFirst(firstOrder.discount);
      if (firstDisc) {
        let finalValue = parseFloat(firstDisc.value || 0);
        const type = firstDisc.type || "percent";

        if (type === "price") {
          finalValue = 0;
          selectedInvoice.orders.forEach((ord) => {
            const d = getFirst(ord.discount);
            if (d && d.value) finalValue += parseFloat(d.value);
          });
        }

        if (finalValue > 0) {
          restoredDiscount = {
            ...restoredDiscount,
            note: firstDisc.note || "",
            value: finalValue,
            type: type,
            saved: true,
            isManual: true,
          };
        }
      }

      // --- TAX FEE ---
      const firstTax = getFirst(firstOrder.tax_fee);
      if (firstTax) {
        let finalValue = parseFloat(firstTax.value || 0);
        const type = firstTax.type || "percent";

        if (type === "price") {
          finalValue = 0;
          selectedInvoice.orders.forEach((ord) => {
            const t = getFirst(ord.tax_fee);
            if (t && t.value) finalValue += parseFloat(t.value);
          });
        }

        if (finalValue > 0) {
          restoredTaxFee = {
            ...restoredTaxFee,
            note: firstTax.note || "",
            value: finalValue,
            type: type,
            saved: true,
            isManual: true,
          };
        }
      }

      // --- FEE OTHER ---
      const firstFee = getFirst(firstOrder.fee_other);
      if (firstFee) {
        let finalValue = parseFloat(firstFee.value || 0);
        const type = firstFee.type || "percent";

        if (type === "price") {
          finalValue = 0;
          selectedInvoice.orders.forEach((ord) => {
            const f = getFirst(ord.fee_other);
            if (f && f.value) finalValue += parseFloat(f.value);
          });
        }

        if (finalValue > 0) {
          restoredFeeOther = {
            ...restoredFeeOther,
            label: normalizeFeeOtherLabel(firstFee.label),
            note: firstFee.note || "",
            value: finalValue,
            type: type,
            saved: true,
            isManual: true,
          };
        }
      }
    }

    // 4. Reset payment state & set hydrated orders
    this.setState((prev) => ({
      ...prev,
      modalProvisionalInvoice: !this.state.modalProvisionalInvoice,
      orders: hydratedOrders,
      provisionalBillIds: provisionalBillIds,
      // Restore discount/tax/fee
      discount_form: restoredDiscount,
      tax_fee: restoredTaxFee,
      fee_other: restoredFeeOther,
      // Reset payment state
      cashs: [
        { cash: 1000, quantity: 0 },
        { cash: 2000, quantity: 0 },
        { cash: 5000, quantity: 0 },
        { cash: 10000, quantity: 0 },
        { cash: 20000, quantity: 0 },
        { cash: 50000, quantity: 0 },
        { cash: 100000, quantity: 0 },
        { cash: 200000, quantity: 0 },
        { cash: 500000, quantity: 0 },
      ],
      cashsPay: [],
      customer_name:
        firstOrder && firstOrder.customer_name ? firstOrder.customer_name : "",
      customer_phone: firstOrder && firstOrder.phone ? firstOrder.phone : "",
      refund_to_customer: 0,
    }));
  };

  onCancelProvisionalInvoice = (selectedInvoice) => {
    if (!selectedInvoice || !selectedInvoice.orders) return;

    // Show confirmation alert
    const confirmed = window.confirm(
      "Bạn có chắc chắn muốn hủy hóa đơn tạm tính này không?",
    );
    if (!confirmed) return;

    // Use order IDs for reliable cancellation
    const arrayId = selectedInvoice.orders.flatMap((o) => o.ids || [o.id]);

    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT + "/order/status"}`,
        {
          arrayId: arrayId,
          status_id: 2223, // PROVISIONAL_INVOICE_CANCEL
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["bill-delete"],
        });

        this.socket.emit("refresh-recent-order", {
          user_id: localStorage.getItem("user_id"),
        });

        this.dataListRender();
        this.renderDataProvisionalInvoice();
      })
      .catch((err) => {
        NotificatioErrController(
          err?.response?.data?.responseText || "Có lỗi xảy ra",
        );
        return false;
      });
  };

  onQuickPayProvisional = async (orderIds) => {
    if (!orderIds || orderIds.length === 0) return;
    let tokenStr = localStorage.getItem("access_token");
    return axios
      .put(
        `${END_POINT + "/order/status"}`,
        { arrayId: orderIds, status_id: 555 }, // 555 = PAYMENTED
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then(() => {
        NotificatioSucController("Đã thanh toán thành công");
        this.socket.emit("refresh-done-order", {
          user_id: localStorage.getItem("user_id"),
        });
        this.socket.emit("refresh-recent-order", {
          user_id: localStorage.getItem("user_id"),
        });
        this.dataListRender();
        this.renderDataProvisionalInvoice();
      })
      .catch((err) => {
        NotificatioErrController(
          err?.response?.data?.responseText || "Có lỗi xảy ra khi thanh toán",
        );
      });
  };

  toggleModalFullOrders = () => {
    this.setState((prev) => ({
      ...prev,
      modalFullOrders: !this.state.modalFullOrders,
    }));
  };

  toggleModalMobileOrderStatus = () => {
    this.setState((prev) => ({
      ...prev,
      modalMobileOrderStatus: !prev.modalMobileOrderStatus,
    }));
  };

  toggleModalMobileReceiveOrder = () => {
    this.setState((prev) => ({
      ...prev,
      modalMobileReceiveOrder: !prev.modalMobileReceiveOrder,
    }));
  };

  toggleModalWizard = (skipUpdate = false) => {
    if (!skipUpdate) {
      this.handleUpdateLoginStatus();
    }

    // When closing wizard, clear login_status from localStorage so Tour can start
    if (this.state.modalWizard) {
      localStorage.removeItem("login_status");
      const today = new Date().toISOString().split("T")[0];
      const storeDomain =
        this.state.store || localStorage.getItem("domain") || "default";
      localStorage.setItem(`vmass_wizard_last_shown_${storeDomain}`, today);

      // Dispatch custom event to notify Tour component to re-check
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("wizardClosed"));
      }, 500);
    }

    this.setState((prev) => ({
      ...prev,
      modalWizard: !this.state.modalWizard,
    }));
  };

  calTotalPrice = (orders) => {
    let total = 0;
    for (let i = 0; i < orders.length; i++) {
      let order = orders[i];

      total += parseInt(order.price) * order.count;
    }
    return total;
  };

  calcNumberOrder = (orders) => {
    let sum = 0;
    let i = 0;
    let orders_len = orders.length;
    let order = null;
    for (; i < orders_len; i++) {
      order = orders[i];
      sum += order.count;
    }
    return sum;
  };

  //ChatGPT rewrite
  cashRefundToCustomer = () => {
    const { orders, cashsPay, discount_form, tax_fee, fee_other } = this.state;

    let total_discount_price = 0;
    if (discount_form.saved) {
      total_discount_price += this.GetTotalDiscountPrice(orders, discount_form);
    }
    const adjustmentPercentageBase = getPostDiscountSubtotal(
      this.calTotalPrice(orders),
      total_discount_price,
    );
    let total_taxfee_price =
      tax_fee && tax_fee.saved && tax_fee.calculation === "included"
        ? 0
        : this.GetTotalTaxFeePrice(
            orders,
            tax_fee,
            adjustmentPercentageBase,
            discount_form,
          );
    const feePercentageBase = getFeeApplicationBase(
      this.calTotalPrice(orders),
      adjustmentPercentageBase,
      fee_other && fee_other.applyOn,
    );
    let total_fee_other_price = 0;
    if (fee_other.saved) {
      total_fee_other_price += this.GetTotalFeeOtherPrice(
        orders,
        fee_other,
        feePercentageBase,
      );
    }
    this.setState({
      refund_to_customer:
        this.calTotalPrice(orders) +
        total_taxfee_price +
        total_fee_other_price -
        total_discount_price -
        this.totalCustomerPay(cashsPay),
    });
    // console.log('refund_to_customer: ', this.state.refund_to_customer);
  };

  // ORDER
  toggleModalOrder = () => {
    // thêm class name này mới scroll được modal
    if (this.state.modalOrderOpen) {
      document.body.classList.remove("modal-open");
    } else {
      document.body.classList.add("modal-open");
    }
    this.setState({
      modalOrderOpen: !this.state.modalOrderOpen,
    });
  };

  // updateOrders = ({ product, requireCreated = false }) => {
  //     const find_order = this.state.orders.find(
  //         (_product) => _product.id === product.id
  //     );

  //     // Kiểm tra size, topping, ice, sugar, price_sale, active_sale
  //     let price = product.price;
  //     if (product.active_sale) {
  //         price = product.price_sale;
  //     }

  //     // size
  //     if (product.sizeSelectedId.length) {
  //         const find_size = product.size.find((_size) =>
  //             product.sizeSelectedId.includes(_size.id)
  //         );
  //         price = parseFloat(price) + parseFloat(find_size.value);
  //     }
  //     // topping
  //     if (product.toppingSelectedId.length) {
  //         const find_topping = product.topping.filter((_size) =>
  //             product.toppingSelectedId.includes(_size.id)
  //         );

  //         for (let i = 0; i < find_topping.length; i++) {
  //             price = parseFloat(price) + parseFloat(find_topping[i].value);
  //         }
  //     }

  //     // Update giá tiền nếu đã tồn tại
  //     if (find_order) {
  //         const orders = this.state.orders.map((o) =>
  //             o.id === find_order.id
  //                 ? {
  //                       ...o,
  //                       price: price,
  //                       note: product.note,
  //                       iceSelectedValue: product.iceSelectedValue,
  //                       sugarSelectedValue: product.sugarSelectedValue,
  //                       sizeSelectedId: product.sizeSelectedId,
  //                       toppingSelectedId: product.toppingSelectedId,
  //                   }
  //                 : o
  //         );

  //         this.setState({ orders });
  //     } else {
  //         /* Tạo mới nếu chưa có
  //          *
  //          * Chỉ tạo mới khi click nút thêm sản phẩm, input hoặc nhấn nút +, -
  //          */
  //         let orders = this.state.orders;

  //         if (requireCreated) {
  //             orders.push({
  //                 id: product.id,
  //                 name: product.name,
  //                 price: price,
  //                 count: 1,
  //                 note: product.note,
  //                 iceSelectedValue: product.iceSelectedValue,
  //                 sugarSelectedValue: product.sugarSelectedValue,
  //                 sizeSelectedId: product.sizeSelectedId,
  //                 toppingSelectedId: product.toppingSelectedId,
  //                 previewDisplay: false,
  //             });
  //         }
  //         this.setState({ orders });
  //     }
  // };

  //ChatGPT rewrite
  incrementItem = (item) => {
    const { orders } = this.state;
    const find_order = orders.find((order) => order.id === item.id);

    const equar = (a, b) => {
      if (a.length !== b.length) {
        return false;
      } else {
        for (let i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) {
            return false;
          }
        }
        return true;
      }
    };

    if (find_order) {
      const updatedOrders = orders.map((order) =>
        order.id === item.id &&
        order.size === item.size &&
        order.color === item.color &&
        order.material === item.material &&
        order.iceSelectedValue === item.iceSelectedValue &&
        order.sugarSelectedValue === item.sugarSelectedValue &&
        order.sizeName === item.sizeName &&
        (item.toppingName
          ? equar(order.toppingName, item.toppingName)
          : order.toppingName === item.toppingName)
          ? { ...order, count: order.count + 1 }
          : order,
      );
      this.setState({ orders: updatedOrders }, () => {
        this.fetchAvailablePromotions();
      });
    }
  };

  onChangeCount = (item, newCount) => {
    const count = parseInt(newCount, 10);
    if (isNaN(count) || count < 1) return;

    const { orders } = this.state;
    const find_order = orders.find((order) => order.id === item.id);

    const equar = (a, b) => {
      if (a.length !== b.length) {
        return false;
      } else {
        for (let i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) {
            return false;
          }
        }
        return true;
      }
    };

    if (find_order) {
      const updatedOrders = orders.map((order) =>
        order.id === item.id &&
        order.size === item.size &&
        order.color === item.color &&
        order.material === item.material &&
        order.iceSelectedValue === item.iceSelectedValue &&
        order.sugarSelectedValue === item.sugarSelectedValue &&
        order.sizeName === item.sizeName &&
        (item.toppingName
          ? equar(order.toppingName, item.toppingName)
          : order.toppingName === item.toppingName)
          ? { ...order, count: count }
          : order,
      );
      this.setState({ orders: updatedOrders }, () => {
        this.fetchAvailablePromotions();
      });
    }
  };

  //ChatGPT rewrite

  decrementItem = (item) => {
    const equar = (a, b) => {
      if (a.length !== b.length) {
        return false;
      } else {
        for (let i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) {
            return false;
          }
        }
        return true;
      }
    };

    const { orders } = this.state;
    const orderIndex = orders.findIndex(
      ({
        id,
        size,
        color,
        material,
        iceSelectedValue,
        sugarSelectedValue,
        sizeName,
        toppingName,
      }) =>
        id === item.id &&
        size === item.size &&
        color === item.color &&
        material === item.material &&
        iceSelectedValue === item.iceSelectedValue &&
        sugarSelectedValue === item.sugarSelectedValue &&
        sizeName === item.sizeName &&
        (item.toppingName
          ? equar(toppingName, item.toppingName)
          : toppingName === item.toppingName),
    );

    if (orders[orderIndex].count > 1) {
      orders[orderIndex].count -= 1;
      this.setState(
        {
          orders,
        },
        () => {
          this.fetchAvailablePromotions();
        },
      );
    }
  };

  //ChatGPT rewrite
  decrementCount = async (e, cash) => {
    e.stopPropagation();
    const { cashs, cashsPay, paymentMethod } = this.state;
    const isFromCredit = paymentMethod === "credit";
    const index = cashs.findIndex((_cash) => _cash.cash === cash.cash);
    if (cashs[index].quantity > 0) {
      const newCashs = [...cashs];
      newCashs[index] = {
        ...cashs[index],
        quantity: cashs[index].quantity - 1,
      };
      await this.setState({
        cashs: newCashs,
        cashsPay: newCashs,
        isCustomPay: false,
        customCustomerPay: 0,
        customCustomerPayRaw: "",
        paymentMethod: isFromCredit ? "cash" : paymentMethod,
        isChecked: false,
      });
      if (cashsPay) {
        this.cashRefundToCustomer();
      }
      if (isFromCredit) {
        NotificationManager.info(
          "Đã chuyển hình thức thanh toán về Tiền mặt để ghi nhận trả một phần đơn hàng.",
          "Hình thức thanh toán",
          4000,
        );
      }
    }
  };

  getFinalOrderTotal = () => {
    const { orders, discount_form, tax_fee, fee_other, shipping_fee } =
      this.state;
    let total_discount_price = 0;
    if (discount_form && discount_form.saved) {
      total_discount_price += this.GetTotalDiscountPrice(orders, discount_form);
    }
    const adjustmentPercentageBase = getPostDiscountSubtotal(
      this.calTotalPrice(orders),
      total_discount_price,
    );
    let total_taxfee_price =
      tax_fee && tax_fee.saved && tax_fee.calculation === "included"
        ? 0
        : this.GetTotalTaxFeePrice(
            orders,
            tax_fee,
            adjustmentPercentageBase,
            discount_form,
          );
    const feePercentageBase = getFeeApplicationBase(
      this.calTotalPrice(orders),
      adjustmentPercentageBase,
      fee_other && fee_other.applyOn,
    );
    let total_fee_other_price = 0;
    if (fee_other && fee_other.saved) {
      total_fee_other_price += this.GetTotalFeeOtherPrice(
        orders,
        fee_other,
        feePercentageBase,
      );
    }
    return Math.max(
      0,
      this.calTotalPrice(orders) +
        total_taxfee_price +
        total_fee_other_price -
        total_discount_price +
        (shipping_fee || 0),
    );
  };

  onChangePaymentMethod = (value) => {
    if (value === "credit") {
      const paidAmount = this.totalCustomerPay(this.state.cashsPay);

      // Nếu khách đã đưa một phần tiền (> 0)
      if (paidAmount > 0) {
        this.setState({
          creditFullOrderWarningModalOpen: true,
        });
        return;
      }

      this.setState({
        paymentMethod: "credit",
        isChecked: true,
      });
      return;
    }

    this.setState({
      paymentMethod: value,
      isChecked: false,
    });
  };

  confirmSwitchToCredit = () => {
    const resetCashs = this.state.cashs.map((item) => ({
      ...item,
      quantity: 0,
    }));

    this.setState(
      {
        paymentMethod: "credit",
        isChecked: true,
        creditFullOrderWarningModalOpen: false,
        cashs: resetCashs,
        cashsPay: resetCashs,
        isCustomPay: false,
        customCustomerPay: 0,
        customCustomerPayRaw: "",
      },
      () => {
        this.cashRefundToCustomer();
        NotificationManager.warning(
          `Đã chuyển sang hình thức Ghi nợ cho toàn bộ đơn hàng (${AddCommaNumber(this.getFinalOrderTotal())} đ). Tiền khách đưa đã được đặt lại về 0.`,
          "Ghi nhận công nợ toàn bộ",
          5000,
          null,
          null,
          "filled",
        );
      },
    );
  };

  cancelSwitchToCredit = () => {
    this.setState({
      creditFullOrderWarningModalOpen: false,
    });
  };

  // Removed duplicate onChangeShippingCarrier

  onChangeStaff = (value) => {
    this.setState({ selectedStaff: value });
    // Persist to localStorage
    if (value) {
      localStorage.setItem("selectedStaff", value);
    } else {
      localStorage.removeItem("selectedStaff");
    }
  };

  fetchStaffList = () => {
    const userId = localStorage.getItem("user_id");
    const parentId = localStorage.getItem("b");
    const isCashierAccount = userId !== parentId;

    // If user is a cashier (child account), auto-set staff to their own user_id
    if (isCashierAccount) {
      this.setState({
        isCashierAccount: true,
        selectedStaff: userId,
        staffList: [], // No need to fetch staff list for cashiers
      });
      // Also persist to localStorage for consistency
      localStorage.setItem("selectedStaff", userId);
      return;
    }

    // For parent accounts, fetch the staff list as before
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/user-staff/json?pageSize=100&currentPage=1`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          // Filter to only show active staff (still working)
          const activeStaff = res.data.filter(
            (staff) => staff.status_working === "on",
          );
          const staffOptions = activeStaff.map((staff) => ({
            value: staff.id,
            label: staff.name || "Không tên",
          }));
          this.setState({ staffList: staffOptions, isCashierAccount: false });
        } else {
          // No staff - set empty array (dropdown will show placeholder)
          this.setState({ staffList: [], isCashierAccount: false });
        }
      })
      .catch((err) => {
        console.log("Error fetching staff list:", err);
        // On error, set empty array
        this.setState({ staffList: [], isCashierAccount: false });
      });
  };

  onHandleChecked = () => {
    this.setState({ isChecked: !this.state.isChecked });
  };

  infoTable = (data) => {
    this.setState((prev) => ({
      ...prev,
      info_table: data,
      selectedFloorTable: 100,
    }));
  };

  handleClickedPrintInvoice = (e, selectedItems) => {
    // let arrayOrdersId = this.state.items_id.map((i) => i.id);
    // console.log('Selected Items for Invoice:', selectedItems);
    // console.log('Discount Form State:', this.state.discount_form);
    // console.log('Tax Fee State:', this.state.tax_fee);
    // console.log('Fee Other State:', this.state.fee_other);

    let tokenStr = localStorage.getItem("access_token");

    return axios
      .put(
        `${END_POINT + "/order/status"}`,
        {
          arrayId: selectedItems,
          status_id: STATUS.PAYMENTED,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then(async (data) => {
        this.socket.emit("refresh-done-order", {
          user_id: localStorage.getItem("user_id"),
        });
        this.socket.emit("refresh-stock", {
          user_id: localStorage.getItem("user_id"),
          // orders_id,
        });
        this.socket.emit("refresh-recent-order", {
          user_id: localStorage.getItem("user_id"),
          // floor: this.state.selectedFloorTable,
        });
        this.socket.emit("refresh-pending-order", {
          user_id: localStorage.getItem("user_id"),
        });
        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["invoice-print"],
        });

        try {
          // save discount
          if (this.state.discount_form.saved) {
            console.log(
              "Attempting to save discount with orders_id:",
              this.state.discount_form.orders_id,
            );
            await this.handleSaveDiscount();
          }
          // save tax fee
          if (this.state.tax_fee.saved) {
            console.log(
              "Attempting to save tax fee with orders_id:",
              this.state.tax_fee.orders_id,
            );
            await this.handleSaveTaxFee();
          }

          // save fee other
          if (this.state.fee_other.saved) {
            console.log(
              "Attempting to save fee other with orders_id:",
              this.state.fee_other.orders_id,
            );
            await this.handleSaveFeeOther();
          }
        } catch (error) {
          // Lỗi xảy ra từ một trong các hàm handleSave...
          console.error("Lỗi trong quá trình lưu chi tiết hóa đơn:", error);
          // Thông báo cho người dùng về việc một phần có thể đã thất bại
          NotificatioErrController(
            this.props.intl.formatMessage({ id: "home.notify.save-error" }),
          );
          // Cân nhắc: có cần "hoàn tác" trạng thái PAYMENTED không? (phức tạp)
        }
      })
      .catch((err) => {
        // Lỗi từ việc cập nhật status hoặc từ lỗi không bắt được trong khối .then ở trên
        console.error("Lỗi khi cập nhật trạng thái đơn hàng:", err);
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "home.notify.status-error" }),
        );
      });
  };

  getWidth = () => {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    );
  };

  handleResize = () => {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.setState({ width: this.getWidth() });
    }, 150);
  };

  handleLoginStatus = (status) => {
    console.log("[Wizard Debug] handleLoginStatus called with status:", status);
    if (status === "is_first_login" || status === "wizard_pending") {
      if (this.state.modalWizard) {
        console.log("[Wizard Debug] Modal is already open. Ignoring.");
        return;
      }

      // First login must ALWAYS show wizard modal
      if (status === "is_first_login") {
        console.log("[Wizard Debug] Showing Wizard modal for first login.");
        localStorage.setItem("login_status", status);
        this.setState({
          modalWizard: true,
        });
        return;
      }

      // For wizard_pending, check if already dismissed today for this store
      const today = new Date().toISOString().split("T")[0];
      const storeDomain =
        this.state.store || localStorage.getItem("domain") || "default";
      const lastShownKey = `vmass_wizard_last_shown_${storeDomain}`;
      const lastShown = localStorage.getItem(lastShownKey);
      console.log(
        "[Wizard Debug] Today:",
        today,
        "Last shown today:",
        lastShown,
      );

      if (lastShown === today) {
        console.log(
          "[Wizard Debug] Wizard pending already shown today. Skipping modal show.",
        );
        localStorage.removeItem("login_status");
        this.setState({
          modalWizard: false,
        });
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent("wizardClosed"));
        }, 500);
      } else {
        console.log("[Wizard Debug] Showing Wizard modal for pending wizard.");
        localStorage.setItem("login_status", status);
        localStorage.setItem(lastShownKey, today);
        this.setState({
          modalWizard: true,
        });
      }
    } else {
      console.log(
        "[Wizard Debug] User status is not first login or pending. Clearing login_status.",
      );
      localStorage.removeItem("login_status");
    }
  };

  checkAndUpdateWizardStatus = () => {
    const { formUser, menus } = this.state;
    if (!formUser || !menus) {
      console.log(
        "[Wizard Debug] checkAndUpdateWizardStatus: formUser or menus not loaded yet.",
      );
      return;
    }

    const {
      companyName,
      phone,
      email,
      companyAddress,
      namePay,
      bankPay,
      numberPay,
      login_status,
    } = formUser;

    console.log(
      "[Wizard Debug] checkAndUpdateWizardStatus called. status:",
      login_status,
      "products category count:",
      menus.length,
    );

    if (
      login_status === "is_first_login" ||
      login_status === "wizard_pending"
    ) {
      const isComplete =
        companyName &&
        companyName !== "" &&
        phone &&
        phone !== "" &&
        email &&
        email !== "" &&
        companyAddress &&
        companyAddress !== "" &&
        namePay &&
        namePay !== "" &&
        bankPay &&
        bankPay !== "" &&
        numberPay &&
        numberPay !== "" &&
        menus.length >= 1;

      console.log("[Wizard Debug] Profile fields filled status:", {
        companyName: !!companyName,
        phone: !!phone,
        email: !!email,
        companyAddress: !!companyAddress,
        namePay: !!namePay,
        bankPay: !!bankPay,
        numberPay: !!numberPay,
        hasProducts: menus.length >= 1,
        isAllComplete: isComplete,
      });

      if (isComplete) {
        console.log(
          "[Wizard Debug] All info complete. Automatically updating to wizard_complete...",
        );
        let formData = new FormData();
        formData.append("login_status", "wizard_complete");

        let tokenStr = localStorage.getItem("access_token");
        axios
          .put(`${END_POINT + "/user"}`, formData, {
            headers: {
              Authorization: `Bearer ${tokenStr}`,
              "content-type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.setState((prev) => ({
              formUser: {
                ...prev.formUser,
                login_status: "wizard_complete",
              },
              modalWizard: false,
            }));
            localStorage.removeItem("login_status");
            window.dispatchEvent(new CustomEvent("wizardClosed"));
          })
          .catch((err) => {
            console.error("[Wizard Debug] Error updating status:", err);
          });
      }
    }
  };

  handleUpdateLoginStatus = () => {
    if (!this.state.formUser) return;
    const {
      companyName,
      phone,
      email,
      companyAddress,
      namePay,
      bankPay,
      numberPay,
    } = this.state.formUser;

    let wizard_status;
    if (
      !companyName ||
      !phone ||
      !email ||
      !companyAddress ||
      !namePay ||
      !bankPay ||
      !numberPay ||
      !this.state.menus ||
      this.state.menus.length < 1
    ) {
      wizard_status = "wizard_pending";
    } else {
      wizard_status = "wizard_complete";
    }

    let formUser = new FormData();

    formUser.append("login_status", wizard_status);

    // axios submit
    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(`${END_POINT + "/user"}`, formUser, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          "content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        // NotificatioSucController(data.responseText);
      })
      .catch((err) => {
        NotificatioErrController(err?.response?.data?.responseText);
      });
  };

  render() {
    let {
      promotions,
      dataProvisionalInvoice,
      menus,
      is_loading_data,
      listsData,
      activeIndex,
      itemsTable,
      isLoadingItemsTable,
      selectedFloorTable,
      floorsActiveId,
      itemsOrderStatus,
      itemsPending,
      itemsPendingBill,
      itemsDone,
      itemsRefund,
      itemsRecentOrder,
      selectedItemsPending,
      selectedItemsDone,
      selectedItemsRefund,
      customer_name,
      customer_phone,
      suggestions,
      customerSuggestionField,
      eInvoiceInfoModalOpen,
      eInvoice_customer_name,
      eInvoice_customer_phone,
      eInvoice_customer_tax_id,
      eInvoice_customer_address,
      eInvoice_customer_email,
      isLoadingCustomer,
      orders,
      itemsChange,
      cashs,
      cashsPay,
      companyAddress,
      companyWebsite,
      companyLogo,
      companyName,
      billDate,
      pin_print,
      is_open_modal_discount_tax_fee,
      active_order_adjustment_modal,
      discount_form,
      tax_fee,
      fee_other,
      modalProvisionalInvoice,
      modalOrderHistory,
      modalFullOrders,
      modalOrderOpen,
      modalMobileOrderStatus,
      modalMobileReceiveOrder,
      btnDropup,
      isChecked,
      refund_to_customer,
      customer_debt,
      info_table,
      switchChecked: {
        switchCheckedBill,
        switchCheckedBillQr,
        switchCheckedBillBar,
        switchCheckedOrderOne,
        switchCheckedOrderTwo,
      },
      width,
      modalWizard,
      formUser,
    } = this.state;

    // console.log("orders: ", orders);
    // console.log("fee_other: ", fee_other);

    const isLaptop = width <= 1500;
    const businessType = (localStorage.getItem("businessType") || "")
      .toLowerCase()
      .trim();
    const isFnBBusiness =
      businessType === "cafe" || businessType === "restaurant";
    const hasCreatedOrders = Number(itemsOrderStatus?.order || 0) > 0;

    const hasTemplateData =
      (Array.isArray(menus) &&
        menus.some(
          (cat) =>
            Array.isArray(cat?.data) &&
            cat.data.some((p) => Boolean(p.isTemplate)),
        )) ||
      (Array.isArray(listsData) &&
        listsData.some((p) => Boolean(p?.isTemplate)));

    const hasMissingCompanyInfo =
      formUser?.companyName === "" ||
      formUser?.phone === "" ||
      formUser?.companyAddress === "" ||
      formUser?.email === "";

    const hasMissingPaymentInfo =
      formUser?.namePay === "" ||
      formUser?.bankPay === "" ||
      formUser?.numberPay === "";

    const shouldShowWarningRow =
      hasMissingCompanyInfo || hasMissingPaymentInfo || hasTemplateData;

    return (
      <Fragment>
        {/* Ẩn các chức năng quản lý cho cashier */}
        {!window.location.pathname.startsWith("/cashier") && (
          <>
            <Modal
              isOpen={modalWizard}
              onToggle={this.toggleModalWizard}
              className="table-modal cursor-pointer max-width-100"
            >
              <ModalHeader toggle={this.toggleModalWizard}>
                <IntlMessages id="home.wizard.title" />
              </ModalHeader>
              <ModalBody>
                <WizardBasic
                  onToggle={this.toggleModalWizard}
                  handleLoginStatus={this.handleLoginStatus}
                  onWizardComplete={() => {
                    // Refresh dashboard data after wizard completes
                    this.dataRenderUser();
                    this.dataListRender();
                  }}
                />
              </ModalBody>
            </Modal>
            <Row>
              <Colxx xxs="12">
                <CompaniesRequired />
              </Colxx>
            </Row>
            <Row
              className={
                shouldShowWarningRow ? "d-flex flex-wrap mb-4 px-2" : "d-none"
              }
            >
              {hasMissingCompanyInfo ? (
                <Colxx xxs="12" md="6" className="mb-3">
                  <Card className="h-100">
                    <CardBody className="p-3 text-muted font-italic">
                      <IntlMessages id="home.warning.update-info" />,{" "}
                      <a href="/app/applications/profile">
                        <IntlMessages id="home.warning.here" />
                      </a>
                    </CardBody>
                  </Card>
                </Colxx>
              ) : null}
              {hasMissingPaymentInfo ? (
                <Colxx xxs="12" md="6" className="mb-3">
                  <Card className="h-100">
                    <CardBody className="p-3 text-muted font-italic">
                      <IntlMessages id="home.warning.update-payment" />,{" "}
                      <a href="/app/applications/profile">
                        <IntlMessages id="home.warning.here" />
                      </a>
                    </CardBody>
                  </Card>
                </Colxx>
              ) : null}
              {hasTemplateData ? (
                <Colxx
                  xxs="12"
                  md={hasMissingCompanyInfo || hasMissingPaymentInfo ? 6 : 12}
                  className="mb-3"
                >
                  <TemplateWarningCard
                    onDismissed={() => {
                      this.setState({
                        showTemplate: false,
                        hasTemplateProducts: false,
                      });
                      this.dataRenderUser();
                    }}
                  />
                </Colxx>
              ) : null}
            </Row>
          </>
        )}
        <OrderAdjustmentModals
          activeType={active_order_adjustment_modal}
          isOpen={is_open_modal_discount_tax_fee}
          values_discount={discount_form}
          values_tax={tax_fee}
          values_fee={fee_other}
          promotions={this.state.manual_promotions || []}
          selectedPromotionsFromParent={this.state.selected_promotions}
          orders={orders}
          customerPhone={customer_phone}
          onToggle={this.handleToggleModalDiscountTaxFee}
          onSubmit={this.handleSubmitOrderAdjustment}
        />
        <Row>
          <Colxx
            sm="12"
            md="12"
            lg={isLaptop ? 7 : 8}
            xl={isLaptop ? 7 : 8}
            id="table-chair-remove-card"
          >
            <TableChairs
              menus={menus}
              is_loading_data={is_loading_data}
              renderCategories={this.renderCategories}
              onClickCategory={this.onClickCategory}
              listsData={listsData}
              activeIndex={activeIndex}
              items={itemsTable}
              infoTable={this.infoTable}
              isLoading={isLoadingItemsTable}
              selectedFloorTable={selectedFloorTable}
              onUpdateSelectedFloorTable={this.onUpdateSelectedFloorTable}
              orders={itemsRecentOrder}
              floorsActiveId={floorsActiveId}
              onActions={this.onActions}
              onToggleDetail={this.onToggleDetail}
              onClickImage={(product, plus, quantity) =>
                this.onClickImage(product, plus, quantity)
              }
              billDate={
                this.state.customOrderDate
                  ? moment(this.state.customOrderDate).format("DD/MM/YYYY")
                  : billDate
              }
              onOpenAddProductModal={this.toggleAddProductModal}
            />
          </Colxx>
          {orders.length ? (
            <div className="d-block d-md-none m-0-auto card-body-custom order-btn-preview order-btn-preview-sticky">
              <Button
                color="primary"
                size="lg"
                className="top-right-button px-2"
                onClick={this.toggleModalOrder}
                block
              >
                <Row>
                  <Colxx xxs="5" md="5" xl="5">
                    <IntlMessages id="general.btn-order-preview" />{" "}
                  </Colxx>
                  <Colxx xxs="3" md="3" xl="3" className="fw-100">
                    {this.calcNumberOrder(orders)}{" "}
                    <IntlMessages id="general.product-unit" />{" "}
                  </Colxx>
                  <Colxx xxs="4" md="4" xl="4">
                    {AddCommaNumber(this.calTotalPrice(orders))}
                    <sup className="fz-sup">đ</sup>
                  </Colxx>
                </Row>
              </Button>
            </div>
          ) : null}
          <ProductOrderModalMenu
            isOpen={modalOrderOpen}
            onToggleModal={this.toggleModalOrder}
            orders={orders}
            incrementItem={this.incrementItem}
            decrementItem={this.decrementItem}
            phone={customer_phone}
            name={customer_name}
            customer_debt={customer_debt}
            companyName={companyName}
            onChange={this.onChange}
            removeOrders={this.removeOrders}
            onRemoveOrder={this.onRemoveOrder}
            handleSubmit={(payment) => this.handleSubmit(payment)}
            calTotalPrice={this.calTotalPrice}
            refund_to_customer={refund_to_customer}
            paymentMethod={this.state.paymentMethod}
            onChangePaymentMethod={this.onChangePaymentMethod}
            shippingCarrier={this.state.shipping_provider}
            onChangeShippingCarrier={this.onChangeShippingCarrier}
            connected_providers={this.state.connected_providers}
            discount_form={discount_form}
            tax_fee={tax_fee}
            fee_other={fee_other}
            getTotalDiscountPrice={this.GetTotalDiscountPrice}
            getTotalTaxFeePrice={this.GetTotalTaxFeePrice}
            getTotalFeeOtherPrice={this.GetTotalFeeOtherPrice}
            handleToggleModalDiscountTaxFee={
              this.handleToggleModalDiscountTaxFee
            }
            handleSaveProvisional={() =>
              this.handleSubmit("provisionalInvoice")
            }
            info_table={info_table}
            shipping_fee={this.state.shipping_fee}
            staffList={this.state.staffList}
            selectedStaff={this.state.selectedStaff}
            onChangeStaff={this.onChangeStaff}
            isCashierAccount={this.state.isCashierAccount}
            eInvoiceEnabled={this.state.eInvoiceEnabled}
            issueEInvoice={this.state.issueEInvoice}
            onChangeIssueEInvoice={this.onChangeIssueEInvoice}
            onOpenEInvoiceInfoModal={this.toggleEInvoiceInfoModal}
            customOrderDate={this.state.customOrderDate}
            onChangeCustomOrderDate={this.handleChangeCustomOrderDate}
          />
          {orders.length ? (
            <Colxx
              className="d-none d-md-flex flex-column justify-content-between h-82vh position-sticky-custom"
              lg={isLaptop ? 5 : 4}
              xl={isLaptop ? 5 : 4}
            >
              <Card className="h-100 order-display" data-tut="reatour__1">
                <CardHeader className="text-center p-3 d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center flex-grow-1">
                    {!this.state.isCashierAccount ? (
                      <div className="mr-3 position-relative d-inline-block">
                        <DatePicker
                          selected={
                            this.state.customOrderDate
                              ? moment(this.state.customOrderDate)
                              : null
                          }
                          onChange={this.handleChangeCustomOrderDate}
                          dateFormat="DD/MM/YYYY"
                          maxDate={moment()}
                          isClearable={true}
                          customInput={<CustomDateInput />}
                          popperPlacement="bottom-start"
                          popperModifiers={{
                            preventOverflow: {
                              enabled: true,
                              escapeWithReference: false,
                              boundariesElement: "viewport",
                            },
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        className="mr-3 badge badge-outline-primary px-3 py-1"
                        style={{
                          minWidth: "165px",
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                          cursor: "default",
                        }}
                        title="Chỉ quản lý mới có quyền đổi ngày"
                      >
                        <i
                          className="simple-icon-clock mr-2"
                          style={{ fontSize: "14px" }}
                        />
                        <span
                          style={{ fontSize: "0.80rem", fontWeight: "bold" }}
                        >
                          {this.state.customOrderDate
                            ? moment(this.state.customOrderDate).format(
                                "DD/MM/YYYY",
                              )
                            : "Hôm nay"}
                        </span>
                      </div>
                    )}
                    <span
                      className="font-weight-bold"
                      style={{ fontSize: "0.95rem", color: "#303030" }}
                    >
                      {info_table
                        ? `BÀN ${info_table.item.identify}`
                        : "TẠI QUẦY"}
                    </span>
                  </div>
                  <div
                    className="border-dotted"
                    data-id="btn-save-provisional"
                    onClick={() => this.handleSubmit("provisionalInvoice")}
                  >
                    <IntlMessages id="home.btn.save-provisional" /> (F10)
                  </div>
                </CardHeader>
                <CardBody className="d-flex flex-column p-0 table-right scroll">
                  <PerfectScrollbar
                    options={{
                      suppressScrollX: true,
                      wheelPropagation: false,
                    }}
                    id="table-orders"
                  >
                    <ListOrders
                      orders={orders}
                      cashs={cashs}
                      cashsPay={cashsPay}
                      discount_form={discount_form}
                      customOrderDate={this.state.customOrderDate}
                      tax_fee={tax_fee}
                      fee_other={fee_other}
                      isChecked={isChecked}
                      refund_to_customer={refund_to_customer}
                      incrementItem={this.incrementItem}
                      decrementItem={this.decrementItem}
                      onChangeCount={this.onChangeCount}
                      cashFill={this.cashFill}
                      totalPay={this.totalPay}
                      decrementCount={this.decrementCount}
                      totalCustomerPay={this.totalCustomerPay}
                      isCustomPay={this.state.isCustomPay}
                      customCustomerPay={this.state.customCustomerPay}
                      customCustomerPayRaw={this.state.customCustomerPayRaw}
                      onChangeCustomerPay={this.onChangeCustomerPay}
                      removeOrders={this.removeOrders}
                      // onRemoveOrder={this.onRemoveOrder}
                      getDiscountOrderValue={this.GetDiscountOrderValue}
                      getDiscountOrderType={this.GetDiscountOrderType}
                      getDiscountOrderNote={this.GetDiscountOrderNote}
                      getTotalDiscountPrice={this.GetTotalDiscountPrice}
                      getTotalTaxFeePrice={this.GetTotalTaxFeePrice}
                      getTotalFeeOtherPrice={this.GetTotalFeeOtherPrice}
                      calTotalPrice={this.calTotalPrice}
                      handleToggleModalDiscountTaxFee={
                        this.handleToggleModalDiscountTaxFee
                      }
                      onHandlerDeleteOrderPending={
                        this.onHandlerDeleteOrderPending
                      }
                      onHandleChecked={this.onHandleChecked}
                      handleRemoveValueModal={this.handleRemoveValueModal}
                      paymentMethod={this.state.paymentMethod}
                      onChangePaymentMethod={this.onChangePaymentMethod}
                      shippingCarrier={this.state.shipping_provider}
                      onChangeShippingCarrier={this.onChangeShippingCarrier}
                      connected_providers={this.state.connected_providers}
                      staffList={this.state.staffList}
                      selectedStaff={this.state.selectedStaff}
                      onChangeStaff={this.onChangeStaff}
                      isCashierAccount={this.state.isCashierAccount}
                      shipping_fee={this.state.shipping_fee}
                      is_calculating_fee={this.state.is_calculating_fee}
                      eInvoiceEnabled={this.state.eInvoiceEnabled}
                      issueEInvoice={this.state.issueEInvoice}
                      onChangeIssueEInvoice={this.onChangeIssueEInvoice}
                      onOpenEInvoiceInfoModal={this.toggleEInvoiceInfoModal}
                      onUpgradeSize={this.handleUpgradeSize}
                      onAddTopping={this.handleAddTopping}
                      suggestionData={this.state.suggestionData}
                      onAddSuggestionProduct={(product) => {
                        // Look up full product from menu to get size/topping settings
                        let fullProduct = null;
                        for (const cat of this.state.menus) {
                          if (cat.data) {
                            fullProduct = cat.data.find(
                              (p) => p.id === product.id,
                            );
                            if (fullProduct) break;
                          }
                        }
                        this.onClickImage(fullProduct || product);
                      }}
                      // promotion_result={result}
                    />
                  </PerfectScrollbar>
                </CardBody>
                <FooterOrders
                  isOpen={this.state.btnDropup}
                  toggle={() => {
                    this.setState({
                      btnDropup: !this.state.btnDropup,
                    });
                  }}
                  customer_name={customer_name}
                  customer_phone={customer_phone}
                  suggestions={suggestions}
                  customerSuggestionField={customerSuggestionField}
                  isLoadingCustomer={isLoadingCustomer}
                  onChange={this.onChange}
                  handleSuggestionClick={this.handleSuggestionClick}
                  handleSubmit={(payment) => this.handleSubmit(payment)}
                  isSubmitting={this.state.isSubmitting}
                  btnDropup={btnDropup}
                  itemsPending={orders}
                  companyName={companyName}
                  companyAddress={companyAddress}
                  companyLogo={companyLogo}
                  companyWebsite={companyWebsite}
                  billDate={
                    this.state.customOrderDate
                      ? moment(this.state.customOrderDate).format("DD/MM/YYYY")
                      : billDate
                  }
                  pin_print={pin_print}
                  discount={discount_form.saved ? discount_form : null}
                  tax_fee={tax_fee.saved ? tax_fee : null}
                  fee_other={fee_other.saved ? fee_other : null}
                  info_table={info_table}
                  customer_address={this.state.receiver_address}
                  switchCheckedBill={switchCheckedBill}
                  switchCheckedBillBar={switchCheckedBillBar}
                  switchCheckedOrderOne={switchCheckedOrderOne}
                  refund_to_customer={refund_to_customer}
                  isChecked={isChecked}
                  customer_debt={customer_debt}
                  customer_debt_limit={this.state.customer_debt_limit}
                  // Shipping integration state
                  is_shipping={this.state.is_shipping}
                  shipping_provider={this.state.shipping_provider}
                  shipping_fee={this.state.shipping_fee}
                  receiver_address={this.state.receiver_address}
                  receiver_province={this.state.receiver_province}
                  receiver_district={this.state.receiver_district}
                  receiver_ward={this.state.receiver_ward}
                  connected_providers={this.state.connected_providers}
                  provinces={this.state.provinces}
                  districts={this.state.districts}
                  wards={this.state.wards}
                  is_calculating_fee={this.state.is_calculating_fee}
                  onChangeShipping={this.onChangeShipping}
                  onSelectShippingAddress={this.onSelectShippingAddress}
                  toggleShippingModal={this.toggleShippingModal}
                  save_provisional_when_print={
                    this.state.save_provisional_when_print
                  }
                  print_customer_provisional={
                    this.state.print_customer_provisional
                  }
                  print_customer_invoice={this.state.print_customer_invoice}
                  eInvoiceEnabled={this.state.eInvoiceEnabled}
                  issueEInvoice={this.state.issueEInvoice}
                  onChangeIssueEInvoice={this.onChangeIssueEInvoice}
                  onOpenEInvoiceInfoModal={this.toggleEInvoiceInfoModal}
                  customOrderDate={this.state.customOrderDate}
                  paymentMethod={this.state.paymentMethod}
                  onChangePaymentMethod={this.onChangePaymentMethod}
                  staffList={this.state.staffList}
                  selectedStaff={this.state.selectedStaff}
                  onChangeStaff={this.onChangeStaff}
                  isCashierAccount={this.state.isCashierAccount}
                  shippingCarrier={this.state.shipping_provider}
                  onChangeShippingCarrier={this.onChangeShippingCarrier}
                />
              </Card>
            </Colxx>
          ) : itemsChange.length ? (
            <Colxx
              className="d-none d-md-flex flex-column justify-content-between h-82vh position-sticky-custom"
              lg={isLaptop ? 5 : 4}
              xl={isLaptop ? 5 : 4}
            >
              <Card className="h-100 order-display" data-tut="reatour__1">
                <CardHeader className="text-center p-3">
                  {info_table ? `BÀN ${info_table.item.identify} - ` : ""}
                  <IntlMessages id="home.table.title-adjust" />
                </CardHeader>
                <CardBody className="d-flex flex-column p-0 table-right scroll">
                  <PerfectScrollbar
                    options={{
                      suppressScrollX: true,
                      wheelPropagation: false,
                    }}
                    id="table-orders"
                  >
                    <ListOrders
                      orders={itemsChange}
                      cashs={cashs}
                      cashsPay={cashsPay}
                      discount_form={discount_form}
                      tax_fee={tax_fee}
                      fee_other={fee_other}
                      isChecked={isChecked}
                      refund_to_customer={refund_to_customer}
                      itemsChange={itemsChange}
                      incrementItem={this.incrementItem}
                      decrementItem={this.decrementItem}
                      onChangeCount={this.onChangeCount}
                      cashFill={this.cashFill}
                      totalPay={this.totalPay}
                      decrementCount={this.decrementCount}
                      totalCustomerPay={this.totalCustomerPay}
                      isCustomPay={this.state.isCustomPay}
                      customCustomerPay={this.state.customCustomerPay}
                      customCustomerPayRaw={this.state.customCustomerPayRaw}
                      onChangeCustomerPay={this.onChangeCustomerPay}
                      removeOrders={this.removeOrders}
                      onRemoveOrder={this.onRemoveOrder}
                      getDiscountOrderValue={this.GetDiscountOrderValue}
                      getDiscountOrderType={this.GetDiscountOrderType}
                      getDiscountOrderNote={this.GetDiscountOrderNote}
                      getTotalDiscountPrice={this.GetTotalDiscountPrice}
                      getTotalTaxFeePrice={this.GetTotalTaxFeePrice}
                      getTotalFeeOtherPrice={this.GetTotalFeeOtherPrice}
                      calTotalPrice={this.calTotalPrice}
                      handleToggleModalDiscountTaxFee={
                        this.handleToggleModalDiscountTaxFee
                      }
                      onHandlerDeleteOrderPending={
                        this.onHandlerDeleteOrderPending
                      }
                      paymentMethod={this.state.paymentMethod}
                      onChangePaymentMethod={this.onChangePaymentMethod}
                      shippingCarrier={this.state.shipping_provider}
                      onChangeShippingCarrier={this.onChangeShippingCarrier}
                      connected_providers={this.state.connected_providers}
                      staffList={this.state.staffList}
                      selectedStaff={this.state.selectedStaff}
                      onChangeStaff={this.onChangeStaff}
                      isCashierAccount={this.state.isCashierAccount}
                      onHandleChecked={this.onHandleChecked}
                      handleRemoveValueModal={this.handleRemoveValueModal}
                      eInvoiceEnabled={this.state.eInvoiceEnabled}
                      issueEInvoice={this.state.issueEInvoice}
                      onChangeIssueEInvoice={this.onChangeIssueEInvoice}
                      onOpenEInvoiceInfoModal={this.toggleEInvoiceInfoModal}
                      // promotion_result={result}
                    />
                  </PerfectScrollbar>
                </CardBody>
                <FooterOrders
                  isOpen={this.state.btnDropup}
                  toggle={() => {
                    this.setState({
                      btnDropup: !this.state.btnDropup,
                    });
                  }}
                  customer_name={customer_name}
                  customer_phone={customer_phone}
                  suggestions={suggestions}
                  customerSuggestionField={customerSuggestionField}
                  isLoadingCustomer={isLoadingCustomer}
                  onChange={this.onChange}
                  handleSuggestionClick={this.handleSuggestionClick}
                  handleSubmit={(payment) => this.handleSubmit(payment)}
                  isSubmitting={this.state.isSubmitting}
                  handleSubmitChange={this.handleSubmitChange}
                  removeOrders={this.removeOrders}
                  btnDropup={btnDropup}
                  itemsPending={itemsChange}
                  companyName={companyName}
                  companyAddress={companyAddress}
                  companyLogo={companyLogo}
                  companyWebsite={companyWebsite}
                  billDate={
                    this.state.customOrderDate
                      ? moment(this.state.customOrderDate).format("DD/MM/YYYY")
                      : billDate
                  }
                  pin_print={pin_print}
                  discount={discount_form.saved ? discount_form : null}
                  tax_fee={tax_fee.saved ? tax_fee : null}
                  fee_other={fee_other.saved ? fee_other : null}
                  info_table={info_table}
                  customer_address={this.state.receiver_address}
                  switchCheckedBill={switchCheckedBill}
                  switchCheckedBillBar={switchCheckedBillBar}
                  switchCheckedOrderOne={switchCheckedOrderOne}
                  refund_to_customer={refund_to_customer}
                  isChecked={isChecked}
                  customer_debt={customer_debt}
                  customer_debt_limit={this.state.customer_debt_limit}
                  // Shipping integration state
                  is_shipping={this.state.is_shipping}
                  shipping_provider={this.state.shipping_provider}
                  shipping_fee={this.state.shipping_fee}
                  receiver_address={this.state.receiver_address}
                  receiver_province={this.state.receiver_province}
                  receiver_district={this.state.receiver_district}
                  receiver_ward={this.state.receiver_ward}
                  connected_providers={this.state.connected_providers}
                  provinces={this.state.provinces}
                  districts={this.state.districts}
                  wards={this.state.wards}
                  is_calculating_fee={this.state.is_calculating_fee}
                  onChangeShipping={this.onChangeShipping}
                  onSelectShippingAddress={this.onSelectShippingAddress}
                  itemsChange={itemsChange}
                  paymentMethod={this.state.paymentMethod}
                  onChangePaymentMethod={this.onChangePaymentMethod}
                  toggleShippingModal={this.toggleShippingModal}
                  save_provisional_when_print={
                    this.state.save_provisional_when_print
                  }
                  print_customer_provisional={
                    this.state.print_customer_provisional
                  }
                  print_customer_invoice={this.state.print_customer_invoice}
                  eInvoiceEnabled={this.state.eInvoiceEnabled}
                  issueEInvoice={this.state.issueEInvoice}
                  onChangeIssueEInvoice={this.onChangeIssueEInvoice}
                  onOpenEInvoiceInfoModal={this.toggleEInvoiceInfoModal}
                  customOrderDate={this.state.customOrderDate}
                  staffList={this.state.staffList}
                  selectedStaff={this.state.selectedStaff}
                  onChangeStaff={this.onChangeStaff}
                  isCashierAccount={this.state.isCashierAccount}
                  shippingCarrier={this.state.shipping_provider}
                  onChangeShippingCarrier={this.onChangeShippingCarrier}
                />
              </Card>
            </Colxx>
          ) : (
            <Colxx
              sm="12"
              md="12"
              lg={isLaptop ? 5 : 4}
              xl={isLaptop ? 5 : 4}
              className="d-none d-md-flex flex-column mb-4 dashboard-right position-sticky-custom h-82vh"
            >
              <ListOrderStatus
                itemsOrderStatus={itemsOrderStatus}
                itemsPending={itemsPending}
                itemsPendingBill={itemsPendingBill}
                itemsDone={itemsDone}
                onCheckItemPending={(e, id) => this.onCheckItemPending(e, id)}
                onCheckItemRefund={this.onCheckItemRefund}
                onCheckItemDone={this.onCheckItemDone}
                onCheckMultiplePending={this.onCheckMultiplePending}
                onCheckMultipleRefund={this.onCheckMultipleRefund}
                onCheckMultipleDone={this.onCheckMultipleDone}
                onActions={this.onActions}
                selectedItemsPending={selectedItemsPending}
                selectedItemsRefund={selectedItemsRefund}
                selectedItemsDone={selectedItemsDone}
                companyName={companyName}
                companyAddress={companyAddress}
                companyLogo={companyLogo}
                companyWebsite={companyWebsite}
                // billDate={billDate}
                handleClickedPrintInvoice={this.handleClickedPrintInvoice}
                switchCheckedBillQr={switchCheckedBillQr}
                itemsTable={itemsTable}
                switchCheckedOrderTwo={switchCheckedOrderTwo}
                pin_print={pin_print}
              />
              <Row className="mt-auto">
                <Colxx xs="7" md="7" xl="7">
                  <Card className="text-center text-one mt-auto">
                    <CardBody
                      className="p75 cursor-pointer d-flex align-items-center justify-content-center"
                      onClick={this.toggleModalProvisionalInvoice}
                      style={{ gap: "8px" }}
                    >
                      <IntlMessages id="home.btn.provisional-invoice" />
                      {dataProvisionalInvoice?.length > 0 && (
                        <Badge
                          color="danger"
                          pill
                          title={`${dataProvisionalInvoice.length} hóa đơn lưu tạm`}
                        >
                          {dataProvisionalInvoice.length}
                        </Badge>
                      )}
                    </CardBody>
                    <ProvisionalInvoice
                      isOpen={modalProvisionalInvoice}
                      toggle={this.toggleModalProvisionalInvoice}
                      dataProvisionalInvoice={dataProvisionalInvoice}
                      reOrders={(invoice) => this.reOrders(invoice)}
                      onCancelProvisionalInvoice={(invoice) =>
                        this.onCancelProvisionalInvoice(invoice)
                      }
                      onQuickPayProvisional={this.onQuickPayProvisional}
                      switchCheckedBill={
                        this.state.switchChecked.switchCheckedBill
                      }
                      print_customer_invoice={this.state.print_customer_invoice}
                      companyName={this.state.companyName}
                      companyAddress={this.state.companyAddress}
                      companyLogo={this.state.companyLogo}
                      companyWebsite={this.state.companyWebsite}
                    />
                  </Card>
                </Colxx>
                <Colxx xs="5" md="5" xl="5">
                  <Card>
                    <CardBody
                      className="p75 cursor-pointer text-center text-one"
                      onClick={this.toggleModalOrderHistory}
                    >
                      <IntlMessages id="home.btn.return-order" />
                    </CardBody>
                    <OrderHistoryModal
                      isOpen={modalOrderHistory}
                      toggle={this.toggleModalOrderHistory}
                    />
                  </Card>
                </Colxx>
              </Row>
              <Card className="text-center text-one mt-3">
                <CardBody
                  className="p-3 cursor-pointer"
                  onClick={this.toggleModalFullOrders}
                >
                  <IntlMessages id="dashboards.status-order" />
                </CardBody>
                <FullModalAllOrders
                  isOpen={modalFullOrders}
                  toggle={this.toggleModalFullOrders}
                  itemsRecentOrder={itemsRecentOrder}
                  itemsDone={itemsDone}
                  itemsRefund={itemsRefund}
                  isHight={true}
                />
              </Card>
            </Colxx>
          )}
        </Row>

        {/* Floating Barcode Button - Only visible on mobile */}
        {!isFnBBusiness && (
          <div
            className={`floating-barcode-btn d-block d-md-none ${
              orders.length ? "has-order-btn" : ""
            }`}
            onClick={this.handleOpenScanner}
            title="Quét mã Barcode/QR"
          >
            <img
              src="/assets/img/barcode.png"
              alt="Quét Barcode"
              className="floating-barcode-img"
            />
          </div>
        )}
        {/* FAB backdrop — closes menu on outside tap */}
        {this.state.fabMenuOpen && (
          <div
            className="d-block d-md-none"
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 998,
            }}
            onClick={() => this.setState({ fabMenuOpen: false })}
          />
        )}
        {/* FAB Action Menu - Mobile Only (left side) */}
        <div
          className={`fab-action-menu d-block d-md-none${
            orders.length ? " has-order-btn" : ""
          }`}
        >
          {/* Popup items — rendered above trigger */}
          <div
            className={`fab-items${this.state.fabMenuOpen ? " is-open" : ""}`}
          >
            {/* Nhận đơn */}
            <div
              className="fab-item"
              onClick={() => {
                this.setState({ fabMenuOpen: false });
                this.toggleModalMobileReceiveOrder();
              }}
            >
              <span className="fab-item-icon" style={{ background: "#0b74de" }}>
                <i className="simple-icon-basket" />
              </span>
              <span className="fab-item-label">Nhận đơn</span>
            </div>

            {/* Trạng thái đơn hàng */}
            <div
              className="fab-item"
              onClick={() => {
                this.setState({ fabMenuOpen: false });
                this.toggleModalMobileOrderStatus();
              }}
            >
              <span className="fab-item-icon" style={{ background: "#1b8f4b" }}>
                <i className="simple-icon-layers" />
              </span>
              <span className="fab-item-label">Trạng thái đơn</span>
            </div>

            {/* Hóa đơn tạm tính */}
            <div
              className="fab-item"
              onClick={() => {
                this.setState({ fabMenuOpen: false });
                this.toggleModalProvisionalInvoice();
              }}
            >
              <span className="fab-item-icon" style={{ background: "#145388" }}>
                <i className="simple-icon-doc" />
              </span>
              <span className="fab-item-label">Hóa đơn tạm tính</span>
            </div>

            {/* Trả hàng */}
            <div
              className="fab-item"
              onClick={() => {
                this.setState({ fabMenuOpen: false });
                this.toggleModalOrderHistory();
              }}
            >
              <span className="fab-item-icon" style={{ background: "#d44e00" }}>
                <i className="simple-icon-action-undo" />
              </span>
              <span className="fab-item-label">Trả hàng</span>
            </div>
          </div>

          {/* Trigger */}
          <button
            className={`fab-trigger${this.state.fabMenuOpen ? " is-open" : ""}${
              hasCreatedOrders && !this.state.fabMenuOpen ? " bg-primary" : ""
            }`}
            onClick={() =>
              this.setState((prev) => ({ fabMenuOpen: !prev.fabMenuOpen }))
            }
            title="Công cụ nhanh"
          >
            {this.state.fabMenuOpen ? (
              "+"
            ) : (
              <i
                className={`simple-icon-layers${
                  hasCreatedOrders ? " text-white" : " text-primary"
                }`}
              />
            )}
          </button>
        </div>

        <Modal
          isOpen={modalMobileOrderStatus}
          toggle={this.toggleModalMobileOrderStatus}
          size="lg"
          className="d-block d-md-none"
        >
          <ModalHeader toggle={this.toggleModalMobileOrderStatus}>
            <IntlMessages id="dashboards.status-order" />
          </ModalHeader>
          <ModalBody className="p-2">
            <ListOrderStatus
              itemsOrderStatus={itemsOrderStatus}
              itemsPending={itemsPending}
              itemsPendingBill={itemsPendingBill}
              itemsDone={itemsDone}
              onCheckItemPending={(e, id) => this.onCheckItemPending(e, id)}
              onCheckItemRefund={this.onCheckItemRefund}
              onCheckItemDone={this.onCheckItemDone}
              onCheckMultiplePending={this.onCheckMultiplePending}
              onCheckMultipleRefund={this.onCheckMultipleRefund}
              onCheckMultipleDone={this.onCheckMultipleDone}
              onActions={this.onActions}
              selectedItemsPending={selectedItemsPending}
              selectedItemsRefund={selectedItemsRefund}
              selectedItemsDone={selectedItemsDone}
              companyName={companyName}
              companyAddress={companyAddress}
              companyLogo={companyLogo}
              companyWebsite={companyWebsite}
              handleClickedPrintInvoice={this.handleClickedPrintInvoice}
              switchCheckedBillQr={switchCheckedBillQr}
              itemsTable={itemsTable}
              switchCheckedOrderTwo={switchCheckedOrderTwo}
              pin_print={pin_print}
              isMobileStatusView={true}
            />
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modalMobileReceiveOrder}
          toggle={this.toggleModalMobileReceiveOrder}
          size="lg"
          className="d-block d-md-none"
        >
          <ModalHeader toggle={this.toggleModalMobileReceiveOrder}>
            Nhận đơn
          </ModalHeader>
          <ModalBody className="p-2">
            <ListPendingOrdersStatus
              onActions={this.onActions}
              selectedItems={selectedItemsPending}
              onCheckItem={(e, id) => this.onCheckItemPending(e, id)}
              onCheckMultiple={this.onCheckMultiplePending}
              isMobile={true}
              orders={itemsPending?.filter(
                (o) => o.status.uuid === STATUS.CREATED,
              )}
              alias={111}
              emptyText={<IntlMessages id="dashboards.product-received-full" />}
              companyName={companyName}
              companyAddress={companyAddress}
              companyLogo={companyLogo}
              companyWebsite={companyWebsite}
              pin_print={pin_print}
              handleClickedPrintInvoice={this.handleClickedPrintInvoice}
              switchCheckedBillQr={switchCheckedBillQr}
              switchCheckedOrderTwo={switchCheckedOrderTwo}
              itemsTable={itemsTable}
            />
          </ModalBody>
        </Modal>

        {/* Auto print online order (customer + kitchen/bar) */}
        <div style={{ display: "none", overflow: "hidden", height: 0 }}>
          {!isElectron ? (
            <>
              <ReactToPrint
                trigger={() => (
                  <button ref={this.autoPrintCustomerTriggerRef}>
                    auto-print-customer
                  </button>
                )}
                content={() => this.autoPrintCustomerRef.current}
                pageStyle={buildPrintPageStyle(
                  getStoredPrintPaperWidthMm("customer"),
                )}
                onBeforeGetContent={this.prepareAutoPrintCustomerInvoice}
                onAfterPrint={this.handleBrowserPrintClosed}
              />
              <ReactToPrint
                trigger={() => (
                  <button ref={this.autoPrintKitchenTriggerRef}>
                    auto-print-kitchen
                  </button>
                )}
                content={() => this.autoPrintKitchenRef.current}
                pageStyle={buildPrintPageStyle(
                  getStoredPrintPaperWidthMm("kitchen"),
                )}
                onAfterPrint={this.handleBrowserPrintClosed}
              />
            </>
          ) : null}

          <div ref={this.autoPrintCustomerRef}>
            <ComponentToPrintNow
              ref={this.autoPrintCustomerComponentRef}
              items={this.state.autoPrintOnlineItems}
              companyName={companyName}
              companyAddress={companyAddress}
              companyLogo={companyLogo}
              companyWebsite={companyWebsite}
              billDate={this.state.autoPrintOnlineBillDate}
              pin_print={this.state.autoPrintOnlinePinPrint}
              discount={null}
              tax_fee={null}
              fee_other={null}
              timeStart={this.state.autoPrintOnlineTimeStart}
              customer_name={this.state.autoPrintOnlineCustomerName}
              customer_phone={this.state.autoPrintOnlineCustomerPhone}
              customer_address={this.state.autoPrintOnlineCustomerAddress}
              delivery_time={this.state.autoPrintOnlineDeliveryTime}
              table_name={this.state.autoPrintOnlineTableName}
              print_customer={this.state.print_customer_invoice}
              show_order_context
              show_variant_badges
            />
          </div>

          <div ref={this.autoPrintKitchenRef}>
            <ComponentToPrintForKitchen
              items={this.state.autoPrintOnlineItems}
              billDate={this.state.autoPrintOnlineBillDate}
              pin_print={this.state.autoPrintOnlinePinPrint}
              show_variant_badges
            />
          </div>
        </div>

        <Modal
          isOpen={this.state.browserPrintConfirmOpen}
          backdrop="static"
          keyboard={false}
        >
          <ModalHeader>Xác nhận in đơn online</ModalHeader>
          <ModalBody>
            Bạn đã in thành công{" "}
            <strong>
              {this.state.browserPrintDocumentType === "customer"
                ? "hóa đơn khách"
                : "phiếu bếp/bar"}
            </strong>{" "}
            chưa?
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.retryBrowserPrint}>
              In lại
            </Button>
            <Button
              color="warning"
              onClick={() => this.finishBrowserPrintDecision(false)}
            >
              Để sau
            </Button>
            <Button
              color="primary"
              onClick={() => this.finishBrowserPrintDecision(true)}
            >
              Đã in
            </Button>
          </ModalFooter>
        </Modal>

        {/* EInvoiceInfoModal */}
        <Modal
          isOpen={this.state.eInvoiceInfoModalOpen}
          toggle={this.toggleEInvoiceInfoModal}
        >
          <ModalHeader toggle={this.toggleEInvoiceInfoModal}>
            Thông tin xuất hóa đơn điện tử (VAT)
          </ModalHeader>
          <ModalBody>
            <FormGroup className="d-flex flex-column">
              <Label for="eInvoice_invoice_date">Ngày xuất hóa đơn</Label>
              <Input
                type="text"
                id="eInvoice_invoice_date"
                value={`${moment().format("DD/MM/YYYY")} (Hôm nay)`}
                disabled
                readOnly
                className="form-control bg-light"
              />
              <small className="form-text text-muted mt-1">
                <i className="simple-icon-info mr-1" />
                Theo quy định Luật thuế (NĐ 123/2020/NĐ-CP), HĐĐT bắt buộc phát
                hành theo ngày hiện tại.
              </small>
            </FormGroup>
            <FormGroup>
              <Label for="eInvoice_customer_name">Tên đơn vị / Người mua</Label>
              <Input
                type="text"
                id="eInvoice_customer_name"
                value={this.state.eInvoice_customer_name}
                onChange={(e) =>
                  this.setState({ eInvoice_customer_name: e.target.value })
                }
                placeholder="Tên công ty hoặc họ tên người mua"
              />
            </FormGroup>
            <FormGroup>
              <Label for="eInvoice_customer_phone">
                Số điện thoại nhận hóa đơn
              </Label>
              <Input
                type="text"
                id="eInvoice_customer_phone"
                value={this.state.eInvoice_customer_phone}
                onChange={(e) =>
                  this.setState({ eInvoice_customer_phone: e.target.value })
                }
                placeholder="Số điện thoại nhận hóa đơn (nếu có)"
              />
            </FormGroup>
            <FormGroup>
              <Label for="eInvoice_customer_tax_id">Mã số thuế</Label>
              <Input
                type="text"
                id="eInvoice_customer_tax_id"
                value={this.state.eInvoice_customer_tax_id}
                onChange={(e) =>
                  this.setState({ eInvoice_customer_tax_id: e.target.value })
                }
                placeholder="Mã số thuế doanh nghiệp"
              />
            </FormGroup>
            <FormGroup>
              <Label for="eInvoice_customer_address">Địa chỉ</Label>
              <Input
                type="textarea"
                rows={2}
                id="eInvoice_customer_address"
                value={this.state.eInvoice_customer_address}
                onChange={(e) =>
                  this.setState({ eInvoice_customer_address: e.target.value })
                }
                placeholder="Địa chỉ đăng ký kinh doanh"
              />
            </FormGroup>
            <FormGroup>
              <Label for="eInvoice_customer_email">Email nhận hóa đơn</Label>
              <Input
                type="email"
                id="eInvoice_customer_email"
                value={this.state.eInvoice_customer_email}
                onChange={(e) =>
                  this.setState({ eInvoice_customer_email: e.target.value })
                }
                placeholder="email@company.com"
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleEInvoiceInfoModal}>
              Hủy
            </Button>
            <Button color="primary" onClick={this.toggleEInvoiceInfoModal}>
              Lưu thông tin
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Cảnh báo xuất HĐĐT cho đơn hàng lùi ngày */}
        <Modal
          isOpen={this.state.eInvoiceBackdateWarningModalOpen}
          toggle={this.cancelIssueEInvoiceBackdate}
          backdrop="static"
        >
          <ModalHeader toggle={this.cancelIssueEInvoiceBackdate}>
            <i className="simple-icon-exclamation text-warning mr-2" />
            Lưu ý xuất Hóa đơn điện tử (VAT)
          </ModalHeader>
          <ModalBody>
            <div className="alert alert-warning mb-3">
              <strong>Quy định Luật thuế (Nghị định 123/2020/NĐ-CP):</strong>
              <div className="mt-1">
                Hóa đơn điện tử bắt buộc phải có ngày lập liên tục và không được
                phép phát hành lùi ngày.
              </div>
            </div>
            <p className="mb-2">
              Đơn hàng này đang chọn ngày bán hàng là:{" "}
              <strong className="text-danger">
                {this.state.customOrderDate
                  ? moment(this.state.customOrderDate).format("DD/MM/YYYY")
                  : ""}
              </strong>
              .
            </p>
            <p className="mb-3">
              Nếu bạn chọn xuất Hóa đơn điện tử, hóa đơn sẽ được phát hành với{" "}
              <strong>NGÀY HIỆN TẠI ({moment().format("DD/MM/YYYY")})</strong>{" "}
              chứ không thể xuất theo ngày lùi của đơn hàng.
            </p>
            <p className="mb-0 font-weight-bold text-primary">
              Bạn có muốn tiếp tục xuất Hóa đơn điện tử theo ngày hôm nay (
              {moment().format("DD/MM/YYYY")}) không?
            </p>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={this.cancelIssueEInvoiceBackdate}
            >
              Hủy xuất HĐĐT
            </Button>
            <Button color="primary" onClick={this.confirmIssueEInvoiceBackdate}>
              Đồng ý xuất theo ngày hôm nay
            </Button>
          </ModalFooter>
        </Modal>

        {!isFnBBusiness && (
          <BarcodeScanner
            isOpen={this.state.isScannerOpen}
            onClose={this.handleCloseScanner}
            onScan={this.handleBarcodeScan}
          />
        )}

        {/* Alert Sounds for Guest Calls */}
        <audio
          id="call-service-alert-sound"
          preload="auto"
          src="/assets/sound/alert.mp3"
        ></audio>
        <audio
          id="call-bell-alert-sound"
          preload="auto"
          src="/assets/sound/alert.mp3"
        ></audio>

        {/* Floating Keyboard Shortcuts Help Button */}
        <div
          className="floating-keyboard-btn d-none d-md-flex"
          onClick={() => this.setState({ modalKeyboardShortcuts: true })}
          title="Phím tắt (Keyboard Shortcuts)"
          style={{
            position: "fixed",
            bottom: "25px",
            right: "10px",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            backgroundColor: "#fff",
            boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.2)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.15)";
          }}
        >
          <i
            className="iconsminds-keyboard"
            style={{ fontSize: "18px", color: "#145388" }}
          />
        </div>

        {/* Keyboard Shortcuts Modal */}
        <KeyboardShortcutsModal
          isOpen={this.state.modalKeyboardShortcuts}
          toggle={() =>
            this.setState({
              modalKeyboardShortcuts: !this.state.modalKeyboardShortcuts,
            })
          }
        />

        <ShippingAddressModal
          isOpen={this.state.isShippingModalOpen}
          toggle={this.toggleShippingModal}
          shipping_provider={this.state.shipping_provider}
          receiver_address={this.state.receiver_address}
          receiver_province={this.state.receiver_province}
          receiver_district={this.state.receiver_district}
          receiver_ward={this.state.receiver_ward}
          provinces={this.state.provinces}
          districts={this.state.districts}
          wards={this.state.wards}
          shipping_fee={this.state.shipping_fee}
          is_calculating_fee={this.state.is_calculating_fee}
          onSelectShippingAddress={this.onSelectShippingAddress}
          onChangeShipping={this.onChangeShipping}
          handleCalculateFee={this.handleCalculateFee}
          connected_providers={this.state.connected_providers}
          shipping_receiver_name={this.state.shipping_receiver_name}
          shipping_receiver_phone={this.state.shipping_receiver_phone}
          shipping_cod={this.state.shipping_cod}
          shipping_cod_amount={this.state.shipping_cod_amount}
          shipping_free={this.state.shipping_free}
          shipping_weight={this.state.shipping_weight}
          shipping_length={this.state.shipping_length}
          shipping_width={this.state.shipping_width}
          shipping_height={this.state.shipping_height}
          shipping_note={this.state.shipping_note}
          shipping_required_note={this.state.shipping_required_note}
        />

        <Suspense fallback={null}>
          {this.state.isAddProductModalOpen && (
            <AddProductModalWrapper
              isOpen={this.state.isAddProductModalOpen}
              toggle={this.toggleAddProductModal}
              onSuccess={() => this.dataListRender()}
            />
          )}
        </Suspense>

        {/* Modal Cảnh báo Vượt Hạn Mức Công Nợ */}
        <Modal
          isOpen={this.state.debtWarningModalOpen}
          toggle={this.toggleDebtWarningModal}
          backdrop="static"
          centered
        >
          <ModalHeader
            toggle={this.toggleDebtWarningModal}
            className="text-danger font-weight-bold"
          >
            <i className="simple-icon-exclamation mr-2" />
            Cảnh báo: Vượt hạn mức công nợ
          </ModalHeader>
          <ModalBody>
            <p className="mb-2">
              Khách hàng{" "}
              <strong>{this.state.customer_name || "Khách lẻ"}</strong>
              {this.state.customer_phone
                ? ` (${this.state.customer_phone})`
                : ""}{" "}
              có thông tin nợ như sau:
            </p>
            <div
              className="p-3 mb-3 bg-light rounded"
              style={{ fontSize: "13px" }}
            >
              <div className="d-flex justify-content-between mb-1">
                <span className="text-muted">Hạn mức nợ tối đa:</span>
                <strong className="text-primary">
                  {AddCommaNumber(this.state.customer_debt_limit || 0)} đ
                </strong>
              </div>
              <div className="d-flex justify-content-between mb-1">
                <span className="text-muted">Nợ cũ hiện tại:</span>
                <span>{AddCommaNumber(this.state.customer_debt || 0)} đ</span>
              </div>
              <div className="d-flex justify-content-between mb-1">
                <span className="text-muted">Nợ đơn hàng này:</span>
                <span className="text-danger font-weight-bold">
                  {AddCommaNumber(
                    this.state.isChecked ||
                      this.state.paymentMethod === "credit"
                      ? this.calTotalPrice(this.state.orders)
                      : this.state.refund_to_customer || 0,
                  )}{" "}
                  đ
                </span>
              </div>
              <div className="d-flex justify-content-between pt-2 border-top">
                <span className="text-muted font-weight-bold">
                  Tổng nợ sau đơn:
                </span>
                <strong className="text-danger" style={{ fontSize: "15px" }}>
                  {AddCommaNumber(
                    (parseFloat(this.state.customer_debt) || 0) +
                      (this.state.isChecked ||
                      this.state.paymentMethod === "credit"
                        ? this.calTotalPrice(this.state.orders)
                        : this.state.refund_to_customer || 0),
                  )}{" "}
                  đ
                </strong>
              </div>
            </div>
            <div
              className="alert alert-danger mb-0"
              style={{ fontSize: "12px", lineHeight: "1.5" }}
            >
              <i className="simple-icon-info mr-1" />
              Tổng nợ vượt quá hạn mức cho phép{" "}
              <strong>
                {AddCommaNumber(
                  Math.max(
                    0,
                    (parseFloat(this.state.customer_debt) || 0) +
                      (this.state.isChecked ||
                      this.state.paymentMethod === "credit"
                        ? this.calTotalPrice(this.state.orders)
                        : this.state.refund_to_customer || 0) -
                      (parseFloat(this.state.customer_debt_limit) || 0),
                  ),
                )}{" "}
                đ
              </strong>
              . Bạn có xác nhận cho phép khách hàng này tiếp tục ghi nợ không?
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleDebtWarningModal}>
              Hủy bỏ
            </Button>
            <Button color="danger" onClick={this.handleConfirmDebtOverLimit}>
              Xác nhận tiếp tục ghi nợ
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Cảnh báo Ghi nợ toàn bộ khi đang có tiền khách đưa */}
        <Modal
          isOpen={this.state.creditFullOrderWarningModalOpen}
          toggle={this.cancelSwitchToCredit}
          backdrop="static"
          // centered
        >
          <ModalHeader
            toggle={this.cancelSwitchToCredit}
            className="text-warning font-weight-bold"
          >
            <i className="simple-icon-exclamation mr-2" />
            Lưu ý: Ghi nhận công nợ toàn bộ đơn hàng
          </ModalHeader>
          <ModalBody>
            <div
              className="alert alert-warning mb-3"
              style={{ fontSize: "13px", lineHeight: "1.5" }}
            >
              <i className="simple-icon-info mr-1" />
              Đơn hàng hiện tại đang có tiền khách đưa là{" "}
              <strong>
                {AddCommaNumber(this.totalCustomerPay(this.state.cashsPay))} đ
              </strong>
              .
            </div>
            <p className="mb-2" style={{ fontSize: "13px" }}>
              Khi chọn hình thức thanh toán <strong>Ghi nợ</strong>, hệ thống sẽ
              ghi nhận công nợ là{" "}
              <strong>
                TOÀN BỘ ĐƠN HÀNG ({AddCommaNumber(this.getFinalOrderTotal())} đ)
              </strong>{" "}
              và số tiền khách đưa trước đó sẽ được xóa về 0 đ.
            </p>
            <div
              className="p-2 mb-3 bg-light rounded text-muted"
              style={{ fontSize: "12px", borderLeft: "3px solid #17a2b8" }}
            >
              💡{" "}
              <em>
                Nếu khách hàng chỉ nợ phần còn lại, vui lòng giữ hình thức thanh
                toán <strong>Tiền mặt</strong>. Hệ thống sẽ tự động ghi nhận số
                tiền còn thiếu vào công nợ của khách hàng.
              </em>
            </div>
            <p
              className="mb-0 font-weight-bold text-primary"
              style={{ fontSize: "13px" }}
            >
              Bạn có chắc chắn muốn chuyển sang ghi nợ toàn bộ đơn hàng không?
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.cancelSwitchToCredit}>
              Hủy bỏ (Giữ Tiền mặt)
            </Button>
            <Button color="warning" onClick={this.confirmSwitchToCredit}>
              Xác nhận ghi nợ toàn bộ
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

// Lấy state từ Redux store và map vào props của component
const mapStateToProps = ({ searchInput }) => {
  const { keyword } = searchInput;
  return { searchKeyword: keyword }; // Map state.search.keyword vào props.searchKeyword
};

// ĐỊNH NGHĨA mapDispatchToProps
// Cung cấp action `updateSearchKeyword` cho component
const mapDispatchToProps = {
  updateSearchKeyword,
  submitSearchByEnter,
  setSearchContext,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(DefaultDashboard),
);
